import { Component, HostListener, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Beneficiary } from 'src/app/models/beneficiary';
import { AdminMessage } from 'src/app/models/admin-message';
import { WalletAccount } from 'src/app/models/wallet-account';
import { InteracEmail } from 'src/app/models/interac-email';
import { MomoDeposit } from 'src/app/models/momo-deposit';
import { BankDeposit } from 'src/app/models/bank-deposit';
import { IssueReport } from 'src/app/models/issue-report';
import { DepositIssueReport } from 'src/app/models/deposit-issue-report';
import { KycVerification } from 'src/app/models/kyc-verification';
import { ComplianceReview } from 'src/app/models/compliance-review';
import { AngularFireFunctions } from '@angular/fire/functions';
import { ForeignBillPaymentRequest } from 'src/app/models/foreign-bill-payment-request';
import { DataService, PrivacySection } from 'src/app/services/data.service';
import { FirebaseService } from 'src/app/services/firebase.service';
import { CustomizedCellComponentComponent } from '../customized-cell-component/customized-cell-component.component';
import { DeleteRendererComponent } from '../delete-renderer/delete-renderer.component';
import { EditRendererComponent } from '../edit-renderer/edit-renderer.component';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { CheckboxCellComponent } from '../checkbox-cell/checkbox-cell.component';
import { Transaction } from 'src/app/models/transaction';
import { PushNotification } from 'src/app/models/push-notification';
import { DeleteTransactionComponent } from '../delete-transaction/delete-transaction.component';
import { Subscription } from 'rxjs';
import { SelectionChangedEvent } from 'ag-grid-community';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

/** Les douze écrans de l'espace admin, plus le tableau de bord d'accueil. */
export type AdminTab =
  | 'dashboard' | 'transactions' | 'kyc' | 'messages' | 'wallets' | 'interac'
  | 'momo' | 'marketplace' | 'issues' | 'deposit_issues' | 'notifications'
  | 'foreign_bills' | 'fees' | 'rates' | 'compliance' | 'settings' | 'privacy'
  | 'pays' | 'bank_deposits'
  | 'money_events';

/** Une entrée de la navigation latérale. */
interface AdminLink {
  tab: AdminTab;
  label: string;
  icon: string;
  /** Nom de la propriété portant le compteur à afficher en pastille. */
  badge?: 'pendingKycCount' | 'pendingComplianceCount' | 'newInteracCount' | 'newMomoCount'
    | 'newBankDepositCount'
        | 'newIssuesCount' | 'newDepositIssuesCount' | 'pendingForeignBillsCount'
        | 'moneyEventErrorCount' | 'failedNotificationsCount';
}

/** Classe posée sur <body> le temps de la page : elle escamote l'en-tête et
 *  le pied du site public, que l'espace admin remplace par sa propre coque. */
const BODY_CLASS = 'mtx-admin-open';

@Component({
  selector: 'app-manage-transactions',
  templateUrl: './manage-transactions.component.html',
  styleUrls: ['./manage-transactions.component.scss'],
  encapsulation: ViewEncapsulation.None // take the style of the modal popup in considaration
})
export class ManageTransactionsComponent implements OnInit, OnDestroy {

  private getavailablePaySuscribtions: Subscription;
  private gridApi;
  private gridColumnApi;
  public columnDefs;
  public columnDefsXs;
  private sortingOrder;
  load = '';
  rowData: any;
  params: any;
  showXl = false;
  showXs = false;
  modalRef: any; 
  mobileValue = '';
  frameworkComponents: { editRenderer: typeof EditRendererComponent; deleteRenderer: typeof DeleteTransactionComponent; customizedCell: typeof CustomizedCellComponentComponent;};
  enableEmail: boolean;
  enableNom: boolean;
  enablePrenom: boolean;
  enableCountry: boolean;
  enableTown: boolean;
  enableTelephone: boolean;
  enableAmount: boolean;
  separateDialCode = false;
  phoneForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required])
  });
  beneficiaryObj: Beneficiary = {
    id: '',
    userEmail: '',
    first_name: '',
    last_name: '',
    email: '',
    mobile : '',
    town : '',
    country : '' 
  };
  allTransactionsList: Transaction[] = [];
  /** Réserve XAF partagée. Un NOMBRE : le formatage est au gabarit (| number).
   *  C'était une chaîne pré-groupée à la main, et la boucle qui la produisait
   *  comptait tous les 3 caractères depuis la droite, virgule comprise — donc
   *  1234.5 s'affichait « 123 4.5 ». */
  amount = 0;
  /** Le flux des transactions n'expose pas de Subscription : ce drapeau tient
   *  lieu de garde contre une double souscription au montage de la grille. */
  private transactionsLoaded = false;

  // ── COQUE DE L'ESPACE ADMIN ──
  activeTab: AdminTab = 'dashboard';

  readonly navLinks: AdminLink[] = [
    { tab: 'dashboard',      label: 'Tableau de bord', icon: '📊' },
    { tab: 'transactions',   label: 'Transactions',    icon: '💸' },
    { tab: 'money_events',   label: 'Mouvements d\'argent', icon: '🧭', badge: 'moneyEventErrorCount' },
    { tab: 'kyc',            label: 'Vérifications KYC', icon: '🪪', badge: 'pendingKycCount' },
    { tab: 'compliance',     label: 'Conformité',      icon: '🔍', badge: 'pendingComplianceCount' },
    { tab: 'wallets',        label: 'Portefeuilles',   icon: '👛' },
    { tab: 'interac',        label: 'Emails Interac',  icon: '📧', badge: 'newInteracCount' },
    { tab: 'momo',           label: 'Dépôts MoMo',     icon: '📱', badge: 'newMomoCount' },
    { tab: 'bank_deposits',  label: 'Dépôts bancaires', icon: '🏦', badge: 'newBankDepositCount' },
    { tab: 'marketplace',    label: 'Marketplace',     icon: '🛒' },
    { tab: 'foreign_bills',  label: 'Factures étranger', icon: '🧾', badge: 'pendingForeignBillsCount' },
    { tab: 'issues',         label: 'Signalements',    icon: '🚩', badge: 'newIssuesCount' },
    { tab: 'deposit_issues', label: 'Litiges de dépôt', icon: '⚠️', badge: 'newDepositIssuesCount' },
    { tab: 'messages',       label: 'Messages',        icon: '💬' },
    { tab: 'notifications',  label: 'Notifications',   icon: '🔔', badge: 'failedNotificationsCount' },
    { tab: 'fees',           label: 'Frais',           icon: '💰' },
    { tab: 'rates',          label: 'Taux de change',  icon: '💱' },
    { tab: 'pays',           label: 'Pays & corridors', icon: '🌍' },
    { tab: 'settings',       label: 'Paramètres',      icon: '⚙️' },
    { tab: 'privacy',        label: 'Confidentialité', icon: '🛡️' },
  ];

  /** Titre et sous-titre de l'en-tête de contenu, par écran. */
  private readonly pageHeads: { [K in AdminTab]: [string, string] } = {
    dashboard:      ['Tableau de bord', 'Vue d\'ensemble de l\'activité de la plateforme'],
    transactions:   ['Transactions', 'Historique complet des transferts et des opérations marketplace'],
    money_events:   ['Mouvements d\'argent', 'Toutes les tentatives — réussies, refusées, et celles signalées par les clients'],
    kyc:            ['Vérifications KYC', 'Pièces d\'identité soumises par les clients, à valider ou à rejeter'],
    wallets:        ['Portefeuilles', 'Soldes, alias Interac et codes MoMo des clients'],
    interac:        ['Emails Interac', 'Virements Interac reçus sur la boîte de support'],
    bank_deposits:  ['Dépôts bancaires', 'Virements déclarés depuis le Royaume-Uni, la France et la Chine, à vérifier avant de créditer'],
    momo:           ['Dépôts Mobile Money', 'Déclarations de dépôt MTN et Orange en attente de vérification'],
    marketplace:    ['Marketplace', 'Posts publiés, offres reçues et frais encaissés sur les offres acceptées'],
    foreign_bills:  ['Factures à l\'étranger', 'Demandes de paiement de facture confiées à un agent au Canada'],
    issues:         ['Signalements', 'Problèmes remontés par les clients depuis l\'application'],
    deposit_issues: ['Litiges de dépôt', 'Dépôts Interac ou Mobile Money introuvables côté client'],
    messages:       ['Messages', 'Bandeaux affichés dans l\'application cliente'],
    notifications:  ['Notifications', 'Envoi de notifications push et historique'],
    fees:           ['Frais de la plateforme', 'Pourcentages prélevés sur chaque type d\'opération'],
    rates:          ['Taux de change', 'Taux CAD↔XAF des transferts directs et bornes du taux marketplace'],
    compliance:     ['Conformité', 'Transactions au-dessus du seuil, en attente de votre décision'],
    pays:           ['Pays & corridors', 'Ouvrir ou fermer un pays, une direction, et les coordonnées de virement'],
    settings:       ['Paramètres', 'Mode maintenance et coordonnées de réception affichées aux clients'],
    privacy:        ['Politique de confidentialité', 'Texte affiché dans l\'application, et version que les clients doivent accepter'],
  };

  get pageTitle(): string { return this.pageHeads[this.activeTab][0]; }
  get pageSubtitle(): string { return this.pageHeads[this.activeTab][1]; }

  /** Lecture d'un compteur par son nom, pour les pastilles de navigation. */
  badgeCount(link: AdminLink): number {
    return link.badge ? (this[link.badge] as number) || 0 : 0;
  }

  // Platform percentage fees (config/fees), edited on the "Fees" tab and read
  // by the Flutter app. Three independent rates.
  feesForm = { postFeePercent: 0, offerFeePercent: 0, directTransferFeePercent: 0 };
  private feesSubscription: Subscription;

  // Exchange rates (config/rates), edited on the "Taux de change" tab. In
  // 'auto' the apps keep following the public exchangerate API; in 'manual'
  // the two rates below are what customers see, and transferMoney recomputes
  // the recipient amount from cadToXaf instead of trusting the client.
  ratesForm: { mode: 'auto' | 'manual'; cadToXaf: number; xafToCad: number } =
    { mode: 'auto', cadToXaf: 0, xafToCad: 0 };
  ratesUpdatedAt = '';
  ratesUpdatedBy = '';
  private ratesSubscription: Subscription;

  // Marketplace rate bounds (config/rateLimits), edited on the same "Taux de
  // change" tab, below the transfer rates. Absolute min/max on the number a
  // post author types — expressed as XAF per 1 CAD, which is the one direction
  // the mobile app stores whichever way the post points, so a single pair
  // covers both. 0 disables a bound.
  rateLimitsForm = { min: 0, max: 0 };
  rateLimitsUpdatedAt = '';
  rateLimitsUpdatedBy = '';
  private rateLimitsSubscription: Subscription;

  // Deposit-display settings, edited on the "Paramètres" tab and read by the
  // Flutter deposit page. Interac alias domain (config/interac) shown to CA
  // customers, and MTN/Orange receiving numbers (config/momo) shown to CM.
  interacForm = { aliasDomain: '' };
  momoForm = { mtnNumber: '', orangeNumber: '' };
  private interacConfigSubscription: Subscription;
  private momoConfigSubscription: Subscription;

  // Maintenance mode (config/maintenance) — the platform kill switch, edited on
  // the "Paramètres" tab. exemptEmails is held as one comma-separated string
  // for the input and split into an array on save.
  maintenanceForm = {
    isActive: false,
    titleFr: '',
    titleEn: '',
    messageFr: '',
    messageEn: '',
    exemptEmails: '',
  };
  maintenanceUpdatedAt = '';
  maintenanceUpdatedBy = '';
  private maintenanceSubscription: Subscription;

  // Operating company (config/company) — legal entity and FINTRAC number shown
  // in the investor dossier. Edited on the "Paramètres" tab. The defaults are
  // what the FINTRAC registry showed when the dossier was written; the form
  // shows them until the document has been saved once.
  companyForm = { legalName: 'Vofack Consultation Inc.', fintracNumber: 'C10001562' };
  companyUpdatedAt = '';
  companyUpdatedBy = '';
  private companySubscription: Subscription;

  // Investor dossier passwords, one per document: the business case and the
  // business plan are opened by different passwords (functions/dossier_admin.js).
  // Never read back: the server only ever holds a hash, and these forms only
  // ever send a new value.
  dossierPasswordForm: { [target: string]: { password: string; confirm: string } } = {
    case: { password: '', confirm: '' },
    plan: { password: '', confirm: '' },
  };
  dossierPasswordVisible: { [target: string]: boolean } = { case: false, plan: false };
  dossierPasswordSaving: { [target: string]: boolean } = { case: false, plan: false };
  dossierPasswordInfo: { [target: string]: { source: string; updatedAt: string | null; updatedBy: string | null } } = {
    case: null,
    plan: null,
  };
  readonly dossierPasswordPanels = [
    {
      target: 'case',
      title: 'Dossier investisseur — business case',
      lead: 'Mot de passe qui protège le business case en ligne, en français et en anglais. Il n\'ouvre pas le business plan.',
      example: 'corridor-beko-2027',
      links: [
        { label: 'Français', url: 'https://earlytransfert.web.app/dossier' },
        { label: 'Anglais', url: 'https://earlytransfert.web.app/en-US/dossier' },
      ],
    },
    {
      target: 'plan',
      title: 'Business plan',
      lead: 'Mot de passe distinct, qui protège uniquement le business plan. Il doit être différent de celui du business case.',
      example: 'plan-execution-2027',
      links: [
        { label: 'Français', url: 'https://earlytransfert.web.app/dossier/plan' },
      ],
    },
  ];

  // Privacy policy (config/privacyPolicy) — the text the mobile app renders,
  // edited on the "Confidentialité" tab. Sections are an ordered array; order
  // is the display order in the app.
  privacyForm = {
    effectiveDateFr: '', effectiveDateEn: '',
    introFr: '', introEn: '',
    contactTitleFr: '', contactTitleEn: '',
    contactBodyFr: '', contactBodyEn: '',
    contactEmail: '',
    lastUpdatedFr: '', lastUpdatedEn: '',
  };
  privacySections: PrivacySection[] = [];
  privacyVersion = 0;
  /** Per-save intent, never hydrated from Firestore and reset after each save:
   *  ON means "this save is a new version, prompt every customer again". */
  privacyBumpVersion = false;
  privacyUpdatedAt = '';
  privacyUpdatedBy = '';
  privacyVersionPublishedAt = '';
  private privacySubscription: Subscription;

  /** Icon keys the mobile app knows how to resolve. Keeping this list in step
   *  with PrivacyPolicyService._icons on the Flutter side is what stops an
   *  admin from picking an icon that renders as a blank box. */
  readonly privacyIconOptions: { key: string; label: string }[] = [
    { key: 'handshake',     label: 'Poignée de main — engagement' },
    { key: 'folder_shared', label: 'Dossier — informations collectées' },
    { key: 'tune',          label: 'Réglages — utilisation' },
    { key: 'share',         label: 'Partage' },
    { key: 'lock',          label: 'Cadenas — sécurité' },
    { key: 'schedule',      label: 'Horloge — conservation' },
    { key: 'gavel',         label: 'Marteau — droits' },
    { key: 'insights',      label: 'Courbe — analytique' },
    { key: 'child_care',    label: 'Enfance — mineurs' },
    { key: 'public',        label: 'Globe — international' },
    { key: 'update',        label: 'Mise à jour — modifications' },
    { key: 'shield',        label: 'Bouclier' },
    { key: 'payments',      label: 'Paiements' },
    { key: 'badge',         label: 'Badge — identité' },
    { key: 'support_agent', label: 'Support' },
    { key: 'article',       label: 'Document (par défaut)' },
  ];

  // Per-transaction thresholds (config/limits), edited on the "Paramètres" tab.
  // Per currency because 500 CAD and 500 XAF are not remotely the same money.
  // reviewAbove → compliance packet + admin approval; blockAbove → refused.
  // 0 disables a threshold.
  limitsForm = {
    direct: { CAD: { reviewAbove: 0, blockAbove: 0 }, XAF: { reviewAbove: 0, blockAbove: 0 } },
    marketplace: { CAD: { reviewAbove: 0, blockAbove: 0 }, XAF: { reviewAbove: 0, blockAbove: 0 } },
  };
  limitsUpdatedAt = '';
  limitsUpdatedBy = '';
  private limitsSubscription: Subscription;

  // Per-direction corridor switches (config/corridors). Suspends one leg of
  // Canada↔Cameroun for DIRECT TRANSFERS ONLY — the marketplace crosses the
  // same corridor and stays open by design.
  // ── Pays & corridors ──────────────────────────────────────────────────────

  /**
   * MIRROR of `Countries.supported` in lib/models/country.dart. `iso`,
   * `currency` and `rail` must agree with that catalogue and with COUNTRY_TABLE
   * in functions/index.js — three copies, and they have to say the same thing.
   *
   * `hub: true` marks Cameroon: every corridor has it on one leg, so it cannot
   * be closed on its own without closing everything.
   */
  readonly countryCatalogue = [
    { iso: 'CM', label: 'Cameroun',     currency: 'XAF', rail: 'momo',    hub: true },
    { iso: 'CA', label: 'Canada',       currency: 'CAD', rail: 'interac', hub: false },
    { iso: 'GB', label: 'Royaume-Uni',  currency: 'GBP', rail: 'bank',    hub: false },
    { iso: 'FR', label: 'France',       currency: 'EUR', rail: 'bank',    hub: false },
    { iso: 'CN', label: 'Chine',        currency: 'CNY', rail: 'bank',    hub: false },
  ];

  countriesForm: { [iso: string]: {
    enabled: boolean; directEnabled: boolean; marketplaceEnabled: boolean;
    messageFr: string; messageEn: string;
  } } = {};
  countriesUpdatedAt = '';
  countriesUpdatedBy = '';
  private countriesSubscription: Subscription;

  depositRailsForm: { [iso: string]: {
    enabled: boolean; bankName: string; accountName: string;
    fields: { label: string; value: string }[];
    referenceHint: string;
    instructionsFr: string; instructionsEn: string;
    processingNoteFr: string; processingNoteEn: string;
  } } = {};
  depositRailsUpdatedAt = '';
  depositRailsUpdatedBy = '';
  private depositRailsSubscription: Subscription;

  // Indexed by the derived direction key ('caToCm', 'cmToGb', …) rather than a
  // fixed pair, so opening a country adds its two directions without an edit
  // here. See corridorDirections().
  corridorsForm: {
    sides: { [key: string]: { disabled: boolean; messageFr: string; messageEn: string } };
    exemptEmails: string;
  } = { sides: {}, exemptEmails: '' };
  corridorsUpdatedAt = '';
  corridorsUpdatedBy = '';
  private corridorsSubscription: Subscription;

  // Marketplace kill switch (config/marketplace). Blocks ENTRY to the
  // marketplace in the app — the customer gets an unavailability screen
  // carrying the message below. Direct transfers are unaffected.
  //
  // Named `marketplaceConfigForm`, not `marketplaceForm`: `activeTab ===
  // 'marketplace'` is the posts/offers grid tab and `limitsForm.marketplace`
  // already exists.
  marketplaceConfigForm = {
    disabled: false,
    titleFr: '',
    titleEn: '',
    messageFr: '',
    messageEn: '',
    // Comma-separated in the UI, string[] in Firestore.
    exemptEmails: '',
    blockedEmails: '',
  };
  marketplaceConfigUpdatedAt = '';
  marketplaceConfigUpdatedBy = '';
  private marketplaceConfigSubscription: Subscription;

  // Compliance reviews (read-only from here — decisions go through the
  // decideComplianceReview Cloud Function, never a direct Firestore write).
  complianceColumnDefs: any;
  complianceRowData: ComplianceReview[] = [];
  complianceGridParams: any;
  selectedCompliance: ComplianceReview = null;
  pendingComplianceCount = 0;
  complianceRejectReason = '';
  complianceRemediation = '';
  private complianceSubscription: Subscription;
  kycColumnDefs: any;
  kycColumnDefsXs: any;
  kycRowData: KycVerification[] = [];
  kycGridParams: any;
  selectedKyc: KycVerification = null;
  rejectionReason = '';
  pendingKycCount = 0;
  private kycSubscription: Subscription;
  @ViewChild('templateKycDetail', { read: TemplateRef }) templateKycDetail: TemplateRef<any>;
  @ViewChild('templateComplianceDetail', { read: TemplateRef }) templateComplianceDetail: TemplateRef<any>;
  @ViewChild('templateMoneyEventDetail', { read: TemplateRef }) templateMoneyEventDetail: TemplateRef<any>;
  @ViewChild('templateReject', { read: TemplateRef }) templateReject: TemplateRef<any>;

  // ── MESSAGES TAB ──
  messagesColumnDefs: any;
  messagesRowData: AdminMessage[] = [];
  messagesGridParams: any;
  selectedMessage: AdminMessage = null;
  private messagesSubscription: Subscription;
  messageForm: AdminMessage = { messageEn: '', messageFr: '', isActive: true, type: 'info', targetUserEmail: '' };
  isEditingMessage = false;
  @ViewChild('templateAddMessage', { read: TemplateRef }) templateAddMessage: TemplateRef<any>;

  // ── WALLETS TAB ──
  walletColumnDefs: any;
  walletRowData: WalletAccount[] = [];
  walletGridParams: any;
  selectedWallet: WalletAccount = null;
  private walletSubscription: Subscription;
  walletNewAmount: number = 0;
  aliasGenerating: boolean = false;
  momoCodeGenerating: boolean = false;
  // Loaded from config/interac (falls back to the historical default until the
  // config doc is read). Used to render the full alias address in the wallet
  // grid/modal and by copyInteracAlias().
  interacAliasDomain = 'earlytransfert.com';
  @ViewChild('templateEditWallet', { read: TemplateRef }) templateEditWallet: TemplateRef<any>;

  // ── INTERAC EMAILS TAB ──
  interacColumnDefs: any;
  interacRowData: InteracEmail[] = [];
  interacGridParams: any;
  selectedInteracEmail: InteracEmail = null;
  private interacSubscription: Subscription;
  newInteracCount = 0;
  interacChecking = false;
  // State for the "Mark Processed" → credit-wallet confirmation flow.
  pendingInteracCredit: { wallet: WalletAccount; amount: number; amountStr: string; newBalance: number } | null = null;
  // State for the symmetric reversal flow when an email leaves the 'processed'
  // state (Back to New / Mark Ignored): debits the previously credited amount
  // from the wallet.
  pendingInteracReversal: { wallet: WalletAccount; amount: number; amountStr: string; newBalance: number; targetStatus: 'new' | 'ignored' } | null = null;
  @ViewChild('templateInteracCreditConfirm', { read: TemplateRef }) templateInteracCreditConfirm: TemplateRef<any>;
  @ViewChild('templateInteracReversalConfirm', { read: TemplateRef }) templateInteracReversalConfirm: TemplateRef<any>;

  // ── MOMO DEPOSITS TAB (Cameroun) ──
  // ── Marketplace : posts → offres → les 2 transactions de chaque offre acceptée ──
  // Master/Detail maison (accordéon) : ag-grid-community ne fournit pas
  // masterDetail (Enterprise), et il faut ici TROIS niveaux imbriqués.
  marketplaceRowData: any[] = [];
  /** Frais encaissés tous posts confondus, agrégés par devise. */
  marketplaceTotals = '—';
  marketplaceFilter = '';
  marketplaceSort: 'offers' | 'accepted' | 'author' = 'offers';
  expandedPostId: string | null = null;
  expandedOfferId: string | null = null;
  /** Détail (offres + transactions) du SEUL post déplié — jamais de tous. */
  expandedOffers: any[] = [];
  marketplacePage = 0;
  readonly marketplacePageSize = 25;
  // Index construits une fois par rafraîchissement : sans eux l'agrégation
  // serait en O(posts × offres × transactions) et gèlerait la page.
  private offersByPost = new Map<string, any[]>();
  private txByProposition = new Map<string, any[]>();
  // Mémoïsation du filtrage/tri : le getter est appelé à chaque cycle de
  // détection de changement, on ne recalcule que si une entrée a bougé.
  private mpCacheKey = '';
  private mpCache: any[] = [];
  private mpVersion = 0;
  private postsSubscription: Subscription;
  private propositionsSubscription: Subscription;
  private marketTxSubscription: Subscription;
  private allPosts: any[] = [];
  private allPropositions: any[] = [];
  private marketTxs: any[] = [];

  momoColumnDefs: any;
  momoRowData: MomoDeposit[] = [];

  bankDepositColumnDefs: any;
  bankDepositRowData: BankDeposit[] = [];
  selectedBankDeposit: BankDeposit = null;
  pendingBankCredit: { amount: number; currency: string; email: string } = null;
  bankRejectReason = '';
  newBankDepositCount = 0;
  private bankDepositSubscription: Subscription;
  private bankDepositGridApi: any;
  momoGridParams: any;

  // ── Mouvements d'argent (journal d'audit) ──
  moneyEventRowData: any[] = [];
  moneyEventGridParams: any;
  moneyEventColumnDefs: any[] = [];
  /** Recherche par client ou par code de transaction, propre à cet onglet. */
  moneyEventSearch = '';
  moneyEventLoading = false;
  moneyEventNotice = '';
  selectedMoneyEvent: any = null;
  selectedMoneyEventArtifacts: { key: string; value: string }[] = [];
  selectedMomoDeposit: MomoDeposit = null;
  private momoSubscription: Subscription;
  newMomoCount = 0;
  // State for the "Approve" → credit-wallet confirmation flow.
  pendingMomoCredit: { wallet: WalletAccount; amount: number; newBalance: number } | null = null;
  @ViewChild('templateMomoCreditConfirm', { read: TemplateRef }) templateMomoCreditConfirm: TemplateRef<any>;
  @ViewChild('templateMomoRejectConfirm', { read: TemplateRef }) templateMomoRejectConfirm: TemplateRef<any>;
  @ViewChild('templateBankCreditConfirm', { read: TemplateRef }) templateBankCreditConfirm: TemplateRef<any>;
  @ViewChild('templateBankRejectConfirm', { read: TemplateRef }) templateBankRejectConfirm: TemplateRef<any>;
  momoRejectReason: string = '';

  // ── ISSUES TAB ──
  issuesColumnDefs: any;
  issuesRowData: IssueReport[] = [];
  issuesGridParams: any;
  selectedIssue: IssueReport = null;
  private issuesSubscription: Subscription;
  newIssuesCount = 0;
  issuesChecking = false;
  @ViewChild('templateIssueBody', { read: TemplateRef }) templateIssueBody: TemplateRef<any>;

  // ── DEPOSIT ISSUES TAB (Interac / Mobile Money) ──
  depositIssuesColumnDefs: any;
  depositIssuesRowData: DepositIssueReport[] = [];
  /** Sous-ensemble affiché, après application du filtre de type. */
  depositIssuesVisibleRows: DepositIssueReport[] = [];
  depositIssuesGridParams: any;
  selectedDepositIssue: DepositIssueReport = null;
  private depositIssuesSubscription: Subscription;
  newDepositIssuesCount = 0;
  depositTypeFilter: 'all' | 'interac' | 'mobile_money' = 'all';
  @ViewChild('templateDepositIssueBody', { read: TemplateRef }) templateDepositIssueBody: TemplateRef<any>;

  // ── NOTIFICATIONS TAB ──
  notificationColumnDefs: any;
  notificationRowData: PushNotification[] = [];
  notificationGridParams: any;
  private notificationSubscription: Subscription;
  notificationForm: PushNotification = { title: '', body: '', targetEmail: '' };
  notificationTargetType: 'all' | 'specific' = 'all';
  notificationSending = false;
  userEmails: string[] = [];
  selectedTargetEmails: string[] = [];
  emailTypeaheadInput = '';
  private usersSubscription: Subscription;
  // Account email (lowercased) → profile phone (users.mobile). Used as the
  // fallback source for the Interac Emails tab's "User Phone" column when the
  // matched wallet has no interacPhone set yet.
  private userMobileByEmail = new Map<string, string>();

  // ── FOREIGN BILL PAYMENT REQUESTS TAB ──
  // Requests from users abroad asking a Canada-based agent to pay a local bill.
  foreignBillsColumnDefs: any;
  foreignBillsRowData: ForeignBillPaymentRequest[] = [];
  foreignBillsGridParams: any;
  selectedForeignBill: ForeignBillPaymentRequest = null;
  pendingForeignBillsCount = 0;
  foreignBillRejectionReason = '';
  foreignBillPaidForm = { reference: '', proofUrl: '', note: '' };
  foreignBillUserMessageEnDraft = '';
  foreignBillUserMessageFrDraft = '';
  foreignBillUserMessageSaving = false;
  private foreignBillsSubscription: Subscription;
  @ViewChild('templateForeignBillDetail', { read: TemplateRef }) templateForeignBillDetail: TemplateRef<any>;
  @ViewChild('templateForeignBillReject', { read: TemplateRef }) templateForeignBillReject: TemplateRef<any>;
  @ViewChild('templateForeignBillPaid', { read: TemplateRef }) templateForeignBillPaid: TemplateRef<any>;

  // ── FILTERS ──
  emailFilter = '';
  dateFrom = '';
  dateTo = '';
  @ViewChild('templateInteracBody', { read: TemplateRef }) templateInteracBody: TemplateRef<any>;

  // ── MARKETPLACE POST DETAIL MODAL ──
  // Populated when the admin clicks "View" on a marketplace transaction row
  // so the modal can show the Post, the accepted Proposition, and both linked
  // transactions.
  selectedMarketplacePost: any = null;
  selectedMarketplaceProposition: any = null;
  selectedMarketplaceTransactions: { postSide: any; propositionSide: any } = { postSide: null, propositionSide: null };
  loadingMarketplacePost = false;
  @ViewChild('templatePostDetail', { read: TemplateRef }) templatePostDetail: TemplateRef<any>;

  // Appliqué à toutes les grilles : chaque colonne est redimensionnable à la
  // souris. Passer par defaultColDef évite de répéter `resizable` sur la
  // centaine de définitions de colonnes de l'écran.
  readonly defaultColDef = {
    resizable: true,
    minWidth: 70,
  };

  // ── ORIGINE DES TRANSACTIONS (écran Transactions) ──
  // Toutes les transactions ne viennent pas d'un post marketplace : certaines
  // sont des transferts directs. C'est cette distinction-là qu'il faut voir,
  // et un filtre la sert mieux qu'un regroupement — d'autant que la modale
  // « Voir le post » montre déjà, pour une ligne marketplace, le post, la
  // proposition acceptée et les deux transactions liées.
  transactionTypeFilter: 'all' | 'marketplace' | 'direct' = 'all';

  /** Sous-ensemble affiché, après application du filtre d'origine. */
  transactionsVisibleRows: any[] = [];

  marketplaceCount = 0;
  directCount = 0;

  private static isMarketplaceRow(r: any): boolean {
    return !!(r && r.isMarketPlace && r.postId);
  }

  /** Libellé de la colonne « Origine ». Aussi la valeur sur laquelle filtre
   *  et trie la grille, d'où le passage par un valueGetter. */
  transactionOrigin(row: any): string {
    if (!ManageTransactionsComponent.isMarketplaceRow(row)) return 'Transfert direct';
    return row.isPostWoner ? 'Marketplace · Post' : 'Marketplace · Offre';
  }

  setTransactionTypeFilter(value: 'all' | 'marketplace' | 'direct') {
    this.transactionTypeFilter = value;
    this.applyTransactionsGrid();
  }

  // ── REGROUPEMENT PAR POST (vue Marketplace uniquement) ────────────────
  // Une transaction marketplace n'a de sens qu'avec sa contrepartie : le
  // propriétaire du post et celui qui a fait l'offre. On les rassemble donc
  // sous une ligne d'en-tête dépliable. Repliée par défaut : la grille montre
  // alors un post par ligne au lieu de toutes ses transactions.
  //
  // Ce regroupement ne vaut que pour la vue Marketplace ; en « Toutes » il
  // mélangerait des lignes groupées et des lignes isolées, ce qui est
  // précisément ce qui rendait la version précédente illisible.

  /** Posts dépliés. Vide = tout replié. */
  private expandedPosts = new Set<string>();

  isPostExpanded(postId: string): boolean {
    return this.expandedPosts.has(postId);
  }

  togglePostGroup(postId: string) {
    if (this.expandedPosts.has(postId)) {
      this.expandedPosts.delete(postId);
    } else {
      this.expandedPosts.add(postId);
    }
    this.applyTransactionsGrid();
  }

  expandAllPosts() {
    this.transactionsVisibleRows
      .filter(r => r && r.__isGroupHeader)
      .forEach(r => this.expandedPosts.add(r.postId));
    this.applyTransactionsGrid();
  }

  collapseAllPosts() {
    this.expandedPosts.clear();
    this.applyTransactionsGrid();
  }

  /** Vrai dès qu'au moins un post est déplié — pilote le libellé du bouton. */
  get hasExpandedPost(): boolean { return this.expandedPosts.size > 0; }

  // ag-grid Community n'a pas de row grouping : on l'imite avec des lignes
  // d'en-tête synthétiques rendues en pleine largeur.
  isFullWidthCell = (rowNode: any) => !!(rowNode && rowNode.data && rowNode.data.__isGroupHeader);

  // Renderer JS pur des lignes « ▸ Post XYZ · N transactions ». Toute la
  // ligne est cliquable pour plier/déplier ; le bouton « Voir le post »
  // réutilise le flux modal existant et n'entraîne donc pas le pliage.
  fullWidthCellRenderer = class {
    private eGui: HTMLElement;
    private btn: HTMLButtonElement | null = null;
    private onRowClick: ((e: Event) => void) | null = null;
    private onBtnClick: ((e: Event) => void) | null = null;

    init(params: any) {
      const data = (params && params.data) || {};
      const count = data.__count || 0;
      const expanded = !!data.__expanded;

      this.eGui = document.createElement('div');
      this.eGui.className = 'mtx-group-row' + (expanded ? ' is-expanded' : '');
      this.eGui.setAttribute('role', 'button');
      this.eGui.setAttribute('tabindex', '0');
      this.eGui.setAttribute('aria-expanded', String(expanded));
      this.eGui.innerHTML =
        '<span class="mtx-group-row__chevron" aria-hidden="true">' + (expanded ? '▾' : '▸') + '</span>' +
        '<span class="mtx-group-row__label">Post</span>' +
        '<code class="mtx-group-row__id">' + (data.postId || '') + '</code>' +
        '<span class="mtx-group-row__count">' + count + ' transaction' + (count === 1 ? '' : 's') + '</span>' +
        '<button type="button" class="mtx-group-row__cta">Voir le post</button>';

      if (typeof data.__toggle === 'function') {
        this.onRowClick = (e: Event) => {
          if (this.btn && this.btn.contains(e.target as Node)) { return; }
          data.__toggle(data.postId);
        };
        this.eGui.addEventListener('click', this.onRowClick);
      }

      this.btn = this.eGui.querySelector('.mtx-group-row__cta');
      if (this.btn && typeof data.__openPostDetail === 'function' && data.__refTransaction) {
        this.onBtnClick = () => data.__openPostDetail(data.__refTransaction);
        this.btn.addEventListener('click', this.onBtnClick);
      }
    }

    getGui() { return this.eGui; }

    destroy() {
      if (this.onRowClick) { this.eGui.removeEventListener('click', this.onRowClick); }
      if (this.btn && this.onBtnClick) { this.btn.removeEventListener('click', this.onBtnClick); }
    }
  };

  // Range les lignes marketplace par post et intercale une ligne d'en-tête
  // devant chaque groupe. Les transactions d'un post replié ne sont pas
  // émises du tout : la grille n'a donc rien à rendre pour elles.
  private groupMarketplaceRows(rows: any[]): any[] {
    const buckets = new Map<string, any[]>();
    const order: string[] = [];
    for (const r of rows) {
      if (!buckets.has(r.postId)) {
        buckets.set(r.postId, []);
        order.push(r.postId);
      }
      buckets.get(r.postId).push(r);
    }

    const openPostDetail = (t: any) => this.openPostDetailModal(t);
    const toggle = (pid: string) => this.togglePostGroup(pid);

    const out: any[] = [];
    for (const pid of order) {
      const bucket = buckets.get(pid);
      // Le propriétaire du post en tête : c'est lui qui porte le contexte.
      bucket.sort((a, b) => {
        if (a.isPostWoner === b.isPostWoner) return 0;
        return a.isPostWoner ? -1 : 1;
      });
      const expanded = this.expandedPosts.has(pid);
      out.push({
        __isGroupHeader: true,
        postId: pid,
        __count: bucket.length,
        __expanded: expanded,
        __refTransaction: bucket.find(t => t.isPostWoner) || bucket[0],
        __openPostDetail: openPostDetail,
        __toggle: toggle,
      });
      if (expanded) { out.push(...bucket); }
    }
    return out;
  }

  /** Nombre de posts distincts dans la vue Marketplace. */
  postGroupCount = 0;

  // Recalcule la liste visible. C'est elle qui est bindée à la grille via
  // [rowData], donc filtre et pliage survivent à la destruction/recréation
  // de la grille par le *ngIf de l'onglet.
  private applyTransactionsGrid() {
    const rows = this.rowData || [];

    if (this.transactionTypeFilter === 'marketplace') {
      const marketplace = rows.filter(r => ManageTransactionsComponent.isMarketplaceRow(r));
      this.transactionsVisibleRows = this.groupMarketplaceRows(marketplace);
      this.postGroupCount = this.transactionsVisibleRows
        .filter(r => r.__isGroupHeader).length;
      return;
    }

    this.postGroupCount = 0;
    this.transactionsVisibleRows = this.transactionTypeFilter === 'direct'
      ? rows.filter(r => !ManageTransactionsComponent.isMarketplaceRow(r))
      : rows;
  }

  constructor(private http: HttpClient, private modalService:BsModalService,
              private toastr: ToastrService, private  spinner: NgxSpinnerService,
              private data: DataService, private router: Router,
              private firebase: FirebaseService,
              private fns: AngularFireFunctions) {

                // Build the country tab's rows and direction list ONCE. They
                // are read from the template on every change-detection pass, so
                // they must be stable references — see initCountriesTab().
                this.initCountriesTab();

                const cellClassRules = {
                  "cell-pass": params => params.value === 'COMPLETE',
                  "cell-fail": params => params.value === 'INCOMPLETE',
                  "cell-pending": params => params.value === 'PENDING',
                  "cell-inProgress": params => params.value === 'INPROGRESS'
                };

                
                this.columnDefs = [

                  {  
                    field: 'Enable', cellRenderer: 'customizedCell',
                    cellClass: 'grid-cell-centered',
                    width: 120,
                    resizable: true,
                    cellRendererParams: {
                      onClick: this.onClickSelected.bind(this),
                      checkbox: true,
                      width: 20,
                    }
                  },
                  {
                    field: 'delete',cellRenderer: 'deleteRenderer',
                    headerClass: 'my-header-class',
                    onClick: this.onClickDelete.bind(this),
                    width: 120,
                    resizable: true
                  },
                  {
                    headerName: "User Email",
                    field: "userEmail",
                    width: 186,
                    filter: "agTextColumnFilter",
                    sortingOrder: ["asc","desc"]
                  },
                  {
                    headerName: "Transaction code",
                    field: "id",
                    width: 186,
                    filter: "agTextColumnFilter",
                    sortingOrder: ["asc","desc"]
                  },
                  {
                    headerName: "Status",
                    field: "status",
                    cellClassRules: cellClassRules,
                    filter: "agTextColumnFilter",
                    width: 186
                  },
                  {
                    headerName: "Receiver",
                    field: "receiver",
                    filter: "agTextColumnFilter",
                    width: 186
                  },
                  {
                    headerName: "Amout Send",
                    field: "amountSend",
                    filter: "agTextColumnFilter",
                    width: 186,
                    sortingOrder: ["asc",null]
                  },
                  {
                    headerName: "Amout Receive",
                    field: "amountReceive",
                    filter: "agTextColumnFilter",
                    width: 186,
                    sortingOrder: ["asc"]
                  },
                  {
                    headerName: "Fee %",
                    field: "feePercent",
                    filter: "agNumberColumnFilter",
                    width: 100,
                    valueFormatter: (p: any) =>
                      (p.value === undefined || p.value === null) ? '0' : `${p.value}%`
                  },
                  {
                    headerName: "Fee Earned",
                    field: "feeAmount",
                    filter: "agNumberColumnFilter",
                    width: 130,
                    valueFormatter: (p: any) =>
                      (Number(p.value) || 0).toFixed(2)
                  },
                  {
                    headerName: "Date",
                    field: "date",
                    filter: "agTextColumnFilter",
                    width: 186
                  },
                  {
                    headerName: "Sending Country",
                    field: "sendingCountry",
                    filter: "agTextColumnFilter",
                    width: 150
                  },
                  {
                    headerName: "Receiving Country",
                    field: "receivingCountry",
                    filter: "agTextColumnFilter",
                    width: 150
                  },
                  {
                    headerName: "Receiver Number",
                    field: "receiverNumber",
                    filter: "agTextColumnFilter",
                    width: 150
                  },
                  {
                    headerName: "receivingMethod",
                    field: "receivingMethod",
                    filter: "agTextColumnFilter",
                    width: 150
                  },
                  {
                    headerName: "Sender Number",
                    field: "senderNumber",
                    filter: "agTextColumnFilter",
                    width: 150
                  },
                  // Fusionne les deux booléens bruts (isMarketPlace,
                  // isPostWoner) en une valeur lisible et filtrable : c'est
                  // la distinction que l'admin cherche en premier.
                  {
                    headerName: "Origine",
                    colId: "origin",
                    valueGetter: (params: any) => this.transactionOrigin(params.data),
                    filter: "agTextColumnFilter",
                    width: 190,
                    cellRenderer: (params: any) => {
                      const label = params.value || '';
                      const cls = ManageTransactionsComponent.isMarketplaceRow(params.data)
                        ? 'mtx-origin mtx-origin--marketplace'
                        : 'mtx-origin mtx-origin--direct';
                      return '<span class="' + cls + '">' + label + '</span>';
                    }
                  },
                  {
                    headerName: "Expires At",
                    field: "expires_at",
                    filter: "agTextColumnFilter",
                    width: 150
                  },
                  {
                    headerName: "Post",
                    field: "postId",
                    width: 110,
                    filter: false,
                    sortable: false,
                    cellRenderer: (params: any) => {
                      if (!params.data?.isMarketPlace || !params.data?.postId) return '';
                      return '<button class="btn btn-sm btn-outline-primary" style="padding: 2px 10px;">View Post</button>';
                    },
                    onCellClicked: (params: any) => {
                      if (params.data?.isMarketPlace && params.data?.postId) {
                        this.openPostDetailModal(params.data);
                      }
                    }
                  }
                ];

                this.columnDefsXs = [
            
                  {
                    headerName: "Transaction code",
                    field: "id",
                    width: 150,
                    filter: "agTextColumnFilter",
                    sortingOrder: ["asc","desc"]
                  },
                  {
                    headerName: "Receiver",
                    field: "receiver",
                    filter: 'agTextColumnFilter',
                    width: 150
                  },
                  {
                    headerName: "Amout Send",
                    field: "amountSend",
                    filter: "agTextColumnFilter",
                    width: 150,
                    sortingOrder: ["asc",null]
                  },
                  {
                    headerName: "Amout Receive",
                    field: "amountReceive",
                    filter: "agTextColumnFilter",
                    width: 150,
                    sortingOrder: ["asc"]
                  },
                  {
                    headerName: "Fee Earned",
                    field: "feeAmount",
                    filter: "agNumberColumnFilter",
                    width: 130,
                    valueFormatter: (p: any) =>
                      (Number(p.value) || 0).toFixed(2)
                  },
                  {
                    headerName: "Date",
                    field: "date",
                    width: 150
                  },
                  {
                    headerName: "Status",
                    field: "status",
                    cellClassRules: cellClassRules,
                    filter: "agTextColumnFilter",
                    width: 150
                  },
                  {
                    headerName: "Sending Country",
                    field: "sendingCountry",
                    filter: "agTextColumnFilter",
                    width: 150
                  },
                  {
                    headerName: "Receiving Country",
                    field: "receivingCountry",
                    filter: "agTextColumnFilter",
                    width: 150
                  },
                  {
                    headerName: "Receiver Number",
                    field: "receiverNumber",
                    filter: "agTextColumnFilter",
                    width: 150
                  },
                  {
                    headerName: "Sender Number",
                    field: "senderNumber",
                    filter: "agTextColumnFilter",
                    width: 150
                  },
                  {
                    headerName: "Post",
                    field: "postId",
                    width: 110,
                    filter: false,
                    sortable: false,
                    cellRenderer: (params: any) => {
                      if (!params.data?.isMarketPlace || !params.data?.postId) return '';
                      return '<button class="btn btn-sm btn-outline-primary" style="padding: 2px 10px;">View</button>';
                    },
                    onCellClicked: (params: any) => {
                      if (params.data?.isMarketPlace && params.data?.postId) {
                        this.openPostDetailModal(params.data);
                      }
                    }
                  }
                ];
                this.sortingOrder = ["desc", "asc", null];
            
                this.frameworkComponents = {
                  editRenderer: EditRendererComponent,
                  deleteRenderer: DeleteTransactionComponent,
                  customizedCell: CustomizedCellComponentComponent
                }

                // ── KYC COLUMN DEFS ──
                const kycCellClassRules = {
                  "cell-verified": params => params.value === 'verified',
                  "cell-rejected": params => params.value === 'rejected',
                  "cell-pending": params => params.value === 'pending'
                };

                this.kycColumnDefs = [
                  {
                    headerName: "User Email",
                    field: "userEmail",
                    width: 220,
                    filter: "agTextColumnFilter",
                    sortingOrder: ["asc","desc"]
                  },
                  {
                    headerName: "Name",
                    field: "extractedName",
                    width: 160,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Document #",
                    field: "extractedDocumentNumber",
                    width: 160,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Status",
                    field: "status",
                    cellClassRules: kycCellClassRules,
                    filter: "agTextColumnFilter",
                    width: 130
                  },
                  {
                    headerName: "Attempt",
                    field: "attemptNumber",
                    width: 110,
                    filter: "agNumberColumnFilter",
                    valueFormatter: (params) =>
                      params.value
                        ? `#${params.value} / ${params.data.totalAttempts}`
                        : ''
                  },
                  {
                    headerName: "Submitted",
                    field: "submittedAt",
                    width: 180,
                    filter: "agTextColumnFilter",
                    valueFormatter: (params) => {
                      if (!params.value) return '';
                      return new Date(params.value).toLocaleDateString('fr-FR', {
                        day: '2-digit', month: '2-digit', year: 'numeric',
                        hour: '2-digit', minute: '2-digit'
                      });
                    }
                  },
                  {
                    headerName: "Verified At",
                    field: "verifiedAt",
                    width: 180,
                    filter: "agTextColumnFilter",
                    valueFormatter: (params) => {
                      if (!params.value) return '';
                      return new Date(params.value).toLocaleDateString('fr-FR', {
                        day: '2-digit', month: '2-digit', year: 'numeric',
                        hour: '2-digit', minute: '2-digit'
                      });
                    }
                  },
                  {
                    headerName: "Rejection Reason",
                    field: "rejectionReason",
                    width: 200,
                    filter: "agTextColumnFilter"
                  }
                ];

                this.complianceColumnDefs = [
                  {
                    headerName: "Email",
                    field: "userEmail",
                    width: 220,
                    filter: "agTextColumnFilter",
                    sortingOrder: ["asc","desc"]
                  },
                  {
                    headerName: "Type",
                    field: "kind",
                    width: 120,
                    filter: "agTextColumnFilter",
                    valueFormatter: (params) => ({
                      direct: 'Transfert', post: 'Annonce', offer: 'Offre',
                    })[params.value] || params.value || ''
                  },
                  {
                    headerName: "Montant",
                    field: "amount",
                    width: 150,
                    filter: "agNumberColumnFilter",
                    valueFormatter: (params) =>
                      params.value == null ? '' : `${params.value} ${params.data.currency || ''}`
                  },
                  {
                    headerName: "Statut",
                    field: "status",
                    width: 130,
                    filter: "agTextColumnFilter",
                    cellClassRules: kycCellClassRules
                  },
                  {
                    headerName: "Profession",
                    field: "profession",
                    width: 160,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Source des fonds",
                    field: "sourceOfFunds",
                    width: 200,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Soumis le",
                    field: "submittedAt",
                    width: 180,
                    filter: "agTextColumnFilter",
                    valueFormatter: (params) => {
                      if (!params.value) return '';
                      return new Date(params.value).toLocaleDateString('fr-FR', {
                        day: '2-digit', month: '2-digit', year: 'numeric',
                        hour: '2-digit', minute: '2-digit'
                      });
                    }
                  },
                  {
                    headerName: "Décidé par",
                    field: "decidedBy",
                    width: 200,
                    filter: "agTextColumnFilter"
                  },
                  {
                    // Doubles as the settlement error when status is 'failed'.
                    headerName: "Motif / erreur",
                    field: "rejectionReason",
                    width: 240,
                    filter: "agTextColumnFilter"
                  }
                ];

                this.kycColumnDefsXs = [
                  {
                    headerName: "Email",
                    field: "userEmail",
                    width: 150,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Status",
                    field: "status",
                    cellClassRules: kycCellClassRules,
                    filter: "agTextColumnFilter",
                    width: 100
                  },
                  {
                    headerName: "Attempt",
                    field: "attemptNumber",
                    width: 90,
                    filter: "agNumberColumnFilter",
                    valueFormatter: (params) =>
                      params.value
                        ? `#${params.value} / ${params.data.totalAttempts}`
                        : ''
                  },
                  {
                    headerName: "Name",
                    field: "extractedName",
                    width: 120,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Submitted",
                    field: "submittedAt",
                    width: 130,
                    filter: "agTextColumnFilter"
                  }
                ];

                // ── MESSAGES COLUMN DEFS ──
                const msgActiveCellClassRules = {
                  "cell-verified": params => params.value === true,
                  "cell-rejected": params => params.value === false
                };

                this.messagesColumnDefs = [
                  {
                    headerName: "Message (EN)",
                    field: "messageEn",
                    width: 280,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Message (FR)",
                    field: "messageFr",
                    width: 280,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Type",
                    field: "type",
                    width: 100,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Target User",
                    field: "targetUserEmail",
                    width: 220,
                    filter: "agTextColumnFilter",
                    valueFormatter: params => params.value || 'All Users'
                  },
                  {
                    headerName: "Active",
                    field: "isActive",
                    width: 100,
                    cellClassRules: msgActiveCellClassRules,
                    valueFormatter: params => params.value ? 'Yes' : 'No'
                  },
                  {
                    headerName: "Created",
                    field: "createdAt",
                    width: 180,
                    filter: "agTextColumnFilter",
                    valueFormatter: (params) => {
                      if (!params.value) return '';
                      return new Date(params.value).toLocaleDateString('fr-FR', {
                        day: '2-digit', month: '2-digit', year: 'numeric',
                        hour: '2-digit', minute: '2-digit'
                      });
                    }
                  }
                ];

                // ── WALLETS COLUMN DEFS ──
                this.walletColumnDefs = [
                  {
                    headerName: "User Email",
                    field: "usersEmail",
                    width: 240,
                    filter: "agTextColumnFilter",
                    sortingOrder: ["asc", "desc"]
                  },
                  {
                    headerName: "Currency",
                    field: "currency",
                    width: 100,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Country",
                    field: "countryCode",
                    width: 100,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Balance",
                    field: "amount",
                    width: 130,
                    filter: "agNumberColumnFilter",
                    sortingOrder: ["desc", "asc"],
                    valueFormatter: (params) => {
                      const val = params.value ?? 0;
                      return Number(val).toLocaleString('fr-FR', { minimumFractionDigits: 2 });
                    }
                  },
                  {
                    headerName: "Interac / Mobile Money",
                    field: "interacPhone",
                    width: 220,
                    filter: "agTextColumnFilter",
                    valueFormatter: (params) => {
                      return params.value || params.data?.mobileMoney || '—';
                    }
                  },
                  {
                    headerName: "Interac Full Name",
                    field: "interacFullName",
                    width: 180,
                    filter: "agTextColumnFilter",
                    valueFormatter: (params) => params.value || '—'
                  },
                  {
                    headerName: "Interac Alias",
                    field: "interacAlias",
                    width: 240,
                    filter: "agTextColumnFilter",
                    valueFormatter: (params) => {
                      return params.value ? `${params.value}@${this.interacAliasDomain}` : '—';
                    }
                  },
                  {
                    headerName: "MoMo Code",
                    field: "momoCode",
                    width: 130,
                    filter: "agTextColumnFilter",
                    valueFormatter: (params) => params.value || '—'
                  },
                  {
                    headerName: "Label",
                    field: "label",
                    width: 120,
                    filter: "agTextColumnFilter"
                  }
                ];

                // ── INTERAC EMAILS COLUMN DEFS ──
                const interacStatusCellClassRules = {
                  "cell-pass": params => params.value === 'processed',
                  "cell-fail": params => params.value === 'ignored',
                  "cell-pending": params => params.value === 'new'
                };

                this.interacColumnDefs = [
                  {
                    headerName: "Received Alias",
                    field: "receivedAlias",
                    width: 160,
                    filter: "agTextColumnFilter",
                    valueFormatter: (params) => params.value || '—'
                  },
                  {
                    headerName: "From",
                    field: "from",
                    width: 220,
                    filter: "agTextColumnFilter",
                    sortingOrder: ["asc", "desc"]
                  },
                  {
                    headerName: "User Email",
                    field: "userEmail",
                    width: 220,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "User Phone",
                    field: "userPhone",
                    width: 160,
                    filter: "agTextColumnFilter",
                    valueFormatter: (params) => params.value || '—'
                  },
                  {
                    headerName: "Sender Name",
                    field: "senderName",
                    width: 160,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Sender Full Name",
                    field: "senderFullName",
                    width: 180,
                    filter: "agTextColumnFilter",
                    valueFormatter: (params) => params.value || '—'
                  },
                  {
                    headerName: "Sender Email (body)",
                    field: "senderEmailFromBody",
                    width: 220,
                    filter: "agTextColumnFilter",
                    valueFormatter: (params) => params.value || '—'
                  },
                  {
                    headerName: "Reference #",
                    field: "referenceNumber",
                    width: 140,
                    filter: "agTextColumnFilter",
                    valueFormatter: (params) => params.value || '—'
                  },
                  {
                    headerName: "Subject",
                    field: "subject",
                    width: 300,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Amount",
                    field: "amount",
                    width: 120,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Date",
                    field: "date",
                    width: 180,
                    filter: "agTextColumnFilter",
                    sort: 'desc',
                    valueFormatter: (params) => {
                      if (!params.value) return '';
                      return new Date(params.value).toLocaleDateString('fr-FR', {
                        day: '2-digit', month: '2-digit', year: 'numeric',
                        hour: '2-digit', minute: '2-digit'
                      });
                    }
                  },
                  {
                    headerName: "Status",
                    field: "status",
                    cellClassRules: interacStatusCellClassRules,
                    filter: "agTextColumnFilter",
                    width: 120,
                    valueFormatter: params => (params.value || '').toUpperCase()
                  },
                  {
                    headerName: "Snippet",
                    field: "snippet",
                    width: 300,
                    filter: "agTextColumnFilter"
                  }
                ];

                // ── MOMO DEPOSITS COLUMN DEFS ──
                const momoStatusCellClassRules = {
                  "cell-pass": params => params.value === 'approved',
                  "cell-fail": params => params.value === 'rejected',
                  "cell-pending": params => params.value === 'pending'
                };

                // Le libellé des issues et des catégories est traduit ici; le serveur, lui,
    // ne stocke que des identifiants stables (money_event.js).
    this.moneyEventColumnDefs = [
      { headerName: "Date", field: "createdAtIso", width: 155, filter: "agTextColumnFilter", sort: 'desc',
        valueFormatter: (params) => {
          if (!params.value) return '';
          return new Date(params.value).toLocaleDateString('fr-FR',
            {day:'2-digit',month:'2-digit',year:'2-digit',hour:'2-digit',minute:'2-digit'});
        } },
      { headerName: "Source", field: "source", width: 100, filter: "agTextColumnFilter",
        valueFormatter: (params) => ({
          server: 'Serveur', trigger: 'Mouvement', client: 'Client (déclaré)',
        }[params.value] || params.value || '') },
      { headerName: "Opération", field: "action", width: 165, filter: "agTextColumnFilter",
        valueFormatter: (params) => ({
          direct_transfer: 'Virement direct', marketplace_accept: 'Offre acceptée',
          interac_credit: 'Crédit Interac', interac_reverse: 'Annulation Interac',
          momo_credit: 'Crédit MoMo', momo_reverse: 'Annulation MoMo',
          balance_delta: 'Solde modifié', pay_pool_delta: 'Réserve modifiée',
        }[params.value] || params.value || '') },
      { headerName: "Résultat", field: "outcome", width: 125, filter: "agTextColumnFilter",
        valueFormatter: (params) => ({
          success: '✅ Réussi', refused: '⛔ Refusé', error: '💥 Erreur',
          held: '⏸ En revue', replayed: '↩︎ Rejeu', observed: '👁 Observé',
          unknown: '❔ Inconnu',
        }[params.value] || params.value || '') },
      { headerName: "Montant", field: "amountDisplay", width: 140, filter: "agTextColumnFilter" },
      { headerName: "Client", field: "userEmail", width: 210, filter: "agTextColumnFilter" },
      { headerName: "Contrepartie", field: "counterpartyEmail", width: 200, filter: "agTextColumnFilter" },
      { headerName: "Motif", field: "refusalCategory", width: 150, filter: "agTextColumnFilter",
        valueFormatter: (params) => this.refusalLabel(params.value) },
      { headerName: "Détail", field: "failureReason", width: 260, filter: "agTextColumnFilter" },
      // Une ligne "Non attribué" = un solde a bougé sans qu'aucune fonction ne
      // signe. C'est ainsi que la modification manuelle du tableau de bord,
      // qui ne laisse aucune autre trace, se dénonce.
      { headerName: "Attribution", field: "attribution", width: 130, filter: "agTextColumnFilter",
        valueFormatter: (params) => params.value === 'unattributed' ? '⚠️ Non attribué' : '' },
      { headerName: "Vérité serveur", field: "serverTruth", width: 135, filter: "agTextColumnFilter",
        valueFormatter: (params) => ({
          settled: 'Réglé', not_settled: 'Non réglé', unknown: '',
        }[params.value] || '') },
      { headerName: "Signalé ×", field: "reportCount", width: 100, filter: "agNumberColumnFilter" },
      { headerName: "Corrélation", field: "correlationId", width: 200, filter: "agTextColumnFilter" },
    ];

    // Bank deposits. Same review flow as MoMo, different identifying field:
    // a free-text reference the customer put on the wire, not an operator
    // transaction id.
    this.bankDepositColumnDefs = [
      {
        headerName: "Déclaré le",
        field: "submittedAt",
        width: 160,
        filter: "agTextColumnFilter",
        sort: 'desc',
        valueFormatter: (params) => {
          if (!params.value) return '';
          return new Date(params.value).toLocaleDateString('fr-FR', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
          });
        }
      },
      {
        headerName: "Pays",
        field: "countryCode",
        width: 90,
        filter: "agTextColumnFilter",
        valueFormatter: (params) => {
          const c = this.countryCatalogue.find(x => x.iso === params.value);
          return c ? c.label : (params.value || '—');
        }
      },
      {
        headerName: "Montant",
        field: "amount",
        width: 140,
        filter: "agNumberColumnFilter",
        valueFormatter: (params) => {
          const val = params.value ?? 0;
          // Never default to XAF here: these wallets are GBP/EUR/CNY, and a
          // wrong currency beside a number is worse than no currency at all.
          const currency = params.data?.currency || '';
          return `${Number(val).toLocaleString('fr-FR')} ${currency}`.trim();
        }
      },
      {
        headerName: "Référence",
        field: "reference",
        width: 220,
        filter: "agTextColumnFilter"
      },
      {
        headerName: "Compte client",
        field: "walletEmail",
        width: 220,
        filter: "agTextColumnFilter"
      },
      {
        headerName: "Émetteur",
        field: "senderName",
        width: 180,
        filter: "agTextColumnFilter",
        valueFormatter: (params) => params.value || '—'
      },
      {
        headerName: "Statut",
        field: "status",
        width: 120,
        filter: "agTextColumnFilter",
        valueFormatter: (params) => {
          if (params.value === 'approved') return 'Crédité';
          if (params.value === 'rejected') return 'Rejeté';
          return 'En attente';
        }
      },
      {
        headerName: "Motif du rejet",
        field: "rejectReason",
        width: 240,
        filter: "agTextColumnFilter",
        valueFormatter: (params) => params.value || '—'
      },
      {
        headerName: "Note du client",
        field: "note",
        width: 240,
        filter: "agTextColumnFilter",
        valueFormatter: (params) => params.value || '—'
      },
    ];

    this.momoColumnDefs = [
                  {
                    headerName: "Submitted",
                    field: "submittedAt",
                    width: 160,
                    filter: "agTextColumnFilter",
                    sort: 'desc',
                    valueFormatter: (params) => {
                      if (!params.value) return '';
                      return new Date(params.value).toLocaleDateString('fr-FR', {
                        day: '2-digit', month: '2-digit', year: 'numeric',
                        hour: '2-digit', minute: '2-digit'
                      });
                    }
                  },
                  {
                    headerName: "Operator",
                    field: "operator",
                    width: 110,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Amount",
                    field: "amount",
                    width: 130,
                    filter: "agNumberColumnFilter",
                    valueFormatter: (params) => {
                      const val = params.value ?? 0;
                      const currency = params.data?.currency || 'XAF';
                      return `${Number(val).toLocaleString('fr-FR')} ${currency}`;
                    }
                  },
                  {
                    headerName: "Transaction ID",
                    field: "transactionId",
                    width: 200,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Wallet Email",
                    field: "walletEmail",
                    width: 220,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "MoMo Code",
                    field: "momoCode",
                    width: 120,
                    filter: "agTextColumnFilter",
                    valueFormatter: (params) => params.value || '—'
                  },
                  {
                    headerName: "Sender",
                    field: "senderPhone",
                    width: 160,
                    filter: "agTextColumnFilter",
                    valueFormatter: (params) => params.value || '—'
                  },
                  {
                    headerName: "Status",
                    field: "status",
                    cellClassRules: momoStatusCellClassRules,
                    filter: "agTextColumnFilter",
                    width: 120,
                    valueFormatter: params => (params.value || '').toUpperCase()
                  },
                  {
                    headerName: "Note",
                    field: "note",
                    width: 240,
                    filter: "agTextColumnFilter",
                    valueFormatter: (params) => params.value || ''
                  }
                ];

                // ── ISSUES COLUMN DEFS ──
                const issueStatusCellClassRules = {
                  "cell-pass": params => params.value === 'resolved',
                  "cell-fail": params => params.value === 'ignored',
                  "cell-pending": params => params.value === 'new'
                };

                this.issuesColumnDefs = [
                  {
                    headerName: "From",
                    field: "from",
                    width: 220,
                    filter: "agTextColumnFilter",
                    sortingOrder: ["asc", "desc"]
                  },
                  {
                    headerName: "Sender Name",
                    field: "senderName",
                    width: 160,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Subject",
                    field: "subject",
                    width: 300,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Date",
                    field: "date",
                    width: 180,
                    filter: "agTextColumnFilter",
                    sort: 'desc',
                    valueFormatter: (params) => {
                      if (!params.value) return '';
                      return new Date(params.value).toLocaleDateString('fr-FR', {
                        day: '2-digit', month: '2-digit', year: 'numeric',
                        hour: '2-digit', minute: '2-digit'
                      });
                    }
                  },
                  {
                    headerName: "Status",
                    field: "status",
                    cellClassRules: issueStatusCellClassRules,
                    filter: "agTextColumnFilter",
                    width: 120,
                    valueFormatter: params => (params.value || '').toUpperCase()
                  },
                  {
                    headerName: "Snippet",
                    field: "snippet",
                    width: 300,
                    filter: "agTextColumnFilter"
                  }
                ];

                // ── DEPOSIT ISSUES COLUMN DEFS ──
                const depositIssueStatusCellClassRules = {
                  "cell-pass": params => params.value === 'resolved',
                  "cell-fail": params => params.value === 'ignored',
                  "cell-pending": params => params.value === 'new'
                };

                this.depositIssuesColumnDefs = [
                  {
                    headerName: "User",
                    field: "userEmail",
                    width: 220,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Type",
                    field: "depositType",
                    width: 140,
                    filter: "agTextColumnFilter",
                    valueFormatter: params =>
                      params.value === 'interac' ? 'INTERAC' :
                      params.value === 'mobile_money' ? 'Mobile Money' : (params.value || '')
                  },
                  {
                    headerName: "Country",
                    field: "countryCode",
                    width: 100,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Sender Contact",
                    field: "senderContact",
                    width: 220,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Message",
                    field: "message",
                    width: 300,
                    filter: "agTextColumnFilter",
                    valueFormatter: params => {
                      const v = params.value || '';
                      return v.length > 80 ? v.slice(0, 80) + '…' : v;
                    }
                  },
                  {
                    headerName: "Attachments",
                    field: "attachmentCount",
                    width: 110
                  },
                  {
                    headerName: "Date",
                    field: "date",
                    width: 180,
                    filter: "agTextColumnFilter",
                    sort: 'desc',
                    valueFormatter: (params) => {
                      if (!params.value) return '';
                      return new Date(params.value).toLocaleDateString('fr-FR', {
                        day: '2-digit', month: '2-digit', year: 'numeric',
                        hour: '2-digit', minute: '2-digit'
                      });
                    }
                  },
                  {
                    headerName: "Status",
                    field: "status",
                    cellClassRules: depositIssueStatusCellClassRules,
                    filter: "agTextColumnFilter",
                    width: 120,
                    valueFormatter: params => (params.value || '').toUpperCase()
                  }
                ];

                // ── FOREIGN BILL PAYMENT REQUESTS COLUMN DEFS ──
                const foreignBillCellClassRules = {
                  "cell-pending": params => params.value === 'pending',
                  "cell-verified": params => params.value === 'paid' || params.value === 'reimbursed',
                  "cell-rejected": params => params.value === 'rejected',
                };

                this.foreignBillsColumnDefs = [
                  {
                    headerName: "User Email",
                    field: "userEmail",
                    width: 220,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Bill Type",
                    field: "billType",
                    width: 130,
                    valueFormatter: params => {
                      switch ((params.value || '').toString()) {
                        case 'tuition': return 'Tuition';
                        case 'subscription': return 'Subscription';
                        case 'service': return 'Service';
                        case 'other': return 'Other';
                        default: return params.value;
                      }
                    }
                  },
                  {
                    headerName: "Provider",
                    field: "providerName",
                    width: 200,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Reference",
                    field: "accountReference",
                    width: 160
                  },
                  {
                    headerName: "Amount",
                    field: "amount",
                    width: 120,
                    valueFormatter: params => params.value != null ? `${Number(params.value).toFixed(2)} CAD` : ''
                  },
                  {
                    headerName: "Commission",
                    field: "commission",
                    width: 130,
                    valueFormatter: params => params.value != null ? `${Number(params.value).toFixed(2)} CAD` : ''
                  },
                  {
                    headerName: "Total",
                    field: "estimatedTotal",
                    width: 120,
                    valueFormatter: params => params.value != null ? `${Number(params.value).toFixed(2)} CAD` : ''
                  },
                  {
                    headerName: "Reimburse via",
                    field: "reimbursementMethod",
                    width: 140,
                    valueFormatter: params => {
                      switch ((params.value || '').toString()) {
                        case 'mobile_money': return 'Mobile Money';
                        case 'interac': return 'Interac';
                        case 'cash': return 'Cash';
                        default: return params.value;
                      }
                    }
                  },
                  {
                    headerName: "Due",
                    field: "dueDate",
                    width: 120
                  },
                  {
                    headerName: "Status",
                    field: "status",
                    cellClassRules: foreignBillCellClassRules,
                    width: 130
                  },
                  {
                    headerName: "Created",
                    field: "createdAt",
                    width: 170,
                    sort: 'desc',
                    valueFormatter: (params) => {
                      const v = params.value;
                      if (!v) return '';
                      // Firestore Timestamp or ISO string
                      const d = v && typeof v.toDate === 'function' ? v.toDate() : new Date(v);
                      if (isNaN(d.getTime())) return '';
                      return d.toLocaleDateString('fr-FR', {
                        day: '2-digit', month: '2-digit', year: 'numeric',
                        hour: '2-digit', minute: '2-digit'
                      });
                    }
                  }
                ];

                // ── NOTIFICATIONS COLUMN DEFS ──
                this.notificationColumnDefs = [
                  {
                    headerName: "Title",
                    field: "title",
                    width: 220,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Message",
                    field: "body",
                    width: 300,
                    filter: "agTextColumnFilter"
                  },
                  {
                    headerName: "Target",
                    field: "targetEmail",
                    width: 220,
                    filter: "agTextColumnFilter",
                    valueFormatter: params => params.value === 'all' ? 'All Users' : params.value
                  },
                  {
                    headerName: "Sent At",
                    field: "sentAt",
                    width: 180,
                    filter: "agTextColumnFilter",
                    sort: 'desc',
                    valueFormatter: (params) => {
                      if (!params.value) return '';
                      return new Date(params.value).toLocaleDateString('fr-FR', {
                        day: '2-digit', month: '2-digit', year: 'numeric',
                        hour: '2-digit', minute: '2-digit'
                      });
                    }
                  },
                  {
                    headerName: "Success",
                    field: "successCount",
                    width: 100
                  },
                  {
                    headerName: "Failed",
                    field: "failureCount",
                    width: 100
                  },
                  {
                    headerName: "Total",
                    field: "totalTokens",
                    width: 100
                  }
                ];

  }

  onClickEdit(params) {
    //code ne fonstionne pas encore, faudrait trouver comment le faire 
  }
    
  onClickDelete(params) {
      //code ne fonstionne pas encore, faudrait trouver comment le faire
  }

  onClickSelected(params) {
 //code ne fonstionne pas encore, faudrait trouver comment le faire
  }

  onSelectionChanged(event: SelectionChangedEvent) {
  
    const selectedData = this.gridApi.getSelectedRows();
  }

  unsuscribe(): void {
    if(this.getavailablePaySuscribtions) {
      this.getavailablePaySuscribtions.unsubscribe();
    }
    if(this.kycSubscription) {
      this.kycSubscription.unsubscribe();
    }
    if(this.messagesSubscription) {
      this.messagesSubscription.unsubscribe();
    }
    if(this.feesSubscription) {
      this.feesSubscription.unsubscribe();
    }
    if(this.ratesSubscription) {
      this.ratesSubscription.unsubscribe();
    }
    if(this.rateLimitsSubscription) {
      this.rateLimitsSubscription.unsubscribe();
    }
    if(this.maintenanceSubscription) {
      this.maintenanceSubscription.unsubscribe();
    }
    if(this.companySubscription) {
      this.companySubscription.unsubscribe();
    }
    if(this.privacySubscription) {
      this.privacySubscription.unsubscribe();
    }
    if(this.limitsSubscription) {
      this.limitsSubscription.unsubscribe();
    }
    if(this.countriesSubscription) {
      this.countriesSubscription.unsubscribe();
    }
    if(this.depositRailsSubscription) {
      this.depositRailsSubscription.unsubscribe();
    }
    if(this.corridorsSubscription) {
      this.corridorsSubscription.unsubscribe();
    }
    if(this.marketplaceConfigSubscription) {
      this.marketplaceConfigSubscription.unsubscribe();
    }
    if(this.complianceSubscription) {
      this.complianceSubscription.unsubscribe();
    }
    if(this.walletSubscription) {
      this.walletSubscription.unsubscribe();
    }
    if(this.interacSubscription) {
      this.interacSubscription.unsubscribe();
    }
    if(this.postsSubscription) {
      this.postsSubscription.unsubscribe();
    }
    if(this.propositionsSubscription) {
      this.propositionsSubscription.unsubscribe();
    }
    if(this.marketTxSubscription) {
      this.marketTxSubscription.unsubscribe();
    }
    if(this.bankDepositSubscription) {
      this.bankDepositSubscription.unsubscribe();
    }
    if(this.momoSubscription) {
      this.momoSubscription.unsubscribe();
    }
    if(this.issuesSubscription) {
      this.issuesSubscription.unsubscribe();
    }
    if(this.depositIssuesSubscription) {
      this.depositIssuesSubscription.unsubscribe();
    }
    if(this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }
    if(this.usersSubscription) {
      this.usersSubscription.unsubscribe();
    }
    if(this.foreignBillsSubscription) {
      this.foreignBillsSubscription.unsubscribe();
    }
    if(this.interacConfigSubscription) {
      this.interacConfigSubscription.unsubscribe();
    }
    if(this.momoConfigSubscription) {
      this.momoConfigSubscription.unsubscribe();
    }
  }

  onGridReady(params) {
    this.params = params;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if (!this.transactionsLoaded) { this.getTransactions(localStorage.getItem('user')); }

  }

  getTransactions(email: string) {

    this.transactionsLoaded = true;
    this.data._getAlltransactions().subscribe(res => {
      let transactionsList = [];
      this.allTransactionsList = res.map((e: any) => {
        const data = e.payload.doc.data();
        data.id = e.payload.doc.id;
        transactionsList.push(data);
        return data;
      });
      this._applyTransactionRowData(transactionsList);
      this.recomputeDashboard();
    }, err => {
      console.log('Error while fetching Transactions data');
    })
  }

  // Point de passage unique des mises à jour de la grille des transactions :
  // le filtre d'origine reste appliqué même quand le flux Firestore réémet.
  private _applyTransactionRowData(rows: any[]) {
    this.rowData = rows;
    this.marketplaceCount = rows
      .filter(r => ManageTransactionsComponent.isMarketplaceRow(r)).length;
    this.directCount = rows.length - this.marketplaceCount;
    this.applyTransactionsGrid();
  }

  ngOnDestroy() {
    this.unsuscribe();
    // Rend son en-tête et son pied au site public.
    document.body.classList.remove(BODY_CLASS);
  }

  // ── COQUE DE L'ESPACE ADMIN ──────────────────────────────────────────

  /** Quitte l'espace admin pour la page d'accueil du site. */
  backToSite(): void {
    this.router.navigate(['/']);
  }

  logout(): void {
    this.firebase.logOut();
    this.router.navigate(['/']);
  }

  // ── CHARGEMENT PARESSEUX ─────────────────────────────────────────────
  // Chaque écran ouvre son propre flux, et seulement au moment où on
  // l'ouvre. Ouvrir la page ne coûte donc qu'une requête (le solde), au
  // lieu des dix collections que représente l'espace complet.
  //
  // Les flux Firestore sont temps réel : une fois ouverts ils restent
  // vivants, d'où la garde sur la souscription — revenir sur un écran ne
  // re-souscrit pas. L'affichage, lui, passe par le binding [rowData] :
  // la grille se resynchronise toute seule quand le *ngIf la recrée.

  /** Ouvre le flux de l'écran demandé s'il ne l'est pas déjà. */
  private loadFor(tab: AdminTab): void {
    switch (tab) {
      case 'transactions':
        if (!this.transactionsLoaded) { this.getTransactions(localStorage.getItem('user')); }
        break;
      case 'kyc':
        if (!this.kycSubscription) { this.getKycVerifications(); }
        break;
      case 'compliance':
        if (!this.complianceSubscription) { this.getComplianceReviews(); }
        break;
      case 'messages':
        if (!this.messagesSubscription) { this.getAdminMessages(); }
        break;
      case 'wallets':
        if (!this.walletSubscription) { this.getWalletAccounts(); }
        break;
      case 'interac':
        if (!this.interacSubscription) { this.getInteracEmails(); }
        // Les emails Interac s'enrichissent de l'email du portefeuille et du
        // téléphone de l'utilisateur : ces deux flux leur sont nécessaires.
        if (!this.walletSubscription) { this.getWalletAccounts(); }
        if (!this.usersSubscription) { this.loadUserEmails(); }
        break;
      case 'money_events':
        // One-shot, not a stream: see data.service.getRecentMoneyEvents.
        if (!this.moneyEventRowData.length) { this.loadRecentMoneyEvents(); }
        break;
      case 'momo':
        if (!this.momoSubscription) { this.getMomoDeposits(); }
        // Le portefeuille cible est résolu à l'approbation ou au rejet.
        if (!this.walletSubscription) { this.getWalletAccounts(); }
        break;
      case 'bank_deposits':
        if (!this.bankDepositSubscription) { this.getBankDeposits(); }
        // Pas de chargement des portefeuilles ici : creditBankDeposit résout
        // le portefeuille depuis le walletId du dépôt, côté serveur.
        break;
      case 'marketplace':
        if (!this.postsSubscription) { this.loadMarketplace(); }
        // Le téléphone de l'offreur vient de la collection users (même patron
        // que l'onglet Interac).
        if (!this.usersSubscription) { this.loadUserEmails(); }
        break;
      case 'issues':
        if (!this.issuesSubscription) { this.getIssueReports(); }
        break;
      case 'deposit_issues':
        if (!this.depositIssuesSubscription) { this.getDepositIssueReports(); }
        break;
      case 'notifications':
        if (!this.notificationSubscription) { this.getNotifications(); }
        if (!this.usersSubscription) { this.loadUserEmails(); }
        break;
      case 'foreign_bills':
        if (!this.foreignBillsSubscription) { this.getForeignBillPaymentRequests(); }
        break;
    }
  }

  /**
   * Vrai quand TOUTES les sources du tableau de bord sont lues — pas « au moins
   * une ».
   *
   * C'est devenu porteur : la liste « À traiter » n'affiche plus seulement les
   * files non vides, elle affiche aussi les zéros. Avec l'ancien « ou », un
   * admin ayant simplement ouvert l'onglet KYC voyait dix lignes à « 0 » qui
   * affirmaient « rien en attente », alors que la vérité était « rien n'est
   * chargé ». Un getter de neuf lectures booléennes, sans allocation — rien à
   * voir avec les getters de tableaux que le commentaire plus bas proscrit.
   */
  get statsLoaded(): boolean {
    return this.transactionsLoaded
      && !!this.walletSubscription
      && !!this.kycSubscription
      && !!this.complianceSubscription
      && !!this.interacSubscription
      && !!this.momoSubscription
      && !!this.bankDepositSubscription
      && !!this.issuesSubscription
      && !!this.depositIssuesSubscription
      && !!this.foreignBillsSubscription
      && !!this.notificationSubscription;
  }

  /**
   * Charge en une fois tout ce qu'affiche le tableau de bord. Déclenché par
   * l'admin, jamais à l'ouverture de la page : ces dix collections sont
   * précisément ce qu'on veut éviter de payer au chargement.
   */
  loadDashboardStats(): void {
    ([
      'transactions', 'kyc', 'wallets', 'interac',
      'momo', 'bank_deposits', 'issues', 'deposit_issues', 'foreign_bills',
      // 'compliance' MANQUAIT, alors que « Dossiers conformité à traiter » est
      // la deuxième ligne de la file. Son compteur restait donc à 0 et la ligne
      // n'apparaissait jamais tant qu'on n'ouvrait pas l'onglet à la main.
      'compliance',
    ] as AdminTab[]).forEach(tab => this.loadFor(tab));

    // Directement, PAS via loadFor('notifications') : cette branche ouvre aussi
    // loadUserEmails(), c'est-à-dire toute la collection `users` — précisément
    // le coût que ce bouton existe pour éviter.
    if (!this.notificationSubscription) { this.getNotifications(); }
    // Requête bornée, pas un flux : moneyEvents est un journal en append-only.
    this.refreshMoneyEventErrorCount();
  }

  // ── STATISTIQUES DU TABLEAU DE BORD ──────────────────────────────────
  // Ce sont des CHAMPS, pas des getters, et c'est délibéré : le composant
  // n'est pas en OnPush, donc un getter serait réévalué à chaque cycle de
  // détection. Ceux qui construisent un tableau (files d'attente, totaux)
  // rendraient en prime une référence neuve à chaque passage, obligeant les
  // *ngFor à reconstruire leur DOM en boucle — la page se fige. On les
  // recalcule donc une seule fois, à l'arrivée des données.

  totalTransactions = 0;
  completedTransactions = 0;
  walletCount = 0;
  verifiedKycCount = 0;
  totalPending = 0;

  /** Somme des soldes des portefeuilles, par devise. */
  walletTotals: { currency: string; total: number }[] = [];

  /** Files d'attente non vides, pour la liste « À traiter ». */
  /** Virements en vol. Un ÉTAT, pas une tâche — d'où l'absence de pastille. */
  inFlightTransactionsCount = 0;
  /** Envois push ayant échoué pour au moins un destinataire. */
  failedNotificationsCount = 0;
  /**
   * Échecs techniques du journal des mouvements d'argent.
   *
   * `outcome == 'error'` UNIQUEMENT. Compter aussi les mouvements non attribués
   * rendrait cette file invidable : le bouton « Modifier » du solde disponible
   * en produit un à chaque usage, et une file qu'on ne peut jamais vider
   * apprend à ignorer toute la liste. Les non-attribués restent visibles dans
   * la grille, avec leur propre colonne.
   */
  moneyEventErrorCount = 0;

  pendingQueues: { label: string; count: number; tab: AdminTab }[] = [];

  /** À rappeler à chaque fois qu'un jeu de données change. */
  private recomputeDashboard(): void {
    this.totalTransactions = this.allTransactionsList.length;
    this.completedTransactions = this.allTransactionsList
      .filter((t: any) => t.status === 'COMPLETE').length;

    // Liste blanche explicite, surtout pas `!== 'COMPLETE'` : cela ramasserait
    // REJECTED et INCOMPLETE (des lignes mortes) et surtout AWAITING_REVIEW, qui
    // est la transaction retenue en conformité — la file juste au-dessus la
    // compterait alors deux fois.
    this.inFlightTransactionsCount = this.allTransactionsList
      .filter((t: any) => t.status === 'PENDING' || t.status === 'INPROGRESS').length;
    this.failedNotificationsCount = this.notificationRowData
      .filter((n: any) => (n.failureCount || 0) > 0).length;

    this.walletCount = this.walletRowData.length;
    this.verifiedKycCount = this.kycRowData.filter(k => k.status === 'verified').length;

    const byCurrency = new Map<string, number>();
    this.walletRowData.forEach(w => {
      const currency = w.currency || '—';
      byCurrency.set(currency, (byCurrency.get(currency) || 0) + (Number(w.amount) || 0));
    });
    this.walletTotals = Array.from(byCurrency, ([currency, total]) => ({ currency, total }))
      .sort((a, b) => b.total - a.total);

    // Les lignes à ZÉRO ne sont plus masquées : une file qui disparaît quand elle
    // est vide n'est pas une liste, c'est une surprise. Elles sont simplement
    // triées en bas et grisées (.mtx-queue__count--zero).
    this.pendingQueues = [
      { label: 'Vérifications KYC en attente', count: this.pendingKycCount,          tab: 'kyc' as AdminTab },
      { label: 'Dossiers conformité à traiter', count: this.pendingComplianceCount,  tab: 'compliance' as AdminTab },
      { label: 'Emails Interac non traités',   count: this.newInteracCount,          tab: 'interac' as AdminTab },
      { label: 'Dépôts MoMo à vérifier',       count: this.newMomoCount,             tab: 'momo' as AdminTab },
      { label: 'Dépôts bancaires à vérifier',  count: this.newBankDepositCount,      tab: 'bank_deposits' as AdminTab },
      { label: 'Factures étranger en attente', count: this.pendingForeignBillsCount, tab: 'foreign_bills' as AdminTab },
      { label: 'Signalements ouverts',         count: this.newIssuesCount,           tab: 'issues' as AdminTab },
      { label: 'Litiges de dépôt ouverts',     count: this.newDepositIssuesCount,    tab: 'deposit_issues' as AdminTab },
      { label: 'Transactions en cours',        count: this.inFlightTransactionsCount, tab: 'transactions' as AdminTab },
      { label: 'Erreurs de mouvements d\'argent', count: this.moneyEventErrorCount,  tab: 'money_events' as AdminTab },
      { label: 'Notifications en échec',       count: this.failedNotificationsCount, tab: 'notifications' as AdminTab },
    ].sort((a, b) => b.count - a.count);

    this.totalPending = this.pendingQueues.reduce((sum, q) => sum + q.count, 0);
  }

  ngOnInit(): void {

    // L'espace admin occupe tout l'écran avec sa propre coque : l'en-tête et
    // le pied du site public sont escamotés le temps de la page.
    document.body.classList.add(BODY_CLASS);

    if(localStorage.getItem('user')) {

    
      if(window.innerWidth > 500) { 
        this.showXl = true;
        this.showXs = false;
      }else{
        this.showXl = false;
        this.showXs = true;
      }
          
    }else{
      let link = ['/'];
      this.router.navigate(link);
    }
   
    this.getPay();
    this.getFees();
    this.getRates();
    this.getRateLimits();
    this.getLimits();
    // Load deposit-display settings up front so the wallet grid renders the
    // correct alias domain even before the Paramètres tab is opened.
    this.getDepositSettings();

  }

  // Load the three platform percentage fees from config/fees.
  getFees(): void {
    this.feesSubscription = this.data.getFees().subscribe((res: any) => {
      if (res) {
        this.feesForm = {
          postFeePercent: Number(res.postFeePercent) || 0,
          offerFeePercent: Number(res.offerFeePercent) || 0,
          directTransferFeePercent: Number(res.directTransferFeePercent) || 0,
        };
      }
    });
  }

  // Persist the three fees. Rejects negative values defensively.
  saveFees(): void {
    const f = this.feesForm;
    if (f.postFeePercent < 0 || f.offerFeePercent < 0 || f.directTransferFeePercent < 0) {
      this.toastr.error('Les pourcentages ne peuvent pas être négatifs', 'Validation',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
      return;
    }
    this.data.updateFees({
      postFeePercent: Number(f.postFeePercent) || 0,
      offerFeePercent: Number(f.offerFeePercent) || 0,
      directTransferFeePercent: Number(f.directTransferFeePercent) || 0,
    }).then(() => {
      this.toastr.success('Frais enregistrés avec succès', 'Early Transfer',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
    }).catch(() => {
      this.toastr.error('Échec de l\'enregistrement des frais', 'Erreur',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
    });
  }

  // ── Exchange rates (Taux de change tab) ───────────────────────────────────

  // Load the CAD↔XAF rates from config/rates.
  getRates(): void {
    // Guard against double-subscription (called from ngOnInit and switchTab).
    if (this.ratesSubscription) this.ratesSubscription.unsubscribe();
    this.ratesSubscription = this.data.getRates().subscribe((res: any) => {
      if (res) {
        this.ratesForm = {
          mode: res.mode === 'manual' ? 'manual' : 'auto',
          cadToXaf: Number(res.cadToXaf) || 0,
          xafToCad: Number(res.xafToCad) || 0,
        };
        this.ratesUpdatedAt = res.updatedAt ? String(res.updatedAt) : '';
        this.ratesUpdatedBy = res.updatedBy ? String(res.updatedBy) : '';
      }
    });
  }

  // Persist the rates. In manual mode both rates must be strictly positive —
  // a 0 would zero out every recipient amount downstream, so it is refused
  // here rather than silently ignored by the apps.
  saveRates(): void {
    const r = this.ratesForm;
    const cad = Number(r.cadToXaf) || 0;
    const xaf = Number(r.xafToCad) || 0;
    if (r.mode === 'manual' && (cad <= 0 || xaf <= 0)) {
      this.toastr.error('En mode manuel, les deux taux doivent être supérieurs à 0', 'Validation',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
      return;
    }
    this.data.updateRates({
      mode: r.mode === 'manual' ? 'manual' : 'auto',
      cadToXaf: cad,
      xafToCad: xaf,
      updatedAt: new Date().toISOString(),
      updatedBy: String(localStorage.getItem('user') || ''),
    }).then(() => {
      this.toastr.success('Taux enregistrés avec succès', 'Early Transfer',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
    }).catch(() => {
      this.toastr.error('Échec de l\'enregistrement des taux', 'Erreur',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
    });
  }

  // Load the marketplace rate bounds from config/rateLimits.
  getRateLimits(): void {
    // Guard against double-subscription (called from ngOnInit and switchTab).
    if (this.rateLimitsSubscription) this.rateLimitsSubscription.unsubscribe();
    this.rateLimitsSubscription = this.data.getRateLimits().subscribe((res: any) => {
      if (!res) return;
      const b = ((res.marketplace || {}).XAF_PER_CAD) || {};
      this.rateLimitsForm = {
        min: Number(b.min) || 0,
        max: Number(b.max) || 0,
      };
      this.rateLimitsUpdatedAt = res.updatedAt ? String(res.updatedAt) : '';
      this.rateLimitsUpdatedBy = res.updatedBy ? String(res.updatedBy) : '';
    });
  }

  // Persist the bounds. Refuses negatives, and refuses a minimum at or above
  // the maximum: that combination leaves no valid rate at all and would stop
  // every marketplace post from being published.
  saveRateLimits(): void {
    const min = Number(this.rateLimitsForm.min) || 0;
    const max = Number(this.rateLimitsForm.max) || 0;
    const err = (msg: string) => this.toastr.error(msg, 'Validation',
      {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 5000});

    if (min < 0 || max < 0) {
      err('Les bornes du taux ne peuvent pas être négatives');
      return;
    }
    if (min > 0 && max > 0 && min >= max) {
      err(`Le taux minimum (${min}) doit être inférieur au taux maximum (${max})`);
      return;
    }

    this.data.updateRateLimits({
      marketplace: { XAF_PER_CAD: { min, max } },
      updatedAt: new Date().toISOString(),
      updatedBy: String(localStorage.getItem('user') || ''),
    }).then(() => {
      this.toastr.success('Bornes du taux enregistrées', 'Early Transfer',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
    }).catch(() => {
      this.toastr.error('Échec de l\'enregistrement des bornes du taux', 'Erreur',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
    });
  }

  // ── Per-transaction limits (Paramètres tab) ───────────────────────────────

  getLimits(): void {
    // Guard against double-subscription (called from ngOnInit and switchTab).
    if (this.limitsSubscription) this.limitsSubscription.unsubscribe();
    this.limitsSubscription = this.data.getLimits().subscribe((res: any) => {
      if (!res) { return; }
      const pair = (group: any, cur: string) => ({
        reviewAbove: Number(((group || {})[cur] || {}).reviewAbove) || 0,
        blockAbove: Number(((group || {})[cur] || {}).blockAbove) || 0,
      });
      this.limitsForm = {
        direct: { CAD: pair(res.direct, 'CAD'), XAF: pair(res.direct, 'XAF') },
        marketplace: { CAD: pair(res.marketplace, 'CAD'), XAF: pair(res.marketplace, 'XAF') },
      };
      this.limitsUpdatedAt = res.updatedAt ? String(res.updatedAt) : '';
      this.limitsUpdatedBy = res.updatedBy ? String(res.updatedBy) : '';
    });
  }

  // Persist the thresholds. Rejects negatives, and rejects a review threshold
  // at or above the hard cap — that combination would send every allowed
  // transaction to manual review while blocking nothing extra, which is never
  // what the admin means.
  saveLimits(): void {
    const pairs: { label: string; p: { reviewAbove: number; blockAbove: number } }[] = [
      { label: 'Transfert direct CAD', p: this.limitsForm.direct.CAD },
      { label: 'Transfert direct XAF', p: this.limitsForm.direct.XAF },
      { label: 'Marketplace CAD', p: this.limitsForm.marketplace.CAD },
      { label: 'Marketplace XAF', p: this.limitsForm.marketplace.XAF },
    ];
    const err = (msg: string) => this.toastr.error(msg, 'Validation',
      {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 5000});

    for (const { label, p } of pairs) {
      const review = Number(p.reviewAbove) || 0;
      const block = Number(p.blockAbove) || 0;
      if (review < 0 || block < 0) { err(`${label} : les seuils ne peuvent pas être négatifs`); return; }
      if (review > 0 && block > 0 && review >= block) {
        err(`${label} : le seuil de revue (${review}) doit être inférieur au plafond (${block})`);
        return;
      }
    }

    const clean = (p: { reviewAbove: number; blockAbove: number }) => ({
      reviewAbove: Number(p.reviewAbove) || 0,
      blockAbove: Number(p.blockAbove) || 0,
    });
    this.data.updateLimits({
      direct: { CAD: clean(this.limitsForm.direct.CAD), XAF: clean(this.limitsForm.direct.XAF) },
      marketplace: { CAD: clean(this.limitsForm.marketplace.CAD), XAF: clean(this.limitsForm.marketplace.XAF) },
      updatedAt: new Date().toISOString(),
      updatedBy: String(localStorage.getItem('user') || ''),
    }).then(() => {
      this.toastr.success('Plafonds enregistrés', 'Early Transfer',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
    }).catch(() => {
      this.toastr.error('Échec de l\'enregistrement des plafonds', 'Erreur',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
    });
  }

  // ── Compliance reviews (Conformité tab) ───────────────────────────────────

  onComplianceRowClicked(event) {
    this.selectedCompliance = event.data as ComplianceReview;
  }

  onComplianceRowDoubleClicked(event) {
    this.selectedCompliance = event.data as ComplianceReview;
    this.openComplianceDetailModal(this.templateComplianceDetail, this.selectedCompliance);
  }

  onComplianceGridReady(params) {
    this.complianceGridParams = params;
    if (!this.complianceSubscription) { this.getComplianceReviews(); }
  }

  getComplianceReviews() {
    this.complianceSubscription = this.data.getAllComplianceReviews().subscribe(res => {
      const list: ComplianceReview[] = res.map((e: any) => {
        const d = e.payload.doc.data();
        d.id = e.payload.doc.id;
        return d as ComplianceReview;
      });
      // Newest first — the admin works the queue from the top.
      list.sort((a, b) => (b.submittedAt || '').localeCompare(a.submittedAt || ''));
      this.complianceRowData = list;
      this.pendingComplianceCount = list.filter(r => r.status === 'pending').length;
      this.recomputeDashboard();
    }, () => {
      console.log('Error while fetching compliance reviews');
    });
  }

  openComplianceDetailModal(template: TemplateRef<any>, review: ComplianceReview) {
    this.selectedCompliance = review;
    this.modalRef = this.modalService.show(template, { class: 'modal-lg mtx-modal' });
  }

  openComplianceRejectModal(template: TemplateRef<any>, review: ComplianceReview) {
    this.selectedCompliance = review;
    this.complianceRejectReason = '';
    this.complianceRemediation = '';
    if (this.modalRef) this.modalRef.hide();
    this.modalRef = this.modalService.show(template, { class: 'mtx-modal' });
  }

  /** A readable one-liner of the held transaction, for the detail modal. */
  compliancePayloadSummary(review: ComplianceReview): string {
    const p = (review && review.payload) || {};
    if (!review) { return ''; }
    if (review.kind === 'direct') {
      const dir = p.isCanadaToCameroon ? 'Canada → Cameroun' : 'Cameroun → Canada';
      return `${dir} — envoi ${p.sendAmount} ${review.currency}`
        + (p.recipientXafAmount ? `, bénéficiaire ${p.recipientXafAmount} XAF` : '');
    }
    return `${review.kind === 'post' ? 'Annonce' : 'Offre'} de ${review.amount} ${review.currency}`;
  }

  approveCompliance(review: ComplianceReview) {
    if (!review) { return; }
    this.decideCompliance(review, 'approve');
  }

  rejectCompliance() {
    const reason = (this.complianceRejectReason || '').trim();
    const remediation = (this.complianceRemediation || '').trim();
    if (!reason || !remediation) {
      this.toastr.error('Le motif ET la démarche à suivre sont obligatoires', 'Validation',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 4000});
      return;
    }
    this.decideCompliance(this.selectedCompliance, 'reject', reason, remediation);
  }

  /**
   * Both decisions go through the decideComplianceReview callable — never a
   * direct Firestore write. Approval is what actually debits the customer's
   * wallet, so it has to happen server-side inside one transaction; and
   * complianceReviews is `allow write: if false` in the rules anyway.
   */
  private decideCompliance(review: ComplianceReview, decision: 'approve' | 'reject',
                           rejectionReason = '', remediation = '') {
    if (!review) { return; }
    this.spinner.show();
    const callable = this.fns.httpsCallable('decideComplianceReview');
    callable({ refId: review.refId || review.id, decision, rejectionReason, remediation })
      .toPromise()
      .then((res: any) => {
        this.spinner.hide();
        if (this.modalRef) this.modalRef.hide();
        if (res && res.alreadyDecided) {
          this.toastr.info('Ce dossier avait déjà été traité', 'Early Transfer',
            {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 4000});
          return;
        }
        this.toastr.success(
          decision === 'approve' ? 'Dossier approuvé, transaction exécutée' : 'Dossier refusé',
          'Early Transfer',
          {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 4000});
      })
      .catch((err: any) => {
        this.spinner.hide();
        // A failed approval is expected and informative — most often the
        // customer spent the money while waiting. Surface the server's message
        // verbatim; the review is stamped `failed` with the same reason.
        this.toastr.error(
          (err && err.message) || 'Échec de la décision',
          'Erreur',
          {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 8000});
        console.log('decideComplianceReview error:', err);
      });
  }

  // ── Deposit-display settings (Paramètres tab) ─────────────────────────────

  // Load the Interac alias domain (config/interac) and MoMo receiving numbers
  // (config/momo) shown to customers on the Flutter deposit page.
  getDepositSettings(): void {
    // Guard against double-subscription (called from ngOnInit and switchTab).
    if (this.interacConfigSubscription) this.interacConfigSubscription.unsubscribe();
    if (this.momoConfigSubscription) this.momoConfigSubscription.unsubscribe();
    this.interacConfigSubscription = this.data.getInteracConfig().subscribe((res: any) => {
      if (res && res.aliasDomain) {
        this.interacForm = { aliasDomain: String(res.aliasDomain) };
        this.interacAliasDomain = String(res.aliasDomain);
      }
    });
    this.momoConfigSubscription = this.data.getMomoConfig().subscribe((res: any) => {
      if (res) {
        this.momoForm = {
          mtnNumber: String(res.mtnNumber || ''),
          orangeNumber: String(res.orangeNumber || ''),
        };
      }
    });
    // Maintenance, corridor and marketplace panels live on the same tab, so
    // they ride the same wiring (ngOnInit + switchTab) without touching
    // switchTab.
    this.getMaintenanceConfig();
    this.getCorridors();
    this.getMarketplaceConfig();
    this.getCompanyConfig();
    this.loadDossierPasswordInfo();
  }

  // ── Corridor switches (Paramètres tab) ────────────────────────────────────

  getCorridors(): void {
    // Guard against double-subscription (called from ngOnInit and switchTab).
    if (this.corridorsSubscription) this.corridorsSubscription.unsubscribe();
    this.corridorsSubscription = this.data.getCorridors().subscribe((res: any) => {
      if (!res) { return; }
      const side = (raw: any) => ({
        // Only an explicit boolean true closes a direction — see
        // assertCorridorOpen in functions/index.js.
        disabled: (raw || {}).disabled === true,
        messageFr: String((raw || {}).messageFr || ''),
        messageEn: String((raw || {}).messageEn || ''),
      });
      // Update in place: the template holds references to these row objects,
      // and replacing the map would leave ngModel bound to orphans.
      for (const d of this.corridorDirections) {
        Object.assign(this.corridorsForm.sides[d.key], side(res[d.key]));
      }
      this.corridorsForm.exemptEmails =
        Array.isArray(res.exemptEmails) ? res.exemptEmails.join(', ') : '';
      this.corridorsUpdatedAt = res.updatedAt ? String(res.updatedAt) : '';
      this.corridorsUpdatedBy = res.updatedBy ? String(res.updatedBy) : '';
    });
  }

  /** True when at least one direction is currently suspended (drives the warning banner). */
  get anyCorridorClosed(): boolean {
    return this.corridorDirections.some(d => this.corridorSide(d.key).disabled);
  }

  /** Pure read — every side is pre-seeded by initCountriesTab(). */
  corridorSide(key: string) {
    return this.corridorsForm.sides[key];
  }

  // Suspending a direction without an explanation leaves the customer with a
  // bare refusal, so both languages are required for whichever leg is closed —
  // same rule as saveMaintenanceConfig().
  saveCorridors(): void {
    const c = this.corridorsForm;
    const err = (msg: string) => this.toastr.error(msg, 'Validation',
      {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 5000});

    const clean = (x: { disabled: boolean; messageFr: string; messageEn: string }) => ({
      disabled: x.disabled === true,
      messageFr: (x.messageFr || '').trim(),
      messageEn: (x.messageEn || '').trim(),
    });

    const payload: any = {};
    for (const d of this.corridorDirections) {
      const side = clean(this.corridorSide(d.key));
      if (side.disabled && (!side.messageFr || !side.messageEn)) {
        err(`${d.label} : le message est obligatoire en français et en anglais pour fermer cette direction`);
        return;
      }
      payload[d.key] = side;
    }

    payload.exemptEmails = (c.exemptEmails || '')
      .split(',')
      .map(e => e.trim().toLowerCase())
      .filter(e => e.length > 0);
    payload.updatedAt = new Date().toISOString();
    payload.updatedBy = String(localStorage.getItem('user') || '');

    this.data.updateCorridors(payload).then(() => {
      this.toastr.success('Directions enregistrées', 'Early Transfer',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 4000});
    }).catch(() => {
      this.toastr.error('Échec de l\'enregistrement des directions', 'Erreur',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
    });
  }

  // ── Pays & corridors ──────────────────────────────────────────────────────

  // ⚠️ THESE ARE FIELDS, NOT GETTERS, AND THAT IS LOAD-BEARING.
  //
  // They were getters returning a freshly built array. `*ngFor` diffs by
  // reference, so a new array on every read means ngForOf rebuilds its whole
  // DOM on every change-detection pass, which schedules another pass — the
  // dashboard froze in an infinite loop the moment this tab opened.
  //
  // Computed once in the constructor. The catalogue is a readonly constant, so
  // there is nothing to recompute.

  /** Every corridor runs through Cameroon, so the directions are hub↔partner. */
  readonly corridorDirections: { key: string; label: string; from: string; to: string }[] = [];

  /** The bank-rail countries — the only ones with coordinates to fill in. */
  readonly bankRailCountries: { iso: string; label: string; currency: string }[] = [];

  /**
   * Builds the direction list and pre-seeds every form row.
   *
   * Pre-seeding matters as much as the arrays above: the row accessors below
   * are called FROM THE TEMPLATE, and a template-called method that writes to
   * component state mutates it during change detection — the second way this
   * tab used to loop forever. With every row present from the start they are
   * pure reads.
   */
  private initCountriesTab(): void {
    const hub = this.countryCatalogue.find(c => c.hub);
    // MIRROR of corridorKey() in functions/index.js and
    // CorridorConfigService.keyFor in the app. For CA↔CM this regenerates the
    // two keys already in the live document, byte for byte.
    const key = (from: string, to: string) =>
      `${from.toLowerCase()}To${to[0]}${to.slice(1).toLowerCase()}`;

    for (const c of this.countryCatalogue) {
      this.countriesForm[c.iso] = {
        // Canada and Cameroon are open when the document is silent — both the
        // app and assertCountryEnabled treat them that way, so the switch must
        // not show them as closed before the first snapshot arrives.
        enabled: c.iso === 'CA' || c.iso === 'CM',
        directEnabled: true,
        marketplaceEnabled: true,
        messageFr: '',
        messageEn: '',
      };

      if (c.rail === 'bank') {
        this.bankRailCountries.push({ iso: c.iso, label: c.label, currency: c.currency });
        this.depositRailsForm[c.iso] = {
          enabled: false, bankName: '', accountName: '', fields: [],
          referenceHint: '', instructionsFr: '', instructionsEn: '',
          processingNoteFr: '', processingNoteEn: '',
        };
      }

      if (hub && !c.hub) {
        this.corridorDirections.push(
          { key: key(c.iso, hub.iso), label: `${c.label} → ${hub.label}`, from: c.iso, to: hub.iso },
          { key: key(hub.iso, c.iso), label: `${hub.label} → ${c.label}`, from: hub.iso, to: c.iso },
        );
      }
    }

    for (const d of this.corridorDirections) {
      this.corridorsForm.sides[d.key] = { disabled: false, messageFr: '', messageEn: '' };
    }
  }

  /** Pure read — every row is pre-seeded by initCountriesTab(). */
  countryRow(iso: string) {
    return this.countriesForm[iso];
  }

  /** Pure read — see countryRow(). */
  railRow(iso: string) {
    return this.depositRailsForm[iso];
  }

  addRailField(iso: string): void {
    this.railRow(iso).fields.push({ label: '', value: '' });
  }

  removeRailField(iso: string, index: number): void {
    this.railRow(iso).fields.splice(index, 1);
  }

  /** True when a selectable country is currently closed (drives the banner). */
  get anyCountryClosed(): boolean {
    return this.countryCatalogue.some(c => !this.countryRow(c.iso).enabled);
  }

  getCountries(): void {
    // Guard against double-subscription (called from ngOnInit and switchTab).
    if (this.countriesSubscription) { this.countriesSubscription.unsubscribe(); }
    this.countriesSubscription = this.data.getCountries().subscribe((res: any) => {
      for (const c of this.countryCatalogue) {
        const raw = (res || {})[c.iso] || {};
        Object.assign(this.countriesForm[c.iso], {
          // Only an explicit boolean true opens a country — mirrors
          // CountryConfigService.isEnabled and assertCountryEnabled. Canada and
          // Cameroon are treated as open by BOTH when the document is silent,
          // so seed them that way rather than showing a switch that lies.
          enabled: raw.enabled === true ||
            (raw.enabled === undefined && (c.iso === 'CA' || c.iso === 'CM')),
          // Per-channel switches are opt-out: absent means on.
          directEnabled: raw.directEnabled !== false,
          marketplaceEnabled: raw.marketplaceEnabled !== false,
          messageFr: String(raw.messageFr || ''),
          messageEn: String(raw.messageEn || ''),
        });
      }
      this.countriesUpdatedAt = res && res.updatedAt ? String(res.updatedAt) : '';
      this.countriesUpdatedBy = res && res.updatedBy ? String(res.updatedBy) : '';
    });
  }

  getDepositRails(): void {
    if (this.depositRailsSubscription) { this.depositRailsSubscription.unsubscribe(); }
    this.depositRailsSubscription = this.data.getDepositRails().subscribe((res: any) => {
      for (const c of this.bankRailCountries) {
        const raw = (res || {})[c.iso] || {};
        Object.assign(this.depositRailsForm[c.iso], {
          enabled: raw.enabled === true,
          bankName: String(raw.bankName || ''),
          accountName: String(raw.accountName || ''),
          fields: Array.isArray(raw.fields)
            ? raw.fields
                .filter((f: any) => f && typeof f === 'object')
                .map((f: any) => ({ label: String(f.label || ''), value: String(f.value || '') }))
            : [],
          referenceHint: String(raw.referenceHint || ''),
          instructionsFr: String(raw.instructionsFr || ''),
          instructionsEn: String(raw.instructionsEn || ''),
          processingNoteFr: String(raw.processingNoteFr || ''),
          processingNoteEn: String(raw.processingNoteEn || ''),
        });
      }
      this.depositRailsUpdatedAt = res && res.updatedAt ? String(res.updatedAt) : '';
      this.depositRailsUpdatedBy = res && res.updatedBy ? String(res.updatedBy) : '';
    });
  }

  private toast(kind: 'success' | 'error', msg: string, title: string): void {
    const opts = {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 5000};
    if (kind === 'success') { this.toastr.success(msg, title, opts); } else { this.toastr.error(msg, title, opts); }
  }

  /**
   * Writes config/countries.
   *
   * The validations are the point of this screen. Opening a country whose rate,
   * limits or deposit rail are missing produces a corridor a customer can enter
   * and not get out of — a wallet they can open but never fund, priced off an
   * uncontrolled public API, with no cap on it.
   */
  saveCountries(): void {
    for (const c of this.countryCatalogue) {
      const row = this.countryRow(c.iso);

      // Closing without an explanation leaves the customer a bare refusal.
      if (!row.enabled && (!row.messageFr.trim() || !row.messageEn.trim())) {
        this.toast('error', `${c.label} : le message est obligatoire en français et en anglais pour fermer un pays`, 'Validation');
        return;
      }

      // Cameroon is the hub — closing it closes every corridor at once.
      if (c.hub && !row.enabled) {
        this.toast('error', 'Le Cameroun ne peut pas être fermé : il est sur une jambe de chaque corridor. Fermez les pays partenaires, ou la plateforme entière depuis Paramètres.', 'Validation');
        return;
      }

    }

    // A bank-rail country with no coordinates is worth WARNING about, not
    // refusing.
    //
    // This used to `return` before saving, which made the switch look broken:
    // you flip GB on, press Enregistrer, and nothing happens — the toast is the
    // only clue, and it scrolls away. Refusing was also stricter than it needed
    // to be: the deposit page fails closed on its own and tells the customer
    // "pas encore disponible", so nobody is stranded silently.
    const missingRail = this.countryCatalogue
      .filter(c => c.rail === 'bank' && this.countryRow(c.iso).enabled)
      .filter(c => {
        const rail = this.railRow(c.iso);
        return !rail.enabled || rail.fields.filter(f => f.label.trim() && f.value.trim()).length === 0;
      })
      .map(c => c.label);

    const payload: any = {
      updatedAt: new Date().toISOString(),
      updatedBy: String(localStorage.getItem('user') || ''),
    };
    for (const c of this.countryCatalogue) {
      const row = this.countryRow(c.iso);
      payload[c.iso] = {
        enabled: row.enabled === true,
        directEnabled: row.directEnabled !== false,
        marketplaceEnabled: row.marketplaceEnabled !== false,
        messageFr: row.messageFr.trim(),
        messageEn: row.messageEn.trim(),
      };
    }

    this.data.updateCountries(payload)
      .then(() => {
        this.toast('success', 'Pays enregistrés', 'Early Transfer');
        if (missingRail.length) {
          this.toast('error',
            `${missingRail.join(', ')} : pays ouvert SANS coordonnées de virement. ` +
            'Un client pourra créer un portefeuille sans pouvoir l\'alimenter — ' +
            'renseignez-les dans « Coordonnées de virement bancaire » ci-dessous.',
            'À compléter');
        }
      })
      .catch(() => this.toast('error', 'Échec de l\'enregistrement des pays', 'Erreur'));
  }

  saveDepositRails(): void {
    for (const c of this.bankRailCountries) {
      const rail = this.railRow(c.iso);
      if (!rail.enabled) { continue; }
      const filled = rail.fields.filter(f => f.label.trim() && f.value.trim());
      // These two DO block, and only for a rail being switched ON: a rail
      // marked active with no account number, or with no reference for the
      // operator to match the wire against, would take a customer's money and
      // lose it. Everything else on this screen saves.
      if (filled.length === 0) {
        this.toast('error', `${c.label} : ajoutez au moins une coordonnée (IBAN, sort code…) avant d'activer ce rail, ou laissez-le désactivé`, 'Validation');
        return;
      }
      if (!rail.referenceHint.trim()) {
        this.toast('error', `${c.label} : indiquez la référence que le client doit porter sur son virement, sans quoi un virement entrant ne peut être rattaché à personne`, 'Validation');
        return;
      }
    }

    const payload: any = {
      updatedAt: new Date().toISOString(),
      updatedBy: String(localStorage.getItem('user') || ''),
    };
    for (const c of this.bankRailCountries) {
      const rail = this.railRow(c.iso);
      payload[c.iso] = {
        enabled: rail.enabled === true,
        bankName: rail.bankName.trim(),
        accountName: rail.accountName.trim(),
        // Half-filled rows tell the customer nothing; drop them rather than
        // rendering a label with no value.
        fields: rail.fields
          .map(f => ({ label: f.label.trim(), value: f.value.trim() }))
          .filter(f => f.label && f.value),
        referenceHint: rail.referenceHint.trim(),
        instructionsFr: rail.instructionsFr.trim(),
        instructionsEn: rail.instructionsEn.trim(),
        processingNoteFr: rail.processingNoteFr.trim(),
        processingNoteEn: rail.processingNoteEn.trim(),
      };
    }

    this.data.updateDepositRails(payload)
      .then(() => this.toast('success', 'Coordonnées de virement enregistrées', 'Early Transfer'))
      .catch(() => this.toast('error', 'Échec de l\'enregistrement des coordonnées', 'Erreur'));
  }

  // ── Marketplace kill switch (Paramètres tab) ──────────────────────────────

  // Load the marketplace switch from config/marketplace.
  getMarketplaceConfig(): void {
    // Guard against double-subscription (called from ngOnInit and switchTab).
    if (this.marketplaceConfigSubscription) this.marketplaceConfigSubscription.unsubscribe();
    this.marketplaceConfigSubscription = this.data.getMarketplaceConfig().subscribe((res: any) => {
      if (!res) { return; }
      this.marketplaceConfigForm = {
        // Only an explicit boolean true closes it — see assertMarketplaceOpen
        // in functions/index.js.
        disabled: res.disabled === true,
        titleFr: String(res.titleFr || ''),
        titleEn: String(res.titleEn || ''),
        messageFr: String(res.messageFr || ''),
        messageEn: String(res.messageEn || ''),
        exemptEmails: Array.isArray(res.exemptEmails) ? res.exemptEmails.join(', ') : '',
        blockedEmails: Array.isArray(res.blockedEmails) ? res.blockedEmails.join(', ') : '',
      };
      this.marketplaceConfigUpdatedAt = res.updatedAt ? String(res.updatedAt) : '';
      this.marketplaceConfigUpdatedBy = res.updatedBy ? String(res.updatedBy) : '';
    });
  }

  /** Drives the warning callout on the panel. */
  get marketplaceClosed(): boolean {
    return this.marketplaceConfigForm.disabled === true;
  }

  // Persist the marketplace switch. Closing it with no message would leave
  // customers on a wordless block screen, so both languages are required when
  // `disabled` is on — same rule as saveCorridors().
  saveMarketplaceConfig(): void {
    const m = this.marketplaceConfigForm;
    const toastOpts = {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 5000};

    const titleFr = (m.titleFr || '').trim();
    const titleEn = (m.titleEn || '').trim();
    const messageFr = (m.messageFr || '').trim();
    const messageEn = (m.messageEn || '').trim();

    if (m.disabled === true && (!messageFr || !messageEn)) {
      this.toastr.error(
        'Le message est obligatoire en français et en anglais pour fermer le marketplace',
        'Validation', toastOpts);
      return;
    }

    // Trim + lowercase + drop empties is mandatory: the app and
    // assertMarketplaceOpen both match with a lowercase includes().
    const emails = (raw: string) => (raw || '')
      .split(',')
      .map(e => e.trim().toLowerCase())
      .filter(e => e.length > 0);

    const exemptEmails = emails(m.exemptEmails);
    const blockedEmails = emails(m.blockedEmails);

    const both = blockedEmails.filter(e => exemptEmails.indexOf(e) >= 0);
    if (both.length > 0) {
      // A warning, not a refusal — the rule is well defined, the admin just
      // may not have meant it.
      this.toastr.warning(
        'Présent dans les deux listes, donc bloqué : ' + both.join(', '),
        'Attention', toastOpts);
    }

    this.data.updateMarketplaceConfig({
      disabled: m.disabled === true,
      titleFr, titleEn, messageFr, messageEn,
      exemptEmails, blockedEmails,
      updatedAt: new Date().toISOString(),
      updatedBy: String(localStorage.getItem('user') || ''),
    }).then(() => {
      this.toastr.success(
        m.disabled ? 'Marketplace fermé' : 'Marketplace ouvert',
        'Early Transfer',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 4000});
    }).catch(() => {
      this.toastr.error('Échec de l\'enregistrement du marketplace', 'Erreur',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
    });
  }

  // ── Maintenance mode (Paramètres tab) ─────────────────────────────────────

  // Load the kill-switch state from config/maintenance.
  getMaintenanceConfig(): void {
    // Guard against double-subscription (called from ngOnInit and switchTab).
    if (this.maintenanceSubscription) this.maintenanceSubscription.unsubscribe();
    this.maintenanceSubscription = this.data.getMaintenanceConfig().subscribe((res: any) => {
      if (!res) { return; }
      this.maintenanceForm = {
        // Only an explicit boolean true means "closed" — see saveMaintenanceConfig.
        isActive: res.isActive === true,
        titleFr: String(res.titleFr || ''),
        titleEn: String(res.titleEn || ''),
        messageFr: String(res.messageFr || ''),
        messageEn: String(res.messageEn || ''),
        exemptEmails: Array.isArray(res.exemptEmails) ? res.exemptEmails.join(', ') : '',
      };
      this.maintenanceUpdatedAt = res.updatedAt ? String(res.updatedAt) : '';
      this.maintenanceUpdatedBy = res.updatedBy ? String(res.updatedBy) : '';
    });
  }

  // Persist the kill switch. Closing the platform with an empty message would
  // leave users staring at a blank screen, so all four texts are required when
  // isActive is on — same rule as saveMessage() for the client banners.
  saveMaintenanceConfig(): void {
    const m = this.maintenanceForm;
    const titleFr = (m.titleFr || '').trim();
    const titleEn = (m.titleEn || '').trim();
    const messageFr = (m.messageFr || '').trim();
    const messageEn = (m.messageEn || '').trim();

    if (m.isActive && (!titleFr || !titleEn || !messageFr || !messageEn)) {
      this.toastr.error(
        'Pour fermer la plateforme, le titre et le message sont obligatoires en français et en anglais',
        'Validation',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 5000});
      return;
    }

    const exemptEmails = (m.exemptEmails || '')
      .split(',')
      .map(e => e.trim().toLowerCase())
      .filter(e => e.length > 0);

    this.data.updateMaintenanceConfig({
      isActive: m.isActive === true,
      titleFr, titleEn, messageFr, messageEn,
      exemptEmails,
      updatedAt: new Date().toISOString(),
      updatedBy: String(localStorage.getItem('user') || ''),
    }).then(() => {
      this.toastr.success(
        m.isActive ? 'Plateforme fermée — mode maintenance actif' : 'Plateforme rouverte',
        'Early Transfer',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 4000});
    }).catch(() => {
      this.toastr.error('Échec de l\'enregistrement du mode maintenance', 'Erreur',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
    });
  }

  // ── Operating company (Paramètres tab) ────────────────────────────────────

  getCompanyConfig(): void {
    // Guard against double-subscription (called from ngOnInit and switchTab).
    if (this.companySubscription) this.companySubscription.unsubscribe();
    this.companySubscription = this.data.getCompanyConfig().subscribe((res: any) => {
      if (!res) { return; }
      this.companyForm = {
        legalName: String(res.legalName || this.companyForm.legalName),
        fintracNumber: String(res.fintracNumber || this.companyForm.fintracNumber),
      };
      this.companyUpdatedAt = res.updatedAt ? String(res.updatedAt) : '';
      this.companyUpdatedBy = res.updatedBy ? String(res.updatedBy) : '';
    });
  }

  saveCompanyConfig(): void {
    const legalName = (this.companyForm.legalName || '').trim();
    const fintracNumber = (this.companyForm.fintracNumber || '').trim().toUpperCase();

    if (!legalName) {
      this.toastr.error('Le nom légal de la société est obligatoire', 'Validation',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 4000});
      return;
    }
    // FINTRAC numbers read as a letter followed by eight digits (e.g. C10001562,
    // M19327148). An empty value is allowed: the dossier then keeps its default.
    if (fintracNumber && !/^[A-Z]\d{8}$/.test(fintracNumber)) {
      this.toastr.error('Numéro FINTRAC attendu : une lettre suivie de 8 chiffres (ex : C10001562)', 'Validation',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 5000});
      return;
    }

    this.data.updateCompanyConfig({
      legalName,
      fintracNumber,
      updatedAt: new Date().toISOString(),
      updatedBy: String(localStorage.getItem('user') || ''),
    }).then(() => {
      this.toastr.success('Société mise à jour — le dossier investisseur l\'affiche d\'ici une minute', 'Early Transfer',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 5000});
    }).catch(() => {
      this.toastr.error('Échec de l\'enregistrement de la société', 'Erreur',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
    });
  }

  // ── Investor dossier password (Paramètres tab) ────────────────────────────

  loadDossierPasswordInfo(): void {
    ['case', 'plan'].forEach(target => {
      this.fns.httpsCallable('getDossierAccessInfo')({ target }).toPromise()
        .then((res: any) => { this.dossierPasswordInfo[target] = res || null; })
        .catch((err: any) => { console.log('getDossierAccessInfo error:', target, err); });
    });
  }

  saveDossierPassword(target: string): void {
    const form = this.dossierPasswordForm[target];
    const password = form.password || '';
    const confirm = form.confirm || '';
    const label = target === 'plan' ? 'du business plan' : 'du business case';

    if (password.trim().length < 10) {
      this.toastr.error('Le mot de passe doit contenir au moins 10 caractères', 'Validation',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 4000});
      return;
    }
    if (password !== confirm) {
      this.toastr.error('Les deux saisies ne correspondent pas', 'Validation',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 4000});
      return;
    }

    this.dossierPasswordSaving[target] = true;
    this.fns.httpsCallable('setDossierPassword')({ target, password }).toPromise()
      .then((res: any) => {
        this.dossierPasswordSaving[target] = false;
        this.dossierPasswordForm[target] = { password: '', confirm: '' };
        this.dossierPasswordVisible[target] = false;
        this.dossierPasswordInfo[target] = { source: 'dashboard', updatedAt: res && res.updatedAt, updatedBy: res && res.updatedBy };
        this.toastr.success(`Nouveau mot de passe ${label} actif — ses sessions ouvertes ont été fermées`, 'Early Transfer',
          {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 5000});
      })
      .catch((err: any) => {
        this.dossierPasswordSaving[target] = false;
        this.toastr.error((err && err.message) || 'Échec du changement de mot de passe', 'Erreur',
          {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 6000});
        console.log('setDossierPassword error:', target, err);
      });
  }

  // ── Privacy policy (Confidentialité tab) ──────────────────────────────────

  // Load config/privacyPolicy. `privacyBumpVersion` is deliberately NOT
  // hydrated here: it is an intent for the next save, not stored state.
  getPrivacyPolicy(): void {
    // Guard against double-subscription (called from ngOnInit and switchTab).
    if (this.privacySubscription) this.privacySubscription.unsubscribe();
    this.privacySubscription = this.data.getPrivacyPolicy().subscribe((res: any) => {
      if (!res) { return; }
      this.privacyForm = {
        effectiveDateFr: String(res.effectiveDateFr || ''),
        effectiveDateEn: String(res.effectiveDateEn || ''),
        introFr: String(res.introFr || ''),
        introEn: String(res.introEn || ''),
        contactTitleFr: String(res.contactTitleFr || ''),
        contactTitleEn: String(res.contactTitleEn || ''),
        contactBodyFr: String(res.contactBodyFr || ''),
        contactBodyEn: String(res.contactBodyEn || ''),
        contactEmail: String(res.contactEmail || ''),
        lastUpdatedFr: String(res.lastUpdatedFr || ''),
        lastUpdatedEn: String(res.lastUpdatedEn || ''),
      };
      this.privacySections = Array.isArray(res.sections)
        ? res.sections.map((s: any) => ({
            icon: String((s || {}).icon || 'article'),
            titleFr: String((s || {}).titleFr || ''),
            titleEn: String((s || {}).titleEn || ''),
            bodyFr: String((s || {}).bodyFr || ''),
            bodyEn: String((s || {}).bodyEn || ''),
          }))
        : [];
      this.privacyVersion = Number(res.version) || 0;
      this.privacyUpdatedAt = res.updatedAt ? String(res.updatedAt) : '';
      this.privacyUpdatedBy = res.updatedBy ? String(res.updatedBy) : '';
      this.privacyVersionPublishedAt = res.versionPublishedAt ? String(res.versionPublishedAt) : '';
    });
  }

  /** Stable identity for the *ngFor, so typing in one section's textarea does
   *  not make Angular tear down and rebuild every other row (which would steal
   *  focus on each keystroke). Index is correct here because reordering
   *  rebuilds the array anyway. */
  trackBySectionIndex(index: number): number { return index; }

  addPrivacySection(): void {
    this.privacySections.push({ icon: 'article', titleFr: '', titleEn: '', bodyFr: '', bodyEn: '' });
  }

  removePrivacySection(index: number): void {
    if (index < 0 || index >= this.privacySections.length) return;
    if (!window.confirm('Supprimer cette section de la politique ?')) return;
    this.privacySections.splice(index, 1);
  }

  movePrivacySection(index: number, delta: number): void {
    const target = index + delta;
    if (target < 0 || target >= this.privacySections.length) return;
    const [row] = this.privacySections.splice(index, 1);
    this.privacySections.splice(target, 0, row);
  }

  /** Fills both "last updated" lines with today's date, so the admin does not
   *  have to hand-write it in two languages on every edit. */
  stampPrivacyToday(): void {
    const now = new Date();
    this.privacyForm.lastUpdatedFr =
      'Dernière mise à jour : ' + now.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
    this.privacyForm.lastUpdatedEn =
      'Last updated: ' + now.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  }

  /** Seeds the editor with the policy the app currently ships, so the first
   *  save is a faithful copy rather than a blank page. Never overwrites work
   *  in progress without asking. */
  seedPrivacyDefaults(): void {
    if (this.privacySections.length > 0 &&
        !window.confirm('Remplacer le contenu actuel de l\'éditeur par la politique embarquée dans l\'application ?')) {
      return;
    }
    this.privacyForm = {
      effectiveDateFr: 'Date d\'effet : 14 juin 2026',
      effectiveDateEn: 'Effective date: June 14, 2026',
      introFr: 'Votre vie privée compte pour nous. Cette politique explique quelles informations Early Transfert collecte, comment nous les utilisons et les protégeons, et les choix dont vous disposez lorsque vous envoyez de l\'argent et publiez ou acceptez des opportunités d\'échange.',
      introEn: 'Your privacy matters to us. This policy explains what information Early Transfert collects, how we use and protect it, and the choices you have when you send money and post or accept exchange opportunities.',
      contactTitleFr: 'Nous contacter',
      contactTitleEn: 'Contact us',
      contactBodyFr: 'Pour toute question sur cette politique ou vos données personnelles, contactez Vofack Consultation Inc. à privacy@earlytransfert.com.',
      contactBodyEn: 'For any question about this policy or your personal data, contact Vofack Consultation Inc. at privacy@earlytransfert.com.',
      contactEmail: 'privacy@earlytransfert.com',
      lastUpdatedFr: '',
      lastUpdatedEn: '',
    };
    this.privacySections = [
      { icon: 'handshake',     titleFr: 'Notre engagement',                    titleEn: 'Our commitment',                 bodyFr: '', bodyEn: '' },
      { icon: 'folder_shared', titleFr: 'Informations que nous collectons',    titleEn: 'Information we collect',         bodyFr: '', bodyEn: '' },
      { icon: 'tune',          titleFr: 'Comment nous utilisons vos informations', titleEn: 'How we use your information', bodyFr: '', bodyEn: '' },
      { icon: 'share',         titleFr: 'Partage des informations',            titleEn: 'How we share information',       bodyFr: '', bodyEn: '' },
      { icon: 'lock',          titleFr: 'Comment nous protégeons vos données', titleEn: 'How we protect your data',       bodyFr: '', bodyEn: '' },
      { icon: 'schedule',      titleFr: 'Conservation des données',            titleEn: 'Data retention',                 bodyFr: '', bodyEn: '' },
      { icon: 'gavel',         titleFr: 'Vos droits',                          titleEn: 'Your rights',                    bodyFr: '', bodyEn: '' },
      { icon: 'insights',      titleFr: 'Analytique & cookies',                titleEn: 'Analytics & cookies',            bodyFr: '', bodyEn: '' },
      { icon: 'child_care',    titleFr: 'Mineurs',                             titleEn: 'Children',                       bodyFr: '', bodyEn: '' },
      { icon: 'public',        titleFr: 'Transferts internationaux',           titleEn: 'International transfers',        bodyFr: '', bodyEn: '' },
      { icon: 'update',        titleFr: 'Modifications de cette politique',    titleEn: 'Changes to this policy',         bodyFr: '', bodyEn: '' },
    ];
    this.stampPrivacyToday();
    this.toastr.success(
      'Structure pré-remplie. Complétez le corps de chaque section avant d\'enregistrer.',
      'Early Transfer',
      {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 6000});
  }

  /** What the primary button says, so the admin cannot publish by accident. */
  get privacySaveLabel(): string {
    return this.privacyBumpVersion
      ? 'Publier la version ' + ((Number(this.privacyVersion) || 0) + 1)
      : 'Enregistrer';
  }

  // Persist the policy. The version only moves when the admin explicitly asks:
  // a typo fix must not prompt every customer to accept again.
  savePrivacyPolicy(): void {
    const f = this.privacyForm;
    const sections = this.privacySections.map(s => ({
      icon: String(s.icon || 'article').trim(),
      titleFr: (s.titleFr || '').trim(),
      titleEn: (s.titleEn || '').trim(),
      // Bodies keep their newlines on purpose: several sections are bullet
      // lists, and the app renders the \n as written.
      bodyFr: (s.bodyFr || '').replace(/\s+$/, ''),
      bodyEn: (s.bodyEn || '').replace(/\s+$/, ''),
    }));

    const toastOpts = {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 5000};

    if (sections.length === 0) {
      this.toastr.error('La politique doit contenir au moins une section', 'Validation', toastOpts);
      return;
    }
    const incomplete = sections.findIndex(s => !s.titleFr || !s.titleEn || !s.bodyFr || !s.bodyEn);
    if (incomplete >= 0) {
      this.toastr.error(
        'Section ' + (incomplete + 1) + ' : le titre et le corps sont obligatoires en français et en anglais',
        'Validation', toastOpts);
      return;
    }
    if (!(f.introFr || '').trim() || !(f.introEn || '').trim()) {
      this.toastr.error('L\'introduction est obligatoire en français et en anglais', 'Validation', toastOpts);
      return;
    }
    if (!(f.contactEmail || '').trim()) {
      this.toastr.error('L\'adresse de contact est obligatoire', 'Validation', toastOpts);
      return;
    }

    const current = Number(this.privacyVersion) || 0;
    // First save on an empty doc always lands on 1: version 0 would be
    // indistinguishable from "no policy", which the app treats as inert.
    const nextVersion = this.privacyBumpVersion ? current + 1 : (current || 1);
    const isPublishing = nextVersion !== current;

    if (this.privacyBumpVersion && !window.confirm(
      'Publier la version ' + nextVersion + ' ? Tous les clients devront accepter de nouveau la politique à leur prochaine connexion.')) {
      return;
    }

    const now = new Date().toISOString();
    const payload: any = {
      version: nextVersion,
      effectiveDateFr: (f.effectiveDateFr || '').trim(),
      effectiveDateEn: (f.effectiveDateEn || '').trim(),
      introFr: (f.introFr || '').trim(),
      introEn: (f.introEn || '').trim(),
      sections,
      contactTitleFr: (f.contactTitleFr || '').trim(),
      contactTitleEn: (f.contactTitleEn || '').trim(),
      contactBodyFr: (f.contactBodyFr || '').trim(),
      contactBodyEn: (f.contactBodyEn || '').trim(),
      contactEmail: (f.contactEmail || '').trim(),
      lastUpdatedFr: (f.lastUpdatedFr || '').trim(),
      lastUpdatedEn: (f.lastUpdatedEn || '').trim(),
      updatedAt: now,
      updatedBy: String(localStorage.getItem('user') || ''),
    };
    // Only stamped when the number actually moved, so the audit trail tells a
    // typo fix apart from a published version.
    if (isPublishing) { payload.versionPublishedAt = now; }

    this.data.updatePrivacyPolicy(payload).then(() => {
      // Intent is consumed: leaving it on would silently publish again on the
      // next save.
      this.privacyBumpVersion = false;
      this.toastr.success(
        isPublishing
          ? 'Version ' + nextVersion + ' publiée — les clients devront l\'accepter'
          : 'Politique enregistrée (version ' + nextVersion + ' inchangée)',
        'Early Transfer',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 4000});
    }).catch(() => {
      this.toastr.error('Échec de l\'enregistrement de la politique', 'Erreur',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
    });
  }

  // Persist the Interac alias domain to config/interac.
  saveInteracConfig(): void {
    const domain = (this.interacForm.aliasDomain || '').trim();
    if (!domain) {
      this.toastr.error('Le domaine ne peut pas être vide', 'Validation',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
      return;
    }
    this.data.updateInteracConfig({ aliasDomain: domain }).then(() => {
      this.interacAliasDomain = domain;
      this.toastr.success('Domaine Interac enregistré', 'Early Transfer',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
    }).catch(() => {
      this.toastr.error('Échec de l\'enregistrement du domaine', 'Erreur',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
    });
  }

  // Persist the MTN/Orange receiving numbers to config/momo.
  saveMomoConfig(): void {
    this.data.updateMomoConfig({
      mtnNumber: (this.momoForm.mtnNumber || '').trim(),
      orangeNumber: (this.momoForm.orangeNumber || '').trim(),
    }).then(() => {
      this.toastr.success('Numéros Mobile Money enregistrés', 'Early Transfer',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
    }).catch(() => {
      this.toastr.error('Échec de l\'enregistrement des numéros', 'Erreur',
        {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
    });
  }

  getPay(): void {
    this.getavailablePaySuscribtions = this.data.getPay().subscribe(res => {
      this.amount = Number(res && res[0] && res[0]['amount']) || 0;
      }, err => {
        console.log('Error while fetching pay');
        console.log(err);
        this.unsuscribe();
    });
  }

  getVal(item){
    var rowData_temp = [];
    for (let i = 0; i < this.rowData.length; i++) {
        const row = this.rowData[i];
        if (row && row.last_name && row.last_name.includes(item.target.value)) rowData_temp.push(row);
    }
    this.params.api.setRowData(rowData_temp);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if(event.target.innerWidth > 500) {
        this.showXl = true;
        this.showXs = false;
      }else{
        this.showXl = false;
        this.showXs = true;
      }
  }

  public openModal(template:TemplateRef<any>){
    this.modalRef = this.modalService.show(template, { class: 'mtx-modal' });
    this.mobileValue = '';
  }

  reinitialiseError(){
    this.enableEmail = false;
    this.enablePrenom = false;
    this.enableNom = false;
    this.enableCountry = false;
    this.enableTown = false;
    this.enableTelephone = false;
    this.enableAmount = false;
  }


  ajouter(Inputnom,Inputprenom,InputCountry,InputProvince,InputTown,Inputemail): void {

    this.reinitialiseError();
    if (Inputnom.value.length == 0 || Inputprenom.value.length == 0 ||
        InputCountry.value.length == 0 || InputTown.value.length == 0 ||  
        Inputemail.value.length == 0 || this.mobileValue === '') {


        if (Inputnom.value.length == 0) this.enableNom = true;
        if (Inputprenom.value.length == 0) this.enablePrenom = true;
        if (InputCountry.value.length == 0) this.enableCountry = true;
        if (InputTown.value.length == 0) this.enableTown = true;
        if (this.mobileValue === '') this.enableTelephone = true;
        if (Inputemail.value.length == 0) this.enableEmail = true;
        this.toastr.error('Erreur de validation','Ajout', {progressBar: true, 
          toastClass: 'toast-custom', closeButton: true,
          positionClass: 'toast-bottom-left'});
        
    }else{

          let Inputnom_ = Inputnom.value.toString().trim();
          let Inputprenom_ = Inputprenom.value.toString().trim();
          let InputCountry_ = InputCountry.value.toString().trim();
          let InputTown_ = InputTown.value.toString().trim();
          let Inputemail_ = Inputemail.value.toString().trim();
     
          this.beneficiaryObj.id = '';
          this.beneficiaryObj.userEmail = localStorage.getItem('user'); // current email connected
          this.beneficiaryObj.first_name = Inputprenom_;
          this.beneficiaryObj.last_name = Inputnom_;
          this.beneficiaryObj.email = Inputemail_;
          this.beneficiaryObj.mobile = this.mobileValue;
          this.beneficiaryObj.town = InputTown_;
          this.beneficiaryObj.country = InputCountry_;
          

          this.toastr.success('Ajout effectuer avec succes','Early Transfer', {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
          this.modalRef.hide(); // pour fermer le popup

          setTimeout(() => {
            /** spinner ends after 2 seconds */    
            this.addBeneficiary(this.beneficiaryObj);
          }, 3500);
    }


  }

  onChange(event){
    this.mobileValue = event.internationalNumber;
  }

  openSpinner($event){
    /** spinner starts on init */
    this.load = $event;
    this.spinner.show();

    setTimeout(() => {
      /** spinner ends after 2 seconds */
      this.spinner.hide();
    }, 1000);
    this.modalRef.hide(); // pour fermer le popup
  }

 
  addBeneficiary(beneficiaryObj: Beneficiary) { 
    this.data.addBeneficiary(beneficiaryObj);
  }

  public exportAsExcelFile(): void {
    let excelFileName = 'TransactionsHistory';
    this.toastr.success('Telechargement en cours d\'execution','Early Transfer', {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});

    // Suit ce que l'admin voit à l'écran, filtre compris — mais sans les
    // lignes d'en-tête de groupe, qui ne sont pas des transactions, ni les
    // transactions masquées par un groupe replié.
    const exportRows = this.transactionTypeFilter === 'marketplace'
      ? (this.rowData || []).filter((r: any) => ManageTransactionsComponent.isMarketplaceRow(r))
      : (this.transactionsVisibleRows || []).filter((r: any) => !(r && r.__isGroupHeader));
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportRows);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });

    setTimeout(() => {
      /** spinner ends after 2 seconds */
      this.saveAsExcelFile(excelBuffer, excelFileName);
    }, 3000);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }


  modifier(Inputsolde): void {
      this.reinitialiseError();

      if ( Inputsolde.value.length == 0 ) {

          if (Inputsolde.value.length == 0) this.enableAmount = true;
          this.toastr.error('Erreur de validation','Ajout', {progressBar: true,
            toastClass: 'toast-custom', closeButton: true,
            positionClass: 'toast-bottom-left'});

      }else{

            // Validation avant écriture. `Number("abc")` vaut NaN, que Firestore
            // accepte comme un double valide — une faute de frappe écrivait donc
            // NaN dans la RÉSERVE DE LIQUIDITÉ PARTAGÉE, que le site web
            // décrémente à chaque virement.
            const raw = Inputsolde.value.toString().trim().replace(',', '.').replace(/\s/g, '');
            const parsed = Number(raw);
            if (!isFinite(parsed) || parsed < 0) {
              this.enableAmount = true;
              this.toastr.error('Montant invalide', 'Ajout', {progressBar: true,
                toastClass: 'toast-custom', closeButton: true,
                positionClass: 'toast-bottom-left'});
              return;
            }
            // Arrondi à 3 décimales pour que le stockage corresponde exactement
            // à l'affichage (| number:'1.0-3').
            const rounded = Math.round(parsed * 1000) / 1000;
            this.toastr.success('Modification avec succes','Early Transfer', {progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000});
            this.modalRef.hide(); // pour fermer le popup

            setTimeout(() => {
              this.data.updatePay("mg6GHY8RPYCo7KzHobR2", rounded);
            }, 3500);
      }
  }

  // ── KYC MANAGEMENT ──

  switchTab(tab: AdminTab) {
    this.activeTab = tab;
    this.loadFor(tab);
    if (tab === 'fees') {
      this.getFees();
    }
    if (tab === 'rates') {
      this.getRates();
    }
    if (tab === 'settings') {
      this.getDepositSettings();
    }
    if (tab === 'pays') {
      this.getCountries();
      this.getDepositRails();
      this.getCorridors();
    }
    if (tab === 'privacy') {
      this.getPrivacyPolicy();
    }
    this.selectedKyc = null;
    this.selectedMessage = null;
    this.selectedWallet = null;
    this.selectedInteracEmail = null;
    this.expandedPostId = null;
    this.expandedOfferId = null;
    this.selectedIssue = null;
    this.selectedDepositIssue = null;
    this.selectedForeignBill = null;
    this.emailFilter = '';
    this.clearEmailFilter();
    this.clearDateFilter();
  }

  filterByEmail() {
    const gridApi = this.getActiveGridApi();
    const emailField = this.getActiveEmailField();
    if (!gridApi || !emailField) return;

    const filterInstance = gridApi.getFilterInstance(emailField);
    if (filterInstance) {
      if (this.emailFilter.trim()) {
        filterInstance.setModel({
          type: 'contains',
          filter: this.emailFilter.trim()
        });
      } else {
        filterInstance.setModel(null);
      }
      gridApi.onFilterChanged();
    }
  }

  private clearEmailFilter() {
    // Clear filter on all grids
    [this.gridApi, this.kycGridParams?.api, this.messagesGridParams?.api, this.walletGridParams?.api, this.interacGridParams?.api, this.issuesGridParams?.api, this.depositIssuesGridParams?.api, this.notificationGridParams?.api, this.foreignBillsGridParams?.api]
      .filter(api => !!api)
      .forEach(api => {
        const fields = ['userEmail', 'targetUserEmail', 'usersEmail', 'from', 'targetEmail'];
        fields.forEach(f => {
          const fi = api.getFilterInstance(f);
          if (fi) {
            fi.setModel(null);
          }
        });
        api.onFilterChanged();
      });
  }

  private getActiveGridApi() {
    switch (this.activeTab) {
      case 'transactions': return this.gridApi;
      case 'kyc': return this.kycGridParams?.api;
      case 'messages': return this.messagesGridParams?.api;
      case 'wallets': return this.walletGridParams?.api;
      case 'interac': return this.interacGridParams?.api;
      case 'money_events': return this.moneyEventGridParams?.api;
      case 'momo': return this.momoGridParams?.api;
      case 'issues': return this.issuesGridParams?.api;
      case 'deposit_issues': return this.depositIssuesGridParams?.api;
      case 'notifications': return this.notificationGridParams?.api;
      case 'foreign_bills': return this.foreignBillsGridParams?.api;
    }
  }

  private getActiveEmailField(): string {
    switch (this.activeTab) {
      case 'transactions': return 'userEmail';
      case 'kyc': return 'userEmail';
      case 'messages': return 'targetUserEmail';
      case 'wallets': return 'usersEmail';
      case 'interac': return 'from';
      case 'money_events': return 'userEmail';
      case 'momo': return 'walletEmail';
      case 'issues': return 'from';
      case 'deposit_issues': return 'userEmail';
      case 'notifications': return 'targetEmail';
      case 'foreign_bills': return 'userEmail';
    }
  }

  private getActiveDateField(): string {
    switch (this.activeTab) {
      case 'transactions': return 'date';
      case 'kyc': return 'submittedAt';
      case 'messages': return 'createdAt';
      case 'wallets': return null;
      case 'interac': return 'date';
      case 'money_events': return 'createdAtIso';
      case 'momo': return 'submittedAt';
      case 'issues': return 'date';
      case 'deposit_issues': return 'date';
      case 'notifications': return 'sentAt';
      case 'foreign_bills': return 'createdAt';
    }
  }

  // Bound callbacks for ag-grid external filtering (date range)
  isExternalFilterPresent = (): boolean => {
    return !!(this.dateFrom || this.dateTo);
  }

  doesExternalFilterPass = (node): boolean => {
    if (!this.dateFrom && !this.dateTo) return true;

    // Try all known date fields on the row
    const dateFields = ['date', 'submittedAt', 'createdAt'];
    let val = null;
    for (const f of dateFields) {
      if (node.data[f]) { val = node.data[f]; break; }
    }
    if (!val) return true;

    const rowDate = new Date(val).getTime();
    if (isNaN(rowDate)) return true;

    if (this.dateFrom) {
      const from = new Date(this.dateFrom).getTime();
      if (rowDate < from) return false;
    }
    if (this.dateTo) {
      const to = new Date(this.dateTo + 'T23:59:59').getTime();
      if (rowDate > to) return false;
    }
    return true;
  }

  filterByDate() {
    // Notify all initialized grids that external filter changed
    [this.gridApi, this.kycGridParams?.api, this.messagesGridParams?.api, this.walletGridParams?.api, this.interacGridParams?.api, this.issuesGridParams?.api, this.depositIssuesGridParams?.api, this.notificationGridParams?.api, this.foreignBillsGridParams?.api]
      .filter(api => !!api)
      .forEach(api => api.onFilterChanged());
  }

  clearDateFilter() {
    this.dateFrom = '';
    this.dateTo = '';
    this.filterByDate();
  }

  onKycRowClicked(event) {
    this.selectedKyc = event.data as KycVerification;
  }

  onKycRowDoubleClicked(event) {
    this.selectedKyc = event.data as KycVerification;
    this.openKycDetailModal(this.templateKycDetail, this.selectedKyc);
  }

  onKycGridReady(params) {
    this.kycGridParams = params;
    if (!this.kycSubscription) { this.getKycVerifications(); }
  }

  getKycVerifications() {
    this.kycSubscription = this.data.getAllKycVerifications().subscribe(res => {
      const kycList: KycVerification[] = res.map((e: any) => {
        const data = e.payload.doc.data();
        data.id = e.payload.doc.id;
        return data as KycVerification;
      });

      // A user re-submitting KYC adds a NEW kyc_verifications doc each time
      // (the Flutter side calls .add(), never overwrites), so the number of
      // docs per email is the number of attempts. Stamp each row with its
      // chronological attempt number (oldest = 1) and the user's total, so
      // the admin can see at a glance how many tries it took.
      const attemptsByEmail: { [email: string]: KycVerification[] } = {};
      kycList.forEach(k => {
        const key = k.userEmail || '';
        (attemptsByEmail[key] = attemptsByEmail[key] || []).push(k);
      });
      Object.keys(attemptsByEmail).forEach(key => {
        const group = attemptsByEmail[key];
        // Oldest first so attempt #1 is the first submission.
        group.sort((a, b) =>
          (a.submittedAt || '').localeCompare(b.submittedAt || ''));
        group.forEach((k, idx) => {
          k.attemptNumber = idx + 1;
          k.totalAttempts = group.length;
        });
      });

      this.kycRowData = kycList;
      this.pendingKycCount = kycList.filter(k => k.status === 'pending').length;
      this.recomputeDashboard();
    }, err => {
      console.log('Error while fetching KYC verifications');
    });
  }

  openKycDetailModal(template: TemplateRef<any>, kyc: KycVerification) {
    this.selectedKyc = kyc;
    this.modalRef = this.modalService.show(template, { class: 'modal-lg mtx-modal' });
  }

  // Firebase Storage URLs are cross-origin, so the plain <a download>
  // attribute is ignored by the browser (it would just open the image).
  // Fetch the bytes as a blob and trigger a genuine download instead.
  downloadKycImage(url: string, filename: string) {
    if (!url) { return; }
    this.spinner.show();
    fetch(url)
      .then(res => {
        if (!res.ok) { throw new Error(`HTTP ${res.status}`); }
        return res.blob();
      })
      .then(blob => {
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(objectUrl);
        this.spinner.hide();
      })
      .catch(err => {
        this.spinner.hide();
        // Fallback: open in a new tab so the admin can still save manually.
        window.open(url, '_blank');
        this.toastr.warning('Could not auto-download, opened in a new tab instead', 'Early Transfer', {
          progressBar: true, toastClass: 'toast-custom',
          positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000
        });
        console.log('Download KYC image error:', err);
      });
  }

  approveKyc(kyc: KycVerification) {
    this.spinner.show();
    this.data.approveKyc(kyc.id).then(() => {
      return this.data.updateUserKycStatus(kyc.userEmail, 'verified');
    }).then(() => {
      this.spinner.hide();
      this.toastr.success('KYC approved successfully', 'Early Transfer', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000
      });
      if (this.modalRef) this.modalRef.hide();
    }).catch(err => {
      this.spinner.hide();
      this.toastr.error('Failed to approve KYC', 'Error', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      console.log('Approve KYC error:', err);
    });
  }

  setKycPending(kyc: KycVerification) {
    this.spinner.show();
    this.data.setKycPending(kyc.id).then(() => {
      return this.data.updateUserKycStatus(kyc.userEmail, 'pending');
    }).then(() => {
      this.spinner.hide();
      this.toastr.success('KYC set back to pending', 'Early Transfer', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000
      });
      if (this.modalRef) this.modalRef.hide();
      this.selectedKyc = null;
    }).catch(err => {
      this.spinner.hide();
      this.toastr.error('Failed to update KYC status', 'Error', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      console.log('Set KYC pending error:', err);
    });
  }

  openRejectModal(template: TemplateRef<any>, kyc: KycVerification) {
    this.selectedKyc = kyc;
    this.rejectionReason = '';
    if (this.modalRef) this.modalRef.hide();
    this.modalRef = this.modalService.show(template, { class: 'mtx-modal' });
  }

  rejectKyc() {
    if (!this.rejectionReason.trim()) {
      this.toastr.error('Please provide a rejection reason', 'Validation', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      return;
    }
    this.spinner.show();
    this.data.rejectKyc(this.selectedKyc.id, this.rejectionReason.trim()).then(() => {
      return this.data.updateUserKycStatus(this.selectedKyc.userEmail, 'rejected');
    }).then(() => {
      this.spinner.hide();
      this.modalRef.hide();
      this.toastr.success('KYC rejected', 'Early Transfer', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000
      });
    }).catch(err => {
      this.spinner.hide();
      this.toastr.error('Failed to reject KYC', 'Error', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      console.log('Reject KYC error:', err);
    });
  }

  // ── MESSAGES MANAGEMENT ──

  onMessagesGridReady(params) {
    this.messagesGridParams = params;
    if (!this.messagesSubscription) { this.getAdminMessages(); }
  }

  onMessagesRowClicked(event) {
    this.selectedMessage = event.data as AdminMessage;
  }

  getAdminMessages() {
    this.messagesSubscription = this.data.getAllAdminMessages().subscribe(res => {
      const list: AdminMessage[] = res.map((e: any) => {
        const d = e.payload.doc.data();
        d.id = e.payload.doc.id;
        return d as AdminMessage;
      });
      this.messagesRowData = list;
    }, err => {
      console.log('Error fetching admin messages', err);
    });
  }

  openAddMessageModal(template: TemplateRef<any>, msg?: AdminMessage) {
    if (msg) {
      this.isEditingMessage = true;
      this.messageForm = { ...msg, targetUserEmail: msg.targetUserEmail || '' };
    } else {
      this.isEditingMessage = false;
      this.messageForm = { messageEn: '', messageFr: '', isActive: true, type: 'info', targetUserEmail: '' };
    }
    this.modalRef = this.modalService.show(template, { class: 'mtx-modal' });
  }

  saveMessage() {
    if (!this.messageForm.messageEn.trim() || !this.messageForm.messageFr.trim()) {
      this.toastr.error('Both English and French messages are required', 'Validation', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      return;
    }
    this.spinner.show();
    const action: Promise<any> = this.isEditingMessage
      ? this.data.updateAdminMessage(this.messageForm.id, {
          messageEn: this.messageForm.messageEn,
          messageFr: this.messageForm.messageFr,
          isActive: this.messageForm.isActive,
          type: this.messageForm.type,
          targetUserEmail: this.messageForm.targetUserEmail || ''
        })
      : this.data.addAdminMessage({ ...this.messageForm });

    action.then(() => {
      this.spinner.hide();
      this.modalRef.hide();
      this.selectedMessage = null;
      this.toastr.success(
        this.isEditingMessage ? 'Message updated successfully' : 'Message added successfully',
        'Early Transfer',
        { progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000 }
      );
    }).catch(err => {
      this.spinner.hide();
      this.toastr.error('Failed to save message', 'Error', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      console.log('Save message error:', err);
    });
  }

  deleteMessage() {
    if (!this.selectedMessage) return;
    this.spinner.show();
    this.data.deleteAdminMessage(this.selectedMessage.id).then(() => {
      this.spinner.hide();
      this.selectedMessage = null;
      this.toastr.success('Message deleted', 'Early Transfer', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000
      });
    }).catch(err => {
      this.spinner.hide();
      this.toastr.error('Failed to delete message', 'Error', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      console.log('Delete message error:', err);
    });
  }

  toggleMessageActive() {
    if (!this.selectedMessage) return;
    this.spinner.show();
    this.data.updateAdminMessage(this.selectedMessage.id, { isActive: !this.selectedMessage.isActive }).then(() => {
      this.spinner.hide();
      this.toastr.success(
        `Message ${this.selectedMessage.isActive ? 'deactivated' : 'activated'}`,
        'Early Transfer',
        { progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000 }
      );
      this.selectedMessage = null;
    }).catch(err => {
      this.spinner.hide();
      this.toastr.error('Failed to update message', 'Error', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      console.log('Toggle message error:', err);
    });
  }

  // ── WALLETS MANAGEMENT ──

  onWalletGridReady(params) {
    this.walletGridParams = params;
    if (!this.walletSubscription) { this.getWalletAccounts(); }
  }

  onWalletRowClicked(event) {
    this.selectedWallet = event.data as WalletAccount;
  }

  getWalletAccounts() {
    this.walletSubscription = this.data.getAllWalletAccounts().subscribe(res => {
      const list: WalletAccount[] = res.map((e: any) => {
        const d = e.payload.doc.data();
        d.id = e.payload.doc.id;
        return d as WalletAccount;
      });
      this.walletRowData = list;
      this.recomputeDashboard();
      // Wallets feed the "User Email" column on the Interac grid; re-enrich
      // and refresh whenever wallets update.
      this.enrichInteracRowsWithUserEmail();
      this.refreshInteracRows();
    }, err => {
      console.log('Error fetching wallet accounts', err);
    });
  }

  openEditWalletModal(template: TemplateRef<any>, wallet: WalletAccount) {
    this.selectedWallet = wallet;
    this.walletNewAmount = wallet.amount;
    this.modalRef = this.modalService.show(template, { class: 'mtx-modal' });
  }

  saveWalletAmount() {
    if (this.walletNewAmount == null || isNaN(this.walletNewAmount) || this.walletNewAmount < 0) {
      this.toastr.error('Please enter a valid amount', 'Validation', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      return;
    }
    this.spinner.show();
    this.data.updateWalletAmount(this.selectedWallet.id, Number(this.walletNewAmount)).then(() => {
      this.spinner.hide();
      this.modalRef.hide();
      this.selectedWallet = null;
      this.toastr.success('Wallet balance updated', 'Early Transfer', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000
      });
    }).catch(err => {
      this.spinner.hide();
      this.toastr.error('Failed to update balance', 'Error', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      console.log('Update wallet error:', err);
    });
  }

  // Calls the assignInteracAlias Cloud Function to mint a unique alias for
  // this wallet. The Cloud Function persists the alias on the wallet doc; we
  // mirror it locally so the modal updates without a round-trip.
  generateInteracAlias(walletId: string) {
    if (!walletId || this.aliasGenerating) return;
    this.aliasGenerating = true;
    this.firebase.getIdToken().then(token => {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    this.http.post('https://us-central1-dashboard-33d8e.cloudfunctions.net/assignInteracAlias',
      { walletId }, { headers }
    ).subscribe(
      (resp: any) => {
        this.aliasGenerating = false;
        if (resp && resp.success && resp.alias) {
          if (this.selectedWallet && this.selectedWallet.id === walletId) {
            this.selectedWallet.interacAlias = resp.alias;
          }
          const row = (this.walletRowData || []).find(w => w.id === walletId);
          if (row) row.interacAlias = resp.alias;
          this.toastr.success(`Alias assigned: ${resp.fullAddress}`, 'Early Transfer', {
            progressBar: true, toastClass: 'toast-custom',
            positionClass: 'toast-bottom-left', closeButton: true, timeOut: 4000
          });
        } else {
          this.toastr.error(resp?.error || 'Failed to generate alias', 'Error', {
            progressBar: true, toastClass: 'toast-custom',
            positionClass: 'toast-bottom-left', closeButton: true
          });
        }
      },
      err => {
        this.aliasGenerating = false;
        this.toastr.error('Failed to generate alias', 'Error', {
          progressBar: true, toastClass: 'toast-custom',
          positionClass: 'toast-bottom-left', closeButton: true
        });
        console.log('assignInteracAlias error:', err);
      }
    );
    });
  }

  copyInteracAlias() {
    if (!this.selectedWallet?.interacAlias) return;
    const full = `${this.selectedWallet.interacAlias}@${this.interacAliasDomain}`;
    navigator.clipboard.writeText(full).then(() => {
      this.toastr.success('Alias copied to clipboard', 'Early Transfer', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true, timeOut: 2000
      });
    });
  }

  // Calls assignMomoCode to mint a unique reference code for a CM wallet.
  // Mirrors generateInteracAlias for the Cameroun Mobile Money flow.
  generateMomoCode(walletId: string) {
    if (!walletId || this.momoCodeGenerating) return;
    this.momoCodeGenerating = true;
    this.firebase.getIdToken().then(token => {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    this.http.post('https://us-central1-dashboard-33d8e.cloudfunctions.net/assignMomoCode',
      { walletId }, { headers }
    ).subscribe(
      (resp: any) => {
        this.momoCodeGenerating = false;
        if (resp && resp.success && resp.code) {
          if (this.selectedWallet && this.selectedWallet.id === walletId) {
            this.selectedWallet.momoCode = resp.code;
          }
          const row = (this.walletRowData || []).find(w => w.id === walletId);
          if (row) row.momoCode = resp.code;
          this.toastr.success(`MoMo code assigned: ${resp.code}`, 'Early Transfer', {
            progressBar: true, toastClass: 'toast-custom',
            positionClass: 'toast-bottom-left', closeButton: true, timeOut: 4000
          });
        } else {
          this.toastr.error(resp?.error || 'Failed to generate MoMo code', 'Error', {
            progressBar: true, toastClass: 'toast-custom',
            positionClass: 'toast-bottom-left', closeButton: true
          });
        }
      },
      err => {
        this.momoCodeGenerating = false;
        this.toastr.error('Failed to generate MoMo code', 'Error', {
          progressBar: true, toastClass: 'toast-custom',
          positionClass: 'toast-bottom-left', closeButton: true
        });
        console.log('assignMomoCode error:', err);
      }
    );
    });
  }

  copyMomoCode() {
    if (!this.selectedWallet?.momoCode) return;
    navigator.clipboard.writeText(this.selectedWallet.momoCode).then(() => {
      this.toastr.success('MoMo code copied to clipboard', 'Early Transfer', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true, timeOut: 2000
      });
    });
  }

  // ── INTERAC EMAILS MANAGEMENT ──

  onInteracGridReady(params) {
    this.interacGridParams = params;
    if (!this.interacSubscription) { this.getInteracEmails(); }
    // Wallets are needed to resolve userEmail per row. Load them if the
    // wallets tab hasn't been opened yet (otherwise the subscription is
    // already live and will keep enrichment in sync).
    if (!this.walletSubscription) {
      this.getWalletAccounts();
    }
    // Users provide the fallback phone (users.mobile) for the "User Phone"
    // column. Load them if the notifications tab hasn't already.
    if (!this.usersSubscription) {
      this.loadUserEmails();
    }
  }

  onInteracRowClicked(event) {
    this.selectedInteracEmail = event.data as InteracEmail;
  }

  onInteracRowDoubleClicked(event) {
    this.selectedInteracEmail = event.data as InteracEmail;
    this.openInteracBodyModal(this.templateInteracBody);
  }

  openInteracBodyModal(template: TemplateRef<any>) {
    if (!this.selectedInteracEmail) return;
    this.modalRef = this.modalService.show(template, { class: 'modal-lg mtx-modal' });
  }

  getInteracEmails() {
    this.interacSubscription = this.data.getAllInteracEmails().subscribe(res => {
      const list: InteracEmail[] = res.map((e: any) => {
        const d = e.payload.doc.data();
        d.id = e.payload.doc.id;
        return d as InteracEmail;
      });
      this.interacRowData = list;
      this.newInteracCount = list.filter(e => e.status === 'new').length;
      this.recomputeDashboard();
      this.enrichInteracRowsWithUserEmail();
    }, err => {
      console.log('Error fetching interac emails', err);
    });
  }

  // Builds case-normalized indexes over the loaded wallets so we can look up
  // a wallet by interacAlias, usersEmail, or interacFullName in O(1).
  private buildWalletIndexes(): {
    byAlias: Map<string, WalletAccount>;
    byUserEmail: Map<string, WalletAccount>;
    byFullName: Map<string, WalletAccount>;
  } {
    const byAlias = new Map<string, WalletAccount>();
    const byUserEmail = new Map<string, WalletAccount>();
    const byFullName = new Map<string, WalletAccount>();
    for (const w of (this.walletRowData || [])) {
      if (w.interacAlias) byAlias.set(w.interacAlias.toLowerCase().trim(), w);
      if (w.usersEmail) byUserEmail.set(w.usersEmail.toLowerCase().trim(), w);
      if (w.interacFullName) byFullName.set(w.interacFullName.toLowerCase().trim(), w);
    }
    return { byAlias, byUserEmail, byFullName };
  }

  // Interac notifications come FROM the bank (catch@payments.interac.ca, etc.),
  // never the customer. The real sender is in the body — the Cloud Function
  // extracts it into senderFullName and senderEmailFromBody. Match priority:
  //   1. receivedAlias against wallet.interacAlias — 100% reliable when customer
  //      sent to their dedicated alias (e.g. abc12xyz@earlytransfert.com)
  //   2. Direct FROM against the wallet's account email (usersEmail)
  //   3. senderEmailFromBody (Reply-To or body-extracted email) against usersEmail
  //   4. senderFullName against wallet.interacFullName (fallback — name collisions possible)
  //   5. Legacy fallback: any email in subject/snippet/body that matches a wallet's usersEmail.
  // NB: customers now register a phone number (interacPhone), not an email, so
  // there is no longer an email-based contact index to match against.
  private lookupInteracWallet(
    e: InteracEmail,
    byAlias: Map<string, WalletAccount>,
    byUserEmail: Map<string, WalletAccount>,
    byFullName: Map<string, WalletAccount>
  ): WalletAccount | null {
    const alias = (e.receivedAlias || '').toLowerCase().trim();
    if (alias) {
      const byAliasMatch = byAlias.get(alias);
      if (byAliasMatch) return byAliasMatch;
    }

    const from = (e.from || '').toLowerCase().trim();
    const direct = byUserEmail.get(from);
    if (direct) return direct;

    const bodyEmail = (e.senderEmailFromBody || '').toLowerCase().trim();
    if (bodyEmail) {
      const byBodyEmail = byUserEmail.get(bodyEmail);
      if (byBodyEmail) return byBodyEmail;
    }

    const fullName = (e.senderFullName || '').toLowerCase().trim();
    if (fullName) {
      const byName = byFullName.get(fullName);
      if (byName) return byName;
    }

    const haystack = `${e.subject || ''}\n${e.snippet || ''}\n${e.body || ''}`.toLowerCase();
    const emailRegex = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/gi;
    const candidates = haystack.match(emailRegex) || [];
    for (const candidate of candidates) {
      const w = byUserEmail.get(candidate.trim());
      if (w) return w;
    }
    return null;
  }

  // L'enrichissement mute les lignes en place : la référence du tableau ne
  // bouge pas, donc le binding [rowData] ne verrait rien. On la renouvelle
  // pour que la grille reprenne les colonnes fraîchement remplies.
  private refreshInteracRows() {
    if (this.interacRowData) {
      this.interacRowData = this.interacRowData.slice();
    }
  }

  // Called both when interac rows arrive and when wallets reload, so the
  // "User Email" column stays in sync regardless of which finishes first.
  private enrichInteracRowsWithUserEmail() {
    if (!this.interacRowData || !this.walletRowData) return;
    const { byAlias, byUserEmail, byFullName } = this.buildWalletIndexes();
    for (const e of this.interacRowData) {
      const wallet = this.lookupInteracWallet(e, byAlias, byUserEmail, byFullName);
      (e as any).userEmail = wallet ? wallet.usersEmail : '';
      // Prefer the registered Interac phone; fall back to the account's profile
      // phone (users.mobile) so a number shows even before the customer sets it.
      (e as any).userPhone = wallet
        ? (wallet.interacPhone || this.userMobileByEmail.get((wallet.usersEmail || '').toLowerCase().trim()) || '')
        : '';
    }
  }

  // Resolves the wallet for the currently selected Interac email using the
  // same matching rules as the column. Used by the Mark Processed / Back to
  // New flows so they stay consistent with what the admin sees.
  private resolveWalletForSelectedInterac(): WalletAccount | null {
    if (!this.selectedInteracEmail) return null;
    const { byAlias, byUserEmail, byFullName } = this.buildWalletIndexes();
    return this.lookupInteracWallet(this.selectedInteracEmail, byAlias, byUserEmail, byFullName);
  }

  // Returns another Interac email that represents the SAME transfer and has
  // already been credited, so the admin can't process a duplicate twice. The
  // reference number is the reliable key (the same transfer forwarded/re-ingested
  // gets a new messageId but keeps its reference); messageId is a secondary key.
  private findProcessedDuplicate(email: InteracEmail): InteracEmail | null {
    if (!email || !this.interacRowData) return null;
    const ref = (email.referenceNumber || '').trim().toUpperCase();
    const msgId = (email.messageId || '').trim();
    return this.interacRowData.find(e =>
      e.id !== email.id &&
      e.status === 'processed' &&
      (
        (ref && (e.referenceNumber || '').trim().toUpperCase() === ref) ||
        (msgId && (e.messageId || '').trim() === msgId)
      )
    ) || null;
  }

  markInteracProcessed() {
    if (!this.selectedInteracEmail) return;

    // Guard against double-crediting: if the same transfer (same reference
    // number / messageId) was already processed on another row, refuse.
    if (this.selectedInteracEmail.status === 'processed') {
      this.toastr.warning('This email is already processed', 'Validation', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      return;
    }
    const duplicate = this.findProcessedDuplicate(this.selectedInteracEmail);
    if (duplicate) {
      const ref = duplicate.referenceNumber ? ` (ref ${duplicate.referenceNumber})` : '';
      this.toastr.error(
        `This transfer${ref} was already processed on another email — not crediting again`,
        'Duplicate',
        { progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 5000 }
      );
      return;
    }

    // Re-extract the dollar amount from the email subject (with body fallback,
    // then the value the cloud function pre-extracted at ingest time).
    const amountStr = this.extractInteracAmountString(
      this.selectedInteracEmail.subject,
      this.selectedInteracEmail.body
    ) || (this.selectedInteracEmail.amount || '');
    const amount = this.parseInteracAmount(amountStr);

    if (!amount || amount <= 0) {
      this.toastr.error('Could not extract a dollar amount from the email subject', 'Validation', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      return;
    }

    const wallet = this.resolveWalletForSelectedInterac();
    if (!wallet) {
      this.toastr.error(
        `No wallet found for ${this.selectedInteracEmail.from}`,
        'Validation',
        { progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true }
      );
      return;
    }

    const currentBalance = Number(wallet.amount) || 0;
    const newBalance = +(currentBalance + amount).toFixed(2);
    this.pendingInteracCredit = { wallet, amount, amountStr, newBalance };
    this.modalRef = this.modalService.show(this.templateInteracCreditConfirm, { class: 'mtx-modal' });
  }

  confirmInteracCredit() {
    if (!this.selectedInteracEmail || !this.pendingInteracCredit) return;

    // Final duplicate check at commit time: the live feed may have flipped
    // another copy of this transfer to 'processed' while the modal was open.
    const duplicate = this.findProcessedDuplicate(this.selectedInteracEmail);
    if (duplicate) {
      if (this.modalRef) this.modalRef.hide();
      this.pendingInteracCredit = null;
      const ref = duplicate.referenceNumber ? ` (ref ${duplicate.referenceNumber})` : '';
      this.toastr.error(
        `This transfer${ref} was already processed — not crediting again`,
        'Duplicate',
        { progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 5000 }
      );
      return;
    }

    const { wallet, amount } = this.pendingInteracCredit;
    const emailId = this.selectedInteracEmail.id;
    const senderEmail = wallet.usersEmail || this.selectedInteracEmail.from;

    // The credit is done server-side in a single atomic, idempotent transaction
    // (creditInteracEmail): it recomputes the amount, guards against double-credit
    // via the interacCredits ledger, updates the balance and flips the email to
    // 'processed' together. The live walletAccount snapshot refreshes the grid.
    this.spinner.show();
    this.firebase.getIdToken().then(token => {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      this.http.post('https://us-central1-dashboard-33d8e.cloudfunctions.net/creditInteracEmail',
        { emailId, walletId: wallet.id }, { headers }
      ).subscribe(
        (resp: any) => {
          this.spinner.hide();
          if (this.modalRef) this.modalRef.hide();
          this.selectedInteracEmail = null;
          this.pendingInteracCredit = null;
          if (resp && resp.success) {
            const credited = Number(resp.amount) || amount;
            const newBalance = Number(resp.newBalance);
            this.toastr.success(
              `$${credited.toFixed(2)} credited to ${senderEmail} (new balance: $${newBalance.toFixed(2)})`,
              'Early Transfer',
              { progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 4000 }
            );
          } else {
            this.toastr.error(resp?.error || 'Failed to process Interac email', 'Error', {
              progressBar: true, toastClass: 'toast-custom',
              positionClass: 'toast-bottom-left', closeButton: true
            });
          }
        },
        err => {
          this.spinner.hide();
          this.pendingInteracCredit = null;
          this.toastr.error(err?.error?.error || 'Failed to process Interac email', 'Error', {
            progressBar: true, toastClass: 'toast-custom',
            positionClass: 'toast-bottom-left', closeButton: true
          });
          console.log('Confirm interac credit error:', err);
        }
      );
    });
  }

  cancelInteracCredit() {
    this.pendingInteracCredit = null;
    if (this.modalRef) this.modalRef.hide();
  }

  // Matches both English ("$70.00", "$1,000.00") and French-Canadian
  // ("70,00 $", "1 250,00 $") amount formats. Scans the subject first, falls
  // back to the body. Mirrors the regex used by checkInteracEmails Cloud
  // Function so admin re-extraction stays consistent with ingest.
  private extractInteracAmountString(subject: string, body?: string): string {
    const regex = /\$\s*\d{1,3}(?:[,\s]\d{3})*(?:[.,]\d{1,2})?|\d{1,3}(?:[\s.,]\d{3})*(?:[.,]\d{1,2})?\s*\$/;
    const subjectMatch = (subject || '').match(regex);
    if (subjectMatch) return subjectMatch[0].trim();
    const bodyMatch = (body || '').match(regex);
    return bodyMatch ? bodyMatch[0].trim() : '';
  }

  // Normalizes an amount string to a Number, handling both decimal conventions:
  //   "$1,000.50" → 1000.5   "1 000,50 $" → 1000.5   "70,00 $" → 70
  // When both "," and "." appear, the rightmost is the decimal separator.
  // When only one appears with 1-2 trailing digits, it's the decimal separator.
  private parseInteracAmount(amountStr: string): number {
    if (!amountStr) return 0;
    let cleaned = amountStr.replace(/\$/g, '').trim();
    const hasComma = cleaned.includes(',');
    const hasDot = cleaned.includes('.');

    if (hasComma && hasDot) {
      if (cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
        cleaned = cleaned.replace(/\./g, '').replace(',', '.');
      } else {
        cleaned = cleaned.replace(/,/g, '');
      }
    } else if (hasComma) {
      const lastIdx = cleaned.lastIndexOf(',');
      const trailing = cleaned.length - lastIdx - 1;
      if (trailing === 1 || trailing === 2) {
        cleaned = cleaned.replace(',', '.');
      } else {
        cleaned = cleaned.replace(/,/g, '');
      }
    }
    cleaned = cleaned.replace(/\s/g, '');
    const n = parseFloat(cleaned);
    return isNaN(n) ? 0 : n;
  }

  markInteracIgnored() {
    if (!this.selectedInteracEmail) return;
    if (this.selectedInteracEmail.status === 'processed') {
      this.openInteracReversalFlow('ignored');
    } else {
      this.justUpdateInteracStatus('ignored', 'Email marked as ignored');
    }
  }

  markInteracNew() {
    if (!this.selectedInteracEmail) return;
    if (this.selectedInteracEmail.status === 'processed') {
      this.openInteracReversalFlow('new');
    } else {
      this.justUpdateInteracStatus('new', 'Email set back to new');
    }
  }

  // Used when no wallet reversal is needed (transitions between non-processed
  // states). Same shape as the original updateStatus flow before the debit
  // logic was added.
  private justUpdateInteracStatus(status: 'new' | 'ignored', successMessage: string) {
    this.spinner.show();
    this.data.updateInteracEmailStatus(this.selectedInteracEmail.id, status).then(() => {
      this.spinner.hide();
      this.selectedInteracEmail = null;
      this.toastr.success(successMessage, 'Early Transfer', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000
      });
    }).catch(err => {
      this.spinner.hide();
      this.toastr.error('Failed to update email status', 'Error', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      console.log('Update interac status error:', err);
    });
  }

  // Leaving 'processed' must reverse the previous debit. Re-extracts the
  // amount from the subject and looks up the original wallet, then opens the
  // reversal confirmation modal. If the amount or wallet can't be resolved
  // (e.g. wallet was deleted) the admin is offered a status change without
  // the credit and warned that no reversal happened.
  private openInteracReversalFlow(targetStatus: 'new' | 'ignored') {
    const amountStr = this.extractInteracAmountString(
      this.selectedInteracEmail.subject,
      this.selectedInteracEmail.body
    ) || (this.selectedInteracEmail.amount || '');
    const amount = this.parseInteracAmount(amountStr);

    if (!amount || amount <= 0) {
      this.toastr.warning(
        'No amount could be extracted; status will change but no wallet credit will occur',
        'Validation',
        { progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 4000 }
      );
      this.justUpdateInteracStatus(targetStatus, targetStatus === 'new' ? 'Email set back to new' : 'Email marked as ignored');
      return;
    }

    const wallet = this.resolveWalletForSelectedInterac();
    if (!wallet) {
      this.toastr.warning(
        `No wallet found for ${this.selectedInteracEmail.from}; status will change but no debit will occur`,
        'Validation',
        { progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 4000 }
      );
      this.justUpdateInteracStatus(targetStatus, targetStatus === 'new' ? 'Email set back to new' : 'Email marked as ignored');
      return;
    }

    const currentBalance = Number(wallet.amount) || 0;
    const newBalance = +(currentBalance - amount).toFixed(2);
    this.pendingInteracReversal = { wallet, amount, amountStr, newBalance, targetStatus };
    this.modalRef = this.modalService.show(this.templateInteracReversalConfirm, { class: 'mtx-modal' });
  }

  confirmInteracReversal() {
    if (!this.selectedInteracEmail || !this.pendingInteracReversal) return;
    const { wallet, amount, targetStatus } = this.pendingInteracReversal;
    const emailId = this.selectedInteracEmail.id;
    const senderEmail = wallet.usersEmail || this.selectedInteracEmail.from;

    // Reversal is done server-side atomically (reverseInteracCredit): it debits
    // the wallet by exactly what was credited (from the interacCredits ledger),
    // removes the ledger entry and moves the email back to new/ignored together.
    this.spinner.show();
    this.firebase.getIdToken().then(token => {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      this.http.post('https://us-central1-dashboard-33d8e.cloudfunctions.net/reverseInteracCredit',
        { emailId, walletId: wallet.id, targetStatus }, { headers }
      ).subscribe(
        (resp: any) => {
          this.spinner.hide();
          if (this.modalRef) this.modalRef.hide();
          this.selectedInteracEmail = null;
          this.pendingInteracReversal = null;
          if (resp && resp.success) {
            const debited = Number(resp.amount) || amount;
            const newBalance = Number(resp.newBalance);
            this.toastr.success(
              `$${debited.toFixed(2)} debited from ${senderEmail} (new balance: $${newBalance.toFixed(2)})`,
              'Early Transfer',
              { progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 4000 }
            );
          } else {
            this.toastr.error(resp?.error || 'Failed to reverse Interac email', 'Error', {
              progressBar: true, toastClass: 'toast-custom',
              positionClass: 'toast-bottom-left', closeButton: true
            });
          }
        },
        err => {
          this.spinner.hide();
          this.pendingInteracReversal = null;
          this.toastr.error(err?.error?.error || 'Failed to reverse Interac email', 'Error', {
            progressBar: true, toastClass: 'toast-custom',
            positionClass: 'toast-bottom-left', closeButton: true
          });
          console.log('Confirm interac reversal error:', err);
        }
      );
    });
  }

  cancelInteracReversal() {
    this.pendingInteracReversal = null;
    if (this.modalRef) this.modalRef.hide();
  }

  checkInteracEmails() {
    this.interacChecking = true;
    this.firebase.getIdToken().then(token => {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      this.http.get(`https://us-central1-dashboard-33d8e.cloudfunctions.net/checkInteracEmails`, { headers }).subscribe(
        (res: any) => {
          this.interacChecking = false;
          const count = res?.newCount || 0;
          this.toastr.success(`Check complete. ${count} new email(s) found.`, 'Interac Emails', {
            progressBar: true, toastClass: 'toast-custom',
            positionClass: 'toast-bottom-left', closeButton: true, timeOut: 5000
          });
        },
        err => {
          this.interacChecking = false;
          this.toastr.error('Failed to check emails. Make sure the Cloud Function is deployed.', 'Error', {
            progressBar: true, toastClass: 'toast-custom',
            positionClass: 'toast-bottom-left', closeButton: true
          });
          console.log('Check interac emails error:', err);
        }
      );
    });
  }

  // ── MOMO DEPOSITS MANAGEMENT (Cameroun) ──

  // ── MARKETPLACE : posts, offres liées et frais encaissés ──
  // Croise trois flux : posts, propositions et allTransactions (isMarketPlace).
  // Les frais plateforme vivent sur les docs allTransactions (feeAmount) : deux
  // par offre acceptée (côté propriétaire et côté offreur) — et ils sont dans
  // DEUX devises différentes, donc jamais additionnés entre eux.

  /**
   * Déplie/replie un post. Le détail (offres + leurs transactions) n'est
   * construit QUE pour le post ouvert — c'est le lazy loading du rendu : on ne
   * matérialise jamais les view-models des milliers d'autres posts.
   */
  togglePost(id: string) {
    if (this.expandedPostId === id) {
      this.expandedPostId = null;
      this.expandedOffers = [];
    } else {
      this.expandedPostId = id;
      this.expandedOffers = this.offersForPost(id);
    }
    this.expandedOfferId = null;
  }

  /** Déplie/replie une offre pour montrer ses 2 transactions. */
  toggleOffer(id: string) {
    this.expandedOfferId = this.expandedOfferId === id ? null : id;
  }

  /**
   * Offres réellement affichées dans le post déplié. Le filtre email/recherche
   * s'applique AUSSI ici : sinon, filtrer sur l'email d'un offreur masquait bien
   * les autres posts, mais réaffichait toutes les offres du post ouvert — ce qui
   * donnait l'impression que le filtre ne marchait pas.
   * Si le post a matché par son auteur (aucune offre ne correspond), on montre
   * toutes ses offres plutôt qu'une liste vide.
   */
  get visibleExpandedOffers(): any[] {
    const needle = ((this.emailFilter || '').trim() || (this.marketplaceFilter || '').trim())
      .toLowerCase();
    if (!needle) { return this.expandedOffers; }
    const matching = this.expandedOffers.filter(o =>
      (o.email || '').toLowerCase().includes(needle) ||
      (o.name || '').toLowerCase().includes(needle));
    return matching.length ? matching : this.expandedOffers;
  }

  /** Vrai si un filtre du bandeau du haut est actif (pour l'indiquer à l'écran). */
  get marketplaceGlobalFilterActive(): boolean {
    return !!((this.emailFilter || '').trim() || this.dateFrom || this.dateTo);
  }

  /** Remet la pagination à zéro et referme le détail quand un filtre change. */
  onMarketplaceFilterChange() {
    this.marketplacePage = 0;
    this.expandedPostId = null;
    this.expandedOffers = [];
    this.expandedOfferId = null;
  }

  /**
   * Filtrage + tri, mémoïsés. Prend en compte la recherche locale ET les filtres
   * globaux du bandeau (email, plage de dates) qui, eux, passent par l'API
   * ag-Grid et ne s'appliqueraient donc pas à cet onglet.
   */
  get filteredMarketplaceRows(): any[] {
    const key = [
      this.marketplaceFilter, this.marketplaceSort, this.emailFilter,
      this.dateFrom, this.dateTo, this.mpVersion,
    ].join('|');
    if (key !== this.mpCacheKey) {
      this.mpCacheKey = key;
      this.mpCache = this.computeFilteredMarketplace();
    }
    return this.mpCache;
  }

  /** La tranche réellement rendue dans le DOM. */
  get pagedMarketplaceRows(): any[] {
    const rows = this.filteredMarketplaceRows;
    const start = this.marketplacePageIndex * this.marketplacePageSize;
    return rows.slice(start, start + this.marketplacePageSize);
  }

  get marketplacePageCount(): number {
    return Math.max(1, Math.ceil(this.filteredMarketplaceRows.length / this.marketplacePageSize));
  }

  /** Page courante bornée (un filtre peut réduire le nombre de pages). */
  get marketplacePageIndex(): number {
    return Math.min(Math.max(0, this.marketplacePage), this.marketplacePageCount - 1);
  }

  changeMarketplacePage(delta: number) {
    this.marketplacePage = Math.min(
      Math.max(0, this.marketplacePageIndex + delta), this.marketplacePageCount - 1);
    this.expandedPostId = null;
    this.expandedOffers = [];
    this.expandedOfferId = null;
  }

  private computeFilteredMarketplace(): any[] {
    const q = (this.marketplaceFilter || '').toLowerCase().trim();
    const email = (this.emailFilter || '').toLowerCase().trim();
    const from = this.dateFrom ? new Date(this.dateFrom).getTime() : null;
    const to = this.dateTo ? new Date(this.dateTo + 'T23:59:59').getTime() : null;

    const rows = this.marketplaceRowData.filter(r => {
      if (q && !(
        (r.author || '').toLowerCase().includes(q) ||
        (r.corridor || '').toLowerCase().includes(q) ||
        r.offerEmails.some((e: string) => e.includes(q))
      )) { return false; }

      // Filtre email global : auteur du post OU l'un des offreurs.
      if (email && !(
        (r.author || '').toLowerCase().includes(email) ||
        r.offerEmails.some((e: string) => e.includes(email))
      )) { return false; }

      // Filtre date global : même tolérance que doesExternalFilterPass —
      // une ligne sans date exploitable n'est jamais exclue.
      if ((from !== null || to !== null) && r.createdAt != null) {
        if (from !== null && r.createdAt < from) { return false; }
        if (to !== null && r.createdAt > to) { return false; }
      }
      return true;
    });

    const s = this.marketplaceSort;
    return rows.sort((a, b) =>
      s === 'author' ? String(a.author).localeCompare(String(b.author))
        : s === 'accepted' ? (b.acceptedCount - a.acceptedCount)
          : (b.offersCount - a.offersCount));
  }

  private loadMarketplace() {
    this.postsSubscription = this.data.getAllPosts().subscribe(res => {
      this.allPosts = res.map((e: any) => {
        const d = e.payload.doc.data(); d.id = e.payload.doc.id; return d;
      });
      this.recomputeMarketplace();
    }, err => console.log('Error fetching posts', err));

    this.propositionsSubscription = this.data.getAllPropositions().subscribe(res => {
      this.allPropositions = res.map((e: any) => {
        const d = e.payload.doc.data(); d.id = e.payload.doc.id; return d;
      });
      this.recomputeMarketplace();
    }, err => console.log('Error fetching propositions', err));

    this.marketTxSubscription = this.data._getAlltransactions().subscribe(res => {
      this.marketTxs = res
        .map((e: any) => { const d = e.payload.doc.data(); d.id = e.payload.doc.id; return d; })
        .filter((t: any) => t.isMarketPlace === true);
      this.recomputeMarketplace();
    }, err => console.log('Error fetching marketplace transactions', err));
  }

  /**
   * Agrégation par post. Tout passe par des index construits UNE fois :
   * l'ancienne version refiltrait toutes les offres et toutes les transactions
   * pour chaque post — O(posts × offres × transactions) — ce qui gelait la page
   * dès quelques centaines de posts. Ici on est en O(posts + offres + transactions).
   * Seuls des agrégats légers sont produits ; le détail est construit à l'ouverture.
   */
  private recomputeMarketplace() {
    this.offersByPost = new Map<string, any[]>();
    this.allPropositions.forEach(o => {
      const k = o.idOfPost || '';
      const list = this.offersByPost.get(k);
      if (list) { list.push(o); } else { this.offersByPost.set(k, [o]); }
    });

    const txByPost = new Map<string, any[]>();
    this.txByProposition = new Map<string, any[]>();
    this.marketTxs.forEach(t => {
      const pk = t.postId || '';
      const pl = txByPost.get(pk);
      if (pl) { pl.push(t); } else { txByPost.set(pk, [t]); }
      const ok = t.propositionId || '';
      const ol = this.txByProposition.get(ok);
      if (ol) { ol.push(t); } else { this.txByProposition.set(ok, [t]); }
    });

    const totals: { [ccy: string]: number } = {};
    this.marketplaceRowData = (this.allPosts || []).map(p => {
      const offers = this.offersByPost.get(p.id) || [];
      const txs = txByPost.get(p.id) || [];

      const fees: { [ccy: string]: number } = {};
      txs.forEach(t => {
        const amt = Number(t.feeAmount) || 0;
        if (amt <= 0) { return; }
        const ccy = this.currencyOf(t.amountSend) || '?';
        fees[ccy] = (fees[ccy] || 0) + amt;
        totals[ccy] = (totals[ccy] || 0) + amt;
      });

      return {
        id: p.id,
        author: p.userEmail || '',
        corridor: `${this.countryFromFlag(p.senderFlag)} → ${this.countryFromFlag(p.receiverFlag)}`,
        amount: p.message || '',
        rate: this.rateLabel(p.rate),
        lifecycle: p.lifecycle || '',
        createdAt: this.postDate(p),
        offersCount: offers.length,
        acceptedCount: offers.filter(o => o.idPostTransaction && o.idPostTransaction !== '').length,
        benefit: this.formatMoneyMap(fees),
        // Emails des offreurs : sert au filtre sans matérialiser le détail.
        offerEmails: offers.map(o => (o.propositionEmail || '').toLowerCase()),
      };
    });

    this.marketplaceTotals = this.formatMoneyMap(totals);
    this.mpVersion++; // invalide le cache de filtrage
    // Le post ouvert doit refléter les données fraîches.
    if (this.expandedPostId) {
      this.expandedOffers = this.offersForPost(this.expandedPostId);
    }
  }

  /** Date du post, tolérante au format (Timestamp Firestore, ISO, Date). */
  private postDate(p: any): number | null {
    const v = p.createdAt || p.lastActivityAt;
    if (!v) { return null; }
    if (typeof v.toDate === 'function') { return v.toDate().getTime(); }
    const t = new Date(v).getTime();
    return isNaN(t) ? null : t;
  }

  /**
   * Les offres d'un post, avec toutes leurs infos + leurs transactions.
   * Appelé UNIQUEMENT pour le post déplié (voir togglePost).
   */
  private offersForPost(postId: string): any[] {
    return (this.offersByPost.get(postId) || []).map(o => {
      const transactions = this.transactionsForOffer(o.id);
      const ownerTx = transactions.find(t => t.isOwner);
      const bidderTx = transactions.find(t => !t.isOwner);
      const accepted = !!(o.idPostTransaction && o.idPostTransaction !== '');
      const money = (t, field) => t
        ? `${(Number(t.raw[field]) || 0).toFixed(2)} ${this.currencyOf(t.raw.amountSend)}`
        : '—';
      return {
        id: o.id,
        // displayName est vide sur les documents anciens → repli sur l'email.
        name: o.displayName || o.propositionEmail || '',
        email: o.propositionEmail || '',
        phone: this.userMobileByEmail.get((o.propositionEmail || '').toLowerCase().trim()) || '',
        amount: o.amount,
        offered: o.amountSend || '',
        received: o.amountReceived || '',
        accepted,
        state: accepted ? 'Acceptée'
             : o.lifecycle === 'withdrawn' ? 'Retirée'
             : o.lifecycle === 'cancelled' ? 'Annulée' : 'En attente',
        progress: o.progressBarStatus || '',
        ownerTxId: o.idPostTransaction || '',
        bidderTxId: o.idPropositionTransaction || '',
        ownerFee: money(ownerTx, 'feeAmount'),
        bidderFee: money(bidderTx, 'feeAmount'),
        ownerDebited: money(ownerTx, 'totalDebited'),
        bidderDebited: money(bidderTx, 'totalDebited'),
        hasTx: transactions.length > 0,
        transactions,
      };
    });
  }

  /**
   * Les 2 transactions d'une offre acceptée : une pour le propriétaire du post,
   * une pour l'offreur. Valeurs lues telles quelles sur les docs allTransactions
   * (jamais recalculées) — ce sont les montants réellement encaissés.
   */
  private transactionsForOffer(offerId: string): any[] {
    return (this.txByProposition.get(offerId) || [])
      .map(t => {
        const ccy = this.currencyOf(t.amountSend);
        const isOwner = t.isPostWoner === true;
        return {
          isOwner,
          raw: t,
          role: isOwner ? 'Propriétaire du post' : 'Offreur',
          code: t.transactionCode || t.id || '',
          user: t.userEmail || '',
          counterparty: t.counterpartyEmail || '',
          when: `${t.date || ''} ${t.time || ''}`.trim(),
          status: t.status || '',
          corridor: `${t.sendingCountry || ''} → ${t.receivingCountry || ''}`,
          method: t.receivingMethod || '',
          amountSend: t.amountSend || '',
          amountReceive: t.amountReceive || '',
          rate: t.rate || '',
          fee: `${(Number(t.feeAmount) || 0).toFixed(2)} ${ccy}`
             + (t.feePercent != null ? ` (${t.feePercent} %)` : ''),
          totalDebited: `${(Number(t.totalDebited) || 0).toFixed(2)} ${ccy}`,
          senderNumber: t.senderNumber || '',
          receiverNumber: t.receiverNumber || '',
          receiver: t.receiver || '',
          stages: this.stageList(t.stageTimestamps),
        };
      })
      // Propriétaire d'abord, offreur ensuite.
      .sort((a, b) => (a.isOwner === b.isOwner ? 0 : a.isOwner ? -1 : 1));
  }

  private stageList(stamps: any): { label: string, time: string }[] {
    if (!stamps || typeof stamps !== 'object') { return []; }
    return Object.keys(stamps).map(k => ({ label: k, time: String(stamps[k]) }));
  }

  /** "50.0 $CA" → "$CA" (la devise est le texte qui suit le nombre). */
  private currencyOf(amountStr: string): string {
    const s = (amountStr || '').trim();
    const i = s.indexOf(' ');
    return i > 0 ? s.substring(i + 1).trim() : '';
  }

  /** Agrège par devise sans jamais additionner des devises différentes. */
  private formatMoneyMap(m: { [ccy: string]: number }): string {
    const parts = Object.keys(m).filter(k => m[k] > 0).map(k => `${m[k].toFixed(2)} ${k}`);
    return parts.length ? parts.join('  +  ') : '—';
  }

  /** Chemin d'asset du drapeau → nom de pays (miroir de getCountryWithFlag côté app). */
  private countryFromFlag(flag: string): string {
    const f = flag || '';
    if (f.includes('cmr.png')) return 'Cameroun';
    if (f.includes('chn.png')) return 'Chine';
    if (f.includes('usa.png')) return 'États-Unis';
    if (f.includes('cna.png')) return 'Canada';
    if (f.includes('germ.png')) return 'Allemagne';
    if (f.includes('fr.png')) return 'France';
    if (f.includes('civ.png')) return "Côte d'Ivoire";
    if (f.includes('en.png')) return 'Angleterre';
    if (f.includes('ngr.png')) return 'Nigéria';
    return 'Sénégal';
  }

  /** { "420XAF": "1$CA" } → "420XAF = 1$CA". */
  private rateLabel(rate: any): string {
    if (!rate || typeof rate !== 'object') return '';
    const k = Object.keys(rate)[0];
    return k ? `${k} = ${rate[k]}` : '';
  }

  onMomoGridReady(params) {
    this.momoGridParams = params;
    if (!this.momoSubscription) { this.getMomoDeposits(); }
    // Wallets are needed to resolve the target wallet on approve/reject. Load
    // them if the wallets tab hasn't been opened yet (otherwise the
    // subscription is already live).
    if (!this.walletSubscription) {
      this.getWalletAccounts();
    }
  }

  /** Stable server identifiers → operator-facing French. */
  refusalLabel(category: string): string {
    const labels = {
      none: '', kyc: 'KYC non vérifié', insufficient_balance: 'Solde insuffisant',
      cap: 'Plafond dépassé', review_band: 'Revue de conformité',
      duplicate: 'Doublon', not_found: 'Introuvable', permission: 'Non autorisé',
      rate_bounds: 'Taux hors bornes', corridor_closed: 'Corridor fermé',
      maintenance: 'Maintenance', invalid_argument: 'Requête invalide',
      internal: 'Erreur interne', unknown: 'Indéterminé',
    };
    return labels[category] !== undefined ? labels[category] : (category || '');
  }

  onMoneyEventGridReady(params) {
    this.moneyEventGridParams = params;
  }

  onMoneyEventRowClicked(event) {
    this.selectedMoneyEvent = event.data;
    // Calculé UNE FOIS, ici. Une méthode de gabarit renvoyant Object.keys(...)
    // rendrait un tableau neuf à chaque cycle de détection — ce composant n'est
    // pas en OnPush — et le *ngFor reconstruirait son DOM sans fin.
    const artifacts = (event.data && event.data.artifacts) || {};
    this.selectedMoneyEventArtifacts = Object.keys(artifacts)
      .filter(k => artifacts[k])
      .map(k => ({ key: k, value: artifacts[k] }));
    this.modalRef = this.modalService.show(
      this.templateMoneyEventDetail, { class: 'modal-lg mtx-modal' });
  }

  /** The most recent events across all customers. */
  loadRecentMoneyEvents() {
    this.moneyEventSearch = '';
    this.runMoneyEventQuery(
      this.data.getRecentMoneyEvents(200),
      'Les 200 événements les plus récents.',
    );
  }

  /**
   * One box, two questions. An "@" means the operator is looking for a
   * customer; anything else is a transaction / offer code, which returns the
   * complete story of that one movement — server attempt, observed balance
   * change, and any failure the customer reported — oldest first.
   */
  searchMoneyEvents() {
    const term = (this.moneyEventSearch || '').trim();
    if (!term) { this.loadRecentMoneyEvents(); return; }
    if (term.includes('@')) {
      this.runMoneyEventQuery(
        this.data.getMoneyEventsByEmail(term, 200),
        `Événements de ${term}, du plus récent au plus ancien.`,
      );
    } else {
      this.runMoneyEventQuery(
        this.data.getMoneyEventsByCorrelation(term),
        `Historique complet de ${term}, dans l'ordre chronologique.`,
      );
    }
  }

  private runMoneyEventQuery(query: any, notice: string) {
    this.moneyEventLoading = true;
    this.selectedMoneyEvent = null;
    query.toPromise().then(snap => {
      this.moneyEventRowData = (snap && snap.docs ? snap.docs : []).map(doc => {
        const d: any = doc.data();
        return Object.assign({}, d, {
          id: doc.id,
          // createdAt is a real Timestamp (so it can drive the TTL and sort
          // reliably). Flattened to ISO here so the grid's date column and the
          // shared date filter, which both do new Date(value), work untouched.
          createdAtIso: d.createdAt && d.createdAt.toDate
            ? d.createdAt.toDate().toISOString() : '',
          legCount: Array.isArray(d.legs) ? d.legs.length : 0,
        });
      });
      this.moneyEventNotice = this.moneyEventRowData.length
        ? notice
        : 'Aucun événement pour cette recherche.';
      this.moneyEventLoading = false;
    }).catch(err => {
      this.moneyEventLoading = false;
      this.moneyEventRowData = [];
      this.moneyEventNotice = 'Lecture impossible. Vérifiez que les index sont construits.';
      console.log('money events query error:', err);
    });
  }

  onBankDepositRowClicked(event) {
    this.selectedBankDeposit = event.data as BankDeposit;
  }

  onBankDepositGridReady(params) {
    this.bankDepositGridApi = params.api;
  }

  private getBankDeposits() {
    this.bankDepositSubscription = this.data.getAllBankDeposits().subscribe(res => {
      const list: BankDeposit[] = res.map((e: any) => {
        const d = e.payload.doc.data();
        d.id = e.payload.doc.id;
        return d as BankDeposit;
      });
      this.bankDepositRowData = list;
      this.newBankDepositCount = list.filter(d => d.status === 'pending').length;
      this.recomputeDashboard();
    }, err => {
      console.log('Error fetching bank deposits', err);
    });
  }

  /** Currency of the selection, for the confirmation copy. Never guesses. */
  get selectedBankDepositLabel(): string {
    const d = this.selectedBankDeposit;
    if (!d) { return ''; }
    const amount = Number(d.amount) || 0;
    return `${amount.toLocaleString('fr-FR')} ${d.currency || ''}`.trim();
  }

  approveBankDeposit() {
    if (!this.selectedBankDeposit) { return; }
    if (this.selectedBankDeposit.status === 'approved') { return; }

    const amount = Number(this.selectedBankDeposit.amount) || 0;
    if (amount <= 0) {
      this.toast('error', 'Montant invalide sur cette déclaration', 'Validation');
      return;
    }

    // No wallet lookup here, unlike the MoMo flow. creditBankDeposit resolves
    // the wallet from the deposit's own walletId inside its transaction, so
    // resolving it again in the browser would only add a way to disagree.
    this.pendingBankCredit = {
      amount,
      currency: this.selectedBankDeposit.currency || '',
      email: this.selectedBankDeposit.walletEmail || '',
    };
    this.modalRef = this.modalService.show(this.templateBankCreditConfirm, { class: 'mtx-modal' });
  }

  confirmBankCredit() {
    if (!this.selectedBankDeposit || !this.pendingBankCredit) { return; }
    const depositId = this.selectedBankDeposit.id;
    const targetEmail = this.pendingBankCredit.email;

    // Approval and credit happen server-side, atomically. The deposit doc is
    // the unit of credit, so a double-click cannot credit twice, and the
    // amount comes from the stored row rather than from this page.
    this.spinner.show();
    this.firebase.getIdToken().then(token => {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      this.http.post('https://us-central1-dashboard-33d8e.cloudfunctions.net/creditBankDeposit',
        { depositId }, { headers }
      ).subscribe(
        (resp: any) => {
          this.spinner.hide();
          if (this.modalRef) { this.modalRef.hide(); }
          this.selectedBankDeposit = null;
          this.pendingBankCredit = null;
          if (resp && resp.success) {
            const credited = Number(resp.amount) || 0;
            const newBalance = Number(resp.newBalance);
            const currency = resp.currency || '';
            this.toast('success',
              `${credited.toLocaleString('fr-FR')} ${currency} crédités à ${targetEmail} ` +
              `(nouveau solde : ${newBalance.toLocaleString('fr-FR')} ${currency})`,
              'Early Transfer');
          } else {
            this.toast('error', (resp && resp.error) || 'Échec du crédit', 'Erreur');
          }
        },
        err => {
          this.spinner.hide();
          this.pendingBankCredit = null;
          this.toast('error', (err && err.error && err.error.error) || 'Échec du crédit', 'Erreur');
          console.log('Confirm bank credit error:', err);
        }
      );
    });
  }

  cancelBankCredit() {
    this.pendingBankCredit = null;
    if (this.modalRef) { this.modalRef.hide(); }
  }

  rejectBankDeposit() {
    if (!this.selectedBankDeposit) { return; }
    if (this.selectedBankDeposit.status === 'rejected') { return; }
    // An already-credited deposit cannot be rejected: the server refuses it, so
    // the wallet balance keeps a single source of truth. Reversing a credit is
    // a separate, deliberate act.
    if (this.selectedBankDeposit.status === 'approved') {
      this.toast('error',
        'Ce dépôt est déjà crédité et ne peut plus être rejeté. Ajustez le portefeuille depuis l\'onglet Portefeuilles si nécessaire.',
        'Validation');
      return;
    }
    this.bankRejectReason = '';
    this.modalRef = this.modalService.show(this.templateBankRejectConfirm, { class: 'mtx-modal' });
  }

  confirmBankReject() {
    if (!this.selectedBankDeposit) { return; }
    const depositId = this.selectedBankDeposit.id;
    const reason = (this.bankRejectReason || '').trim();

    this.spinner.show();
    this.firebase.getIdToken().then(token => {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      this.http.post('https://us-central1-dashboard-33d8e.cloudfunctions.net/rejectBankDeposit',
        { depositId, reason }, { headers }
      ).subscribe(
        (resp: any) => {
          this.spinner.hide();
          if (this.modalRef) { this.modalRef.hide(); }
          this.selectedBankDeposit = null;
          this.bankRejectReason = '';
          if (resp && resp.success) {
            this.toast('success', 'Dépôt rejeté', 'Early Transfer');
          } else {
            this.toast('error', (resp && resp.error) || 'Échec du rejet', 'Erreur');
          }
        },
        err => {
          this.spinner.hide();
          this.bankRejectReason = '';
          this.toast('error', (err && err.error && err.error.error) || 'Échec du rejet', 'Erreur');
          console.log('Confirm bank reject error:', err);
        }
      );
    });
  }

  cancelBankReject() {
    this.bankRejectReason = '';
    if (this.modalRef) { this.modalRef.hide(); }
  }

  onMomoRowClicked(event) {
    this.selectedMomoDeposit = event.data as MomoDeposit;
  }

  private getMomoDeposits() {
    this.momoSubscription = this.data.getAllMomoDeposits().subscribe(res => {
      const list: MomoDeposit[] = res.map((e: any) => {
        const d = e.payload.doc.data();
        d.id = e.payload.doc.id;
        return d as MomoDeposit;
      });
      this.momoRowData = list;
      this.newMomoCount = list.filter(d => d.status === 'pending').length;
      this.recomputeDashboard();
    }, err => {
      console.log('Error fetching MoMo deposits', err);
    });
  }

  // Find the wallet doc that owns this deposit. Primary key is walletId (set
  // at submission time). We fall back to (email + CM countryCode) in case the
  // wallet was re-created since the submission, and lastly to email alone if
  // the user only has one wallet at all.
  private resolveWalletForSelectedMomo(): WalletAccount | null {
    if (!this.selectedMomoDeposit) return null;
    const byId = (this.walletRowData || []).find(w => w.id === this.selectedMomoDeposit.walletId);
    if (byId) return byId;
    const email = (this.selectedMomoDeposit.walletEmail || '').toLowerCase().trim();
    if (!email) return null;
    const wallets = this.walletRowData || [];
    const sameEmail = wallets.filter(
      w => (w.usersEmail || '').toLowerCase().trim() === email
    );
    if (sameEmail.length === 0) return null;
    const cm = sameEmail.find(w => (w.countryCode || '').toUpperCase() === 'CM');
    if (cm) return cm;
    return sameEmail.length === 1 ? sameEmail[0] : null;
  }

  approveMomoDeposit() {
    if (!this.selectedMomoDeposit) return;
    if (this.selectedMomoDeposit.status === 'approved') return;

    const amount = Number(this.selectedMomoDeposit.amount) || 0;
    if (amount <= 0) {
      this.toastr.error('Invalid amount on this deposit', 'Validation', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      return;
    }

    const wallet = this.resolveWalletForSelectedMomo();
    if (!wallet) {
      this.toastr.error(
        `No wallet found for ${this.selectedMomoDeposit.walletEmail}`,
        'Validation',
        { progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true }
      );
      return;
    }

    const currentBalance = Number(wallet.amount) || 0;
    const newBalance = +(currentBalance + amount).toFixed(2);
    this.pendingMomoCredit = { wallet, amount, newBalance };
    this.modalRef = this.modalService.show(this.templateMomoCreditConfirm, { class: 'mtx-modal' });
  }

  confirmMomoCredit() {
    if (!this.selectedMomoDeposit || !this.pendingMomoCredit) return;
    const { wallet, amount } = this.pendingMomoCredit;
    const depositId = this.selectedMomoDeposit.id;
    const targetEmail = wallet.usersEmail || this.selectedMomoDeposit.walletEmail;

    // Approval + credit are done server-side atomically (creditMomoDeposit): the
    // deposit doc is the unit of credit, so a re-approval / double-click can't
    // credit twice. The amount comes from the stored deposit. The live
    // walletAccount snapshot refreshes the grid balance.
    this.spinner.show();
    this.firebase.getIdToken().then(token => {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      this.http.post('https://us-central1-dashboard-33d8e.cloudfunctions.net/creditMomoDeposit',
        { depositId }, { headers }
      ).subscribe(
        (resp: any) => {
          this.spinner.hide();
          if (this.modalRef) this.modalRef.hide();
          this.selectedMomoDeposit = null;
          this.pendingMomoCredit = null;
          if (resp && resp.success) {
            const credited = Number(resp.amount) || amount;
            const newBalance = Number(resp.newBalance);
            const currency = resp.currency || wallet.currency || 'XAF';
            this.toastr.success(
              `${credited.toLocaleString('fr-FR')} ${currency} credited to ${targetEmail} (new balance: ${newBalance.toLocaleString('fr-FR')})`,
              'Early Transfer',
              { progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 4000 }
            );
          } else {
            this.toastr.error(resp?.error || 'Failed to approve MoMo deposit', 'Error', {
              progressBar: true, toastClass: 'toast-custom',
              positionClass: 'toast-bottom-left', closeButton: true
            });
          }
        },
        err => {
          this.spinner.hide();
          this.pendingMomoCredit = null;
          this.toastr.error(err?.error?.error || 'Failed to approve MoMo deposit', 'Error', {
            progressBar: true, toastClass: 'toast-custom',
            positionClass: 'toast-bottom-left', closeButton: true
          });
          console.log('Confirm MoMo credit error:', err);
        }
      );
    });
  }

  cancelMomoCredit() {
    this.pendingMomoCredit = null;
    if (this.modalRef) this.modalRef.hide();
  }

  rejectMomoDeposit() {
    if (!this.selectedMomoDeposit) return;
    if (this.selectedMomoDeposit.status === 'rejected') return;
    this.momoRejectReason = '';
    this.modalRef = this.modalService.show(this.templateMomoRejectConfirm, { class: 'mtx-modal' });
  }

  confirmMomoReject() {
    if (!this.selectedMomoDeposit) return;
    const depositId = this.selectedMomoDeposit.id;
    const reason = (this.momoRejectReason || '').trim();

    // Rejection is done server-side atomically (reverseMomoDeposit): if the
    // deposit was previously approved the wallet is debited in the same
    // transaction; a pending deposit is simply marked rejected. Guards against
    // a double reversal (deposit already rejected).
    this.spinner.show();
    this.firebase.getIdToken().then(token => {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      this.http.post('https://us-central1-dashboard-33d8e.cloudfunctions.net/reverseMomoDeposit',
        { depositId, rejectReason: reason }, { headers }
      ).subscribe(
        (resp: any) => {
          this.spinner.hide();
          if (this.modalRef) this.modalRef.hide();
          this.selectedMomoDeposit = null;
          this.momoRejectReason = '';
          if (resp && resp.success) {
            this.toastr.success('MoMo deposit rejected', 'Early Transfer', {
              progressBar: true, toastClass: 'toast-custom',
              positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000
            });
          } else {
            this.toastr.error(resp?.error || 'Failed to reject MoMo deposit', 'Error', {
              progressBar: true, toastClass: 'toast-custom',
              positionClass: 'toast-bottom-left', closeButton: true
            });
          }
        },
        err => {
          this.spinner.hide();
          this.momoRejectReason = '';
          this.toastr.error(err?.error?.error || 'Failed to reject MoMo deposit', 'Error', {
            progressBar: true, toastClass: 'toast-custom',
            positionClass: 'toast-bottom-left', closeButton: true
          });
          console.log('Reject MoMo deposit error:', err);
        }
      );
    });
  }

  cancelMomoReject() {
    this.momoRejectReason = '';
    if (this.modalRef) this.modalRef.hide();
  }

  // ── ISSUES MANAGEMENT ──

  onIssuesGridReady(params) {
    this.issuesGridParams = params;
    if (!this.issuesSubscription) { this.getIssueReports(); }
  }

  onIssueRowClicked(event) {
    this.selectedIssue = event.data as IssueReport;
  }

  onIssueRowDoubleClicked(event) {
    this.selectedIssue = event.data as IssueReport;
    this.openIssueBodyModal(this.templateIssueBody);
  }

  openIssueBodyModal(template: TemplateRef<any>) {
    if (!this.selectedIssue) return;
    this.modalRef = this.modalService.show(template, { class: 'modal-lg mtx-modal' });
  }

  // ── MARKETPLACE POST DETAIL ─────────────────────────────────────────────

  // Opens a modal showing the Post, the accepted Proposition, and both
  // linked transactions for a marketplace transaction row.
  openPostDetailModal(transaction: any) {
    if (!transaction?.postId) return;

    this.selectedMarketplacePost = null;
    this.selectedMarketplaceProposition = null;
    this.selectedMarketplaceTransactions = { postSide: null, propositionSide: null };
    this.loadingMarketplacePost = true;

    // Open the modal immediately so the admin sees a loading state.
    this.modalRef = this.modalService.show(this.templatePostDetail, { class: 'modal-lg mtx-modal' });

    this.data.getPostById(transaction.postId).then(post => {
      this.loadingMarketplacePost = false;
      if (!post) {
        this.toastr.warning('The linked post no longer exists.', 'Post not found', {
          progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true
        });
        return;
      }
      this.selectedMarketplacePost = post;

      const propositions: any[] = Array.isArray(post.propositions) ? post.propositions : [];
      // Match the proposition that spawned this transaction. Older records
      // may have been written without `propositionId` — fall back to matching
      // by the accepted proposition's transaction ids.
      this.selectedMarketplaceProposition = propositions.find(p =>
        (transaction.propositionId && p.docId === transaction.propositionId) ||
        (p.idPostTransaction && p.idPostTransaction === transaction.id) ||
        (p.idPropositionTransaction && p.idPropositionTransaction === transaction.id)
      ) || null;

      // Locate both sides of the pair in the already-loaded transaction list
      // so the admin can see the postOwner's and the proposition owner's
      // transactions side by side without another round-trip.
      const all = this.allTransactionsList || [];
      const prop = this.selectedMarketplaceProposition;
      const postTxnId = prop?.idPostTransaction || (transaction.isPostWoner ? transaction.id : '');
      const propTxnId = prop?.idPropositionTransaction || (!transaction.isPostWoner ? transaction.id : '');

      this.selectedMarketplaceTransactions = {
        postSide: all.find(t => t.id === postTxnId) || null,
        propositionSide: all.find(t => t.id === propTxnId) || null,
      };
    }).catch(err => {
      this.loadingMarketplacePost = false;
      console.log('Failed to load linked post:', err);
      this.toastr.error('Could not load linked post.', 'Error', {
        progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true
      });
    });
  }

  getIssueReports() {
    this.issuesSubscription = this.data.getAllIssueReportEmails().subscribe(res => {
      const list: IssueReport[] = res.map((e: any) => {
        const d = e.payload.doc.data();
        d.id = e.payload.doc.id;
        return d as IssueReport;
      });
      this.issuesRowData = list;
      this.newIssuesCount = list.filter(e => e.status === 'new').length;
      this.recomputeDashboard();
    }, err => {
      console.log('Error fetching issue reports', err);
    });
  }

  markIssueResolved() {
    if (!this.selectedIssue) return;
    this.spinner.show();
    this.data.updateIssueReportStatus(this.selectedIssue.id, 'resolved').then(() => {
      this.spinner.hide();
      this.selectedIssue = null;
      this.toastr.success('Issue marked as resolved', 'Early Transfer', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000
      });
    }).catch(err => {
      this.spinner.hide();
      this.toastr.error('Failed to update issue status', 'Error', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      console.log('Mark issue resolved error:', err);
    });
  }

  markIssueIgnored() {
    if (!this.selectedIssue) return;
    this.spinner.show();
    this.data.updateIssueReportStatus(this.selectedIssue.id, 'ignored').then(() => {
      this.spinner.hide();
      this.selectedIssue = null;
      this.toastr.success('Issue marked as ignored', 'Early Transfer', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000
      });
    }).catch(err => {
      this.spinner.hide();
      this.toastr.error('Failed to update issue status', 'Error', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      console.log('Mark issue ignored error:', err);
    });
  }

  markIssueNew() {
    if (!this.selectedIssue) return;
    this.spinner.show();
    this.data.updateIssueReportStatus(this.selectedIssue.id, 'new').then(() => {
      this.spinner.hide();
      this.selectedIssue = null;
      this.toastr.success('Issue set back to new', 'Early Transfer', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000
      });
    }).catch(err => {
      this.spinner.hide();
      this.toastr.error('Failed to update issue status', 'Error', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      console.log('Mark issue new error:', err);
    });
  }

  checkIssueReportEmails() {
    this.issuesChecking = true;
    this.http.get(`https://us-central1-dashboard-33d8e.cloudfunctions.net/checkIssueReportEmails`).subscribe(
      (res: any) => {
        this.issuesChecking = false;
        const count = res?.newCount || 0;
        this.toastr.success(`Check complete. ${count} new issue(s) found.`, 'Issue Reports', {
          progressBar: true, toastClass: 'toast-custom',
          positionClass: 'toast-bottom-left', closeButton: true, timeOut: 5000
        });
      },
      err => {
        this.issuesChecking = false;
        this.toastr.error('Failed to check issue report emails. Make sure the Cloud Function is deployed.', 'Error', {
          progressBar: true, toastClass: 'toast-custom',
          positionClass: 'toast-bottom-left', closeButton: true
        });
        console.log('Check issue report emails error:', err);
      }
    );
  }

  // ── NOTIFICATIONS MANAGEMENT ──

  onNotificationGridReady(params) {
    this.notificationGridParams = params;
    if (!this.notificationSubscription) { this.getNotifications(); }
    if (!this.usersSubscription) {
      this.loadUserEmails();
    }
  }

  getNotifications() {
    this.notificationSubscription = this.data.getAllNotifications().subscribe(res => {
      const list: PushNotification[] = res.map((e: any) => {
        const d = e.payload.doc.data();
        d.id = e.payload.doc.id;
        return d as PushNotification;
      });
      this.notificationRowData = list;
      // Manquait : sans cela le compteur « Notifications en échec » restait à 0.
      this.recomputeDashboard();
    }, err => {
      console.log('Error fetching notifications', err);
    });
  }

  /**
   * Compte les échecs techniques du journal des mouvements d'argent.
   *
   * Une requête BORNÉE, déclenchée par le bouton « Charger les indicateurs » —
   * jamais depuis recomputeDashboard(), qui s'exécute neuf fois. `moneyEvents`
   * est un journal en append-only : le diffuser en continu figerait le
   * navigateur, c'est pourquoi son onglet fait déjà des lectures ponctuelles.
   *
   * Égalité simple + limite : aucun index composite requis. Au-delà de 50 on
   * affiche « 50+ », ce qui suffit à dire « allez voir ».
   */
  // Les libellés ci-dessous sont lus PAR LA GRILLE ET PAR LA MODALE. Ils vivaient
  // en ligne dans les valueFormatter ; les dupliquer garantissait la divergence.
  // Le serveur ne stocke que des identifiants stables — la traduction est ici.
  private readonly moneyActionLabels = {
    direct_transfer: 'Virement direct', marketplace_accept: 'Offre acceptée',
    interac_credit: 'Crédit Interac', interac_reverse: 'Annulation Interac',
    momo_credit: 'Crédit MoMo', momo_reverse: 'Annulation MoMo',
    balance_delta: 'Solde modifié', pay_pool_delta: 'Réserve modifiée',
    wallet_provision: 'Portefeuille créé', client_report: 'Signalement client',
  };
  private readonly moneyOutcomeLabels = {
    success: '✅ Réussi', refused: '⛔ Refusé', error: '💥 Erreur',
    held: '⏸ En revue', replayed: '↩︎ Rejeu', observed: '👁 Observé',
    unknown: '❔ Inconnu',
  };
  private readonly moneySourceLabels = {
    server: 'Serveur', trigger: 'Mouvement constaté', client: 'Client (déclaré)',
  };
  private readonly moneyTruthLabels = {
    settled: 'Réglé', not_settled: 'Non réglé', unknown: 'Indéterminé',
  };

  moneyActionLabel(v: string): string { return this.moneyActionLabels[v] || v || ''; }
  moneyOutcomeLabel(v: string): string { return this.moneyOutcomeLabels[v] || v || ''; }
  moneySourceLabel(v: string): string { return this.moneySourceLabels[v] || v || ''; }
  moneyTruthLabel(v: string): string { return this.moneyTruthLabels[v] || ''; }

  /** Couleur de l'en-tête de la modale, selon ce qui s'est passé. */
  moneyEventHeadClass(): string {
    const e = this.selectedMoneyEvent;
    if (!e) return 'mtx-modal__head--brand';
    if (e.source === 'client') return 'mtx-modal__head--violet';
    if (e.outcome === 'error' || e.outcome === 'refused') return 'mtx-modal__head--danger';
    if (e.outcome === 'success') return 'mtx-modal__head--success';
    return 'mtx-modal__head--info';
  }

  moneyEventStatusClass(): string {
    const e = this.selectedMoneyEvent;
    if (!e) return 'mtx-status--wait';
    if (e.outcome === 'success') return 'mtx-status--ok';
    if (e.outcome === 'error' || e.outcome === 'refused') return 'mtx-status--ko';
    return 'mtx-status--wait';
  }

  /** Recharge la grille sur toute l'histoire d'une transaction. */
  showMoneyEventStory(correlationId: string): void {
    if (this.modalRef) this.modalRef.hide();
    this.moneyEventSearch = correlationId;
    this.searchMoneyEvents();
  }

  refreshMoneyEventErrorCount(): void {
    this.data.countMoneyEventErrors(51).toPromise().then(snap => {
      this.moneyEventErrorCount = snap && snap.docs ? snap.docs.length : 0;
      this.recomputeDashboard();
    }).catch(err => {
      console.log('money event error count failed:', err);
    });
  }

  loadUserEmails() {
    // Idempotent: the notifications and interac tabs both need users; only
    // subscribe once.
    if (this.usersSubscription) return;
    this.usersSubscription = this.data.getAllUsers().subscribe(res => {
      this.userEmails = [];
      this.userMobileByEmail.clear();
      res.forEach((e: any) => {
        const data = e.payload.doc.data();
        const email = (data.email || '').trim();
        if (!email) return;
        this.userEmails.push(email);
        const mobile = (data.mobile || '').trim();
        if (mobile) this.userMobileByEmail.set(email.toLowerCase(), mobile);
      });
      this.userEmails.sort();
      // Users may arrive after the interac rows; re-enrich so the "User Phone"
      // column fills in and refresh the grid.
      this.enrichInteracRowsWithUserEmail();
      this.refreshInteracRows();
    }, err => {
      console.log('Error fetching user emails', err);
    });
  }

  sendNotification() {
    if (!this.notificationForm.title.trim() || !this.notificationForm.body.trim()) {
      this.toastr.error('Title and message are required', 'Validation', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      return;
    }

    if (this.notificationTargetType === 'specific' && this.selectedTargetEmails.length === 0) {
      this.toastr.error('Please select at least one target user', 'Validation', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      return;
    }

    this.notificationSending = true;
    const targetEmails = this.notificationTargetType === 'all' ? ['all'] : [...this.selectedTargetEmails];

    // Send to each selected email (or 'all' once). Use allSettled so a single
    // recipient without an FCM token (common for iOS users who haven't
    // provisioned APNS yet) doesn't abort the whole batch.
    this.firebase.getIdToken().then(token => {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const requests = targetEmails.map(email => {
      const payload = {
        title: this.notificationForm.title.trim(),
        body: this.notificationForm.body.trim(),
        targetEmail: email
      };
      return this.http.post('https://us-central1-dashboard-33d8e.cloudfunctions.net/sendNotification', payload, { headers })
        .toPromise()
        .then(res => ({ email, res }));
    });

    Promise.allSettled(requests).then(outcomes => {
      this.notificationSending = false;

      let totalSuccess = 0;
      let totalFail = 0;
      const noTokenEmails: string[] = [];
      const errorMessages: string[] = [];

      outcomes.forEach((outcome, idx) => {
        if (outcome.status === 'fulfilled') {
          const r: any = outcome.value.res;
          totalSuccess += r?.successCount || 0;
          totalFail += r?.failureCount || 0;
        } else {
          const email = targetEmails[idx];
          const reason: any = outcome.reason;
          const errMsg: string = reason?.error?.error || reason?.message || 'Unknown error';
          if (/no FCM token/i.test(errMsg)) {
            noTokenEmails.push(email);
          } else {
            errorMessages.push(`${email}: ${errMsg}`);
          }
          totalFail += 1;
        }
      });

      this.notificationForm = { title: '', body: '', targetEmail: '' };
      this.selectedTargetEmails = [];
      this.emailTypeaheadInput = '';
      this.notificationTargetType = 'all';

      const toastOpts = { progressBar: true, toastClass: 'toast-custom', positionClass: 'toast-bottom-left', closeButton: true, timeOut: 6000 };

      if (totalSuccess > 0) {
        let msg = `${totalSuccess} delivered, ${totalFail} failed.`;
        if (noTokenEmails.length) {
          msg += ` ${noTokenEmails.length} user(s) not reachable (no device token yet).`;
        }
        this.toastr.success(msg, 'Notification sent', toastOpts);
      } else if (noTokenEmails.length && errorMessages.length === 0) {
        this.toastr.warning(
          `Recipient(s) not reachable: ${noTokenEmails.join(', ')}. They need to open the mobile app and allow notifications.`,
          'No device token',
          toastOpts
        );
      } else {
        const msg = errorMessages.length
          ? errorMessages.join(' | ')
          : 'Failed to send notification. Make sure the Cloud Function is deployed.';
        this.toastr.error(msg, 'Error', toastOpts);
      }

      if (errorMessages.length || noTokenEmails.length) {
        console.log('Send notification issues:', { errorMessages, noTokenEmails });
      }
    });
    });
  }

  onEmailTypeaheadSelect(match) {
    const email = match.item;
    if (email && !this.selectedTargetEmails.includes(email)) {
      this.selectedTargetEmails.push(email);
    }
    // Clear input after selection (setTimeout to let typeahead finish its cycle)
    setTimeout(() => { this.emailTypeaheadInput = ''; }, 0);
  }

  removeTargetEmail(email: string) {
    this.selectedTargetEmails = this.selectedTargetEmails.filter(e => e !== email);
  }

  // ── DEPOSIT ISSUES MANAGEMENT (Interac / Mobile Money) ──

  onDepositIssuesGridReady(params) {
    this.depositIssuesGridParams = params;
    if (!this.depositIssuesSubscription) { this.getDepositIssueReports(); }
  }

  onDepositIssueRowClicked(event) {
    this.selectedDepositIssue = event.data as DepositIssueReport;
  }

  onDepositIssueRowDoubleClicked(event) {
    this.selectedDepositIssue = event.data as DepositIssueReport;
    this.openDepositIssueBodyModal(this.templateDepositIssueBody);
  }

  openDepositIssueBodyModal(template: TemplateRef<any>) {
    if (!this.selectedDepositIssue) return;
    this.modalRef = this.modalService.show(template, { class: 'modal-lg mtx-modal' });
  }

  getDepositIssueReports() {
    this.depositIssuesSubscription = this.data.getAllDepositIssueReports().subscribe(res => {
      const list: DepositIssueReport[] = res.map((e: any) => {
        const d = e.payload.doc.data();
        d.id = e.payload.doc.id;
        return d as DepositIssueReport;
      });
      this.depositIssuesRowData = list;
      this.newDepositIssuesCount = list.filter(e => e.status === 'new').length;
      this.recomputeDashboard();
      this.applyDepositIssuesGrid();
    }, err => {
      console.log('Error fetching deposit issue reports', err);
    });
  }

  // Recalcule la liste visible. C'est elle qui est bindée à la grille via
  // [rowData] : le filtre de type survit donc à la destruction/recréation
  // de la grille par le *ngIf de l'onglet.
  private applyDepositIssuesGrid() {
    this.depositIssuesVisibleRows = this.depositTypeFilter === 'all'
      ? this.depositIssuesRowData
      : this.depositIssuesRowData.filter(r => r.depositType === this.depositTypeFilter);
  }

  setDepositTypeFilter(value: 'all' | 'interac' | 'mobile_money') {
    this.depositTypeFilter = value;
    this.applyDepositIssuesGrid();
  }

  markDepositIssueResolved() {
    if (!this.selectedDepositIssue) return;
    this.spinner.show();
    this.data.updateDepositIssueReportStatus(this.selectedDepositIssue.id, 'resolved').then(() => {
      this.spinner.hide();
      this.selectedDepositIssue = null;
      this.toastr.success('Issue marked as resolved', 'Early Transfer', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000
      });
    }).catch(err => {
      this.spinner.hide();
      this.toastr.error('Failed to update issue status', 'Error', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      console.log('Mark deposit issue resolved error:', err);
    });
  }

  markDepositIssueIgnored() {
    if (!this.selectedDepositIssue) return;
    this.spinner.show();
    this.data.updateDepositIssueReportStatus(this.selectedDepositIssue.id, 'ignored').then(() => {
      this.spinner.hide();
      this.selectedDepositIssue = null;
      this.toastr.success('Issue marked as ignored', 'Early Transfer', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000
      });
    }).catch(err => {
      this.spinner.hide();
      this.toastr.error('Failed to update issue status', 'Error', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      console.log('Mark deposit issue ignored error:', err);
    });
  }

  markDepositIssueNew() {
    if (!this.selectedDepositIssue) return;
    this.spinner.show();
    this.data.updateDepositIssueReportStatus(this.selectedDepositIssue.id, 'new').then(() => {
      this.spinner.hide();
      this.selectedDepositIssue = null;
      this.toastr.success('Issue set back to new', 'Early Transfer', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000
      });
    }).catch(err => {
      this.spinner.hide();
      this.toastr.error('Failed to update issue status', 'Error', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      console.log('Mark deposit issue new error:', err);
    });
  }

  // ── FOREIGN BILL PAYMENT REQUESTS MANAGEMENT ─────────────────────────────

  onForeignBillsGridReady(params) {
    this.foreignBillsGridParams = params;
    if (!this.foreignBillsSubscription) { this.getForeignBillPaymentRequests(); }
  }

  onForeignBillRowClicked(event) {
    this.selectedForeignBill = event.data as ForeignBillPaymentRequest;
  }

  onForeignBillRowDoubleClicked(event) {
    this.selectedForeignBill = event.data as ForeignBillPaymentRequest;
    this.openForeignBillDetailModal(this.templateForeignBillDetail);
  }

  getForeignBillPaymentRequests() {
    this.foreignBillsSubscription = this.data.getAllForeignBillPaymentRequests().subscribe(res => {
      const list: ForeignBillPaymentRequest[] = res.map((e: any) => {
        const d = e.payload.doc.data();
        d.id = e.payload.doc.id;
        return d as ForeignBillPaymentRequest;
      });
      // Order: pending first, then in_progress, then paid, reimbursed, rejected.
      const statusRank: { [key: string]: number } = {
        pending: 0, in_progress: 1, paid: 2, reimbursed: 3, rejected: 4,
      };
      list.sort((a, b) => (statusRank[a.status] ?? 99) - (statusRank[b.status] ?? 99));
      this.foreignBillsRowData = list;
      this.pendingForeignBillsCount = list.filter(r => r.status === 'pending').length;
      this.recomputeDashboard();
    }, err => {
      console.log('Error fetching foreign bill payment requests', err);
    });
  }

  openForeignBillDetailModal(template: TemplateRef<any>) {
    if (!this.selectedForeignBill) return;
    // Preload the bilingual fields, falling back to the deprecated single-
    // language field so legacy records remain editable in either textarea.
    const legacy = this.selectedForeignBill.userMessage || '';
    this.foreignBillUserMessageEnDraft =
      this.selectedForeignBill.userMessageEn || legacy || '';
    this.foreignBillUserMessageFrDraft =
      this.selectedForeignBill.userMessageFr || legacy || '';
    this.modalRef = this.modalService.show(template, { class: 'modal-lg mtx-modal' });
  }

  saveForeignBillUserMessage() {
    if (!this.selectedForeignBill) return;
    const messageEn = (this.foreignBillUserMessageEnDraft || '').trim();
    const messageFr = (this.foreignBillUserMessageFrDraft || '').trim();
    if ((messageEn === '') !== (messageFr === '')) {
      this.toastr.error(
        'Please provide the message in both English and French (or clear both)',
        'Validation',
        { progressBar: true, toastClass: 'toast-custom',
          positionClass: 'toast-bottom-left', closeButton: true }
      );
      return;
    }
    this.foreignBillUserMessageSaving = true;
    this.spinner.show();
    this.data.setForeignBillUserMessage(this.selectedForeignBill.id, messageEn, messageFr).then(() => {
      this.spinner.hide();
      this.foreignBillUserMessageSaving = false;
      this.selectedForeignBill.userMessageEn = messageEn;
      this.selectedForeignBill.userMessageFr = messageFr;
      this.selectedForeignBill.userMessage = '';
      this.toastr.success(
        messageEn ? 'Message sent to user' : 'Message cleared',
        'Early Transfer',
        { progressBar: true, toastClass: 'toast-custom',
          positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000 }
      );
    }).catch(err => {
      this.spinner.hide();
      this.foreignBillUserMessageSaving = false;
      this.toastr.error('Failed to send message to user', 'Error', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      console.log('Save foreign bill user message error:', err);
    });
  }

  clearForeignBillUserMessageDraft() {
    this.foreignBillUserMessageEnDraft = '';
    this.foreignBillUserMessageFrDraft = '';
  }

  hasForeignBillUserMessageChanges(): boolean {
    if (!this.selectedForeignBill) return false;
    const enNow = (this.foreignBillUserMessageEnDraft || '').trim();
    const frNow = (this.foreignBillUserMessageFrDraft || '').trim();
    const enSaved = (this.selectedForeignBill.userMessageEn || '').trim();
    const frSaved = (this.selectedForeignBill.userMessageFr || '').trim();
    return enNow !== enSaved || frNow !== frSaved;
  }

  pickUpForeignBill() {
    if (!this.selectedForeignBill) return;
    this.spinner.show();
    this.data.markForeignBillPaymentInProgress(this.selectedForeignBill.id).then(() => {
      this.spinner.hide();
      this.toastr.success('Request picked up', 'Early Transfer', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000
      });
      if (this.modalRef) this.modalRef.hide();
    }).catch(err => {
      this.spinner.hide();
      this.toastr.error('Could not pick up the request', 'Error', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      console.log('Pickup foreign bill error:', err);
    });
  }

  openMarkPaidModal(template: TemplateRef<any>) {
    if (!this.selectedForeignBill) return;
    this.foreignBillPaidForm = { reference: '', proofUrl: '', note: '' };
    if (this.modalRef) this.modalRef.hide();
    this.modalRef = this.modalService.show(template, { class: 'mtx-modal' });
  }

  confirmMarkPaid() {
    if (!this.selectedForeignBill) return;
    this.spinner.show();
    this.data.markForeignBillPaymentPaid(this.selectedForeignBill.id, {
      reference: this.foreignBillPaidForm.reference.trim(),
      proofUrl: this.foreignBillPaidForm.proofUrl.trim(),
      note: this.foreignBillPaidForm.note.trim(),
    }).then(() => {
      this.spinner.hide();
      this.modalRef.hide();
      this.toastr.success('Bill marked as paid', 'Early Transfer', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000
      });
    }).catch(err => {
      this.spinner.hide();
      this.toastr.error('Failed to mark as paid', 'Error', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      console.log('Mark foreign bill paid error:', err);
    });
  }

  markForeignBillReimbursed() {
    if (!this.selectedForeignBill) return;
    this.spinner.show();
    this.data.markForeignBillPaymentReimbursed(this.selectedForeignBill.id).then(() => {
      this.spinner.hide();
      this.toastr.success('Request closed as reimbursed', 'Early Transfer', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000
      });
      if (this.modalRef) this.modalRef.hide();
    }).catch(err => {
      this.spinner.hide();
      this.toastr.error('Failed to update status', 'Error', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      console.log('Mark foreign bill reimbursed error:', err);
    });
  }

  openRejectForeignBillModal(template: TemplateRef<any>) {
    if (!this.selectedForeignBill) return;
    this.foreignBillRejectionReason = '';
    if (this.modalRef) this.modalRef.hide();
    this.modalRef = this.modalService.show(template, { class: 'mtx-modal' });
  }

  confirmRejectForeignBill() {
    if (!this.selectedForeignBill) return;
    if (!this.foreignBillRejectionReason.trim()) {
      this.toastr.error('Please provide a rejection reason', 'Validation', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      return;
    }
    this.spinner.show();
    this.data.rejectForeignBillPayment(this.selectedForeignBill.id, this.foreignBillRejectionReason.trim()).then(() => {
      this.spinner.hide();
      this.modalRef.hide();
      this.toastr.success('Request rejected', 'Early Transfer', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true, timeOut: 3000
      });
    }).catch(err => {
      this.spinner.hide();
      this.toastr.error('Failed to reject request', 'Error', {
        progressBar: true, toastClass: 'toast-custom',
        positionClass: 'toast-bottom-left', closeButton: true
      });
      console.log('Reject foreign bill error:', err);
    });
  }

  formatForeignBillType(value: string): string {
    switch (value) {
      case 'tuition': return 'Tuition fees';
      case 'subscription': return 'Subscription';
      case 'service': return 'Service fees';
      case 'other': return 'Other';
      default: return value || '-';
    }
  }

  formatReimbursementMethod(value: string): string {
    switch (value) {
      case 'mobile_money': return 'Mobile Money';
      case 'interac': return 'Interac (Canada)';
      case 'cash': return 'Cash / In person';
      default: return value || '-';
    }
  }

}
